import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d3817256"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "terms-condition-overlay" }, null, -1))
const _hoisted_2 = { class: "terms-condition-main" }
const _hoisted_3 = {
  lang: "JA",
  link: "#0563C1",
  vlink: "#954F72",
  style: {"tab-interval":"42pt"}
}
const _hoisted_4 = { class: "WordSection1" }
const _hoisted_5 = { class: "MsoTitle" }
const _hoisted_6 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.15pt"} }
const _hoisted_7 = { lang: "EN-US" }
const _hoisted_8 = { class: "MsoTitle" }
const _hoisted_9 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.15pt"} }
const _hoisted_10 = { lang: "EN-US" }
const _hoisted_11 = { class: "MsoTitle" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "ZH-TW",
  style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.15pt","mso-fareast-language":"ZH-TW"}
}, "（一般公開用）", -1))
const _hoisted_13 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.15pt","mso-fareast-language":"ZH-TW"}
}
const _hoisted_14 = {
  class: "MsoBodyText",
  align: "center",
  style: {"margin-top":"0.1pt","text-align":"center"}
}
const _hoisted_15 = {
  lang: "EN-US",
  style: {"font-size":"15pt","mso-bidi-font-size":"10.5pt","font-family":"'ＭＳ ゴシック'","mso-fareast-language":"ZH-TW"}
}
const _hoisted_16 = {
  class: "MsoNormal",
  align: "center",
  style: {"margin-top":"0mm","margin-right":"38.7pt","margin-bottom":"0.0001pt","margin-left":"28.45pt","text-align":"center"}
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "ZH-TW",
  style: {"font-size":"14pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.2pt","mso-fareast-language":"ZH-TW"}
}, "国土交通省", -1))
const _hoisted_18 = {
  lang: "EN-US",
  style: {"font-size":"14pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","mso-fareast-language":"ZH-TW"}
}
const _hoisted_19 = {
  class: "MsoBodyText",
  style: {"margin-top":"0.25pt"}
}
const _hoisted_20 = {
  lang: "EN-US",
  style: {"font-size":"7pt","mso-bidi-font-size":"10.5pt","font-family":"'ＭＳ ゴシック'","mso-fareast-language":"ZH-TW"}
}
const _hoisted_21 = {
  class: "MsoNormal",
  align: "center",
  style: {"text-align":"center"}
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"14pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }, "制定：令和７年５月", -1))
const _hoisted_23 = {
  lang: "EN-US",
  style: {"font-size":"14pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_24 = {
  class: "MsoNormal",
  align: "center",
  style: {"text-align":"center"}
}
const _hoisted_25 = { style: {"font-size":"14pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_26 = { lang: "EN-US" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-size":"14pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'Yu Gothic'","mso-font-kerning":"0pt","mso-ansi-language":"EN-US","mso-fareast-language":"JA","mso-bidi-language":"AR-SA"}
}, [
  /*#__PURE__*/_createElementVNode("br", {
    clear: "all",
    style: {"page-break-before":"always","mso-break-type":"section-break"}
  })
], -1))
const _hoisted_28 = { class: "WordSection2" }
const _hoisted_29 = {
  class: "MsoBodyText",
  style: {"margin-top":"0.55pt"}
}
const _hoisted_30 = {
  lang: "EN-US",
  style: {"font-size":"3pt","mso-bidi-font-size":"10.5pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_31 = {
  class: "MsoNormal",
  style: {"margin-top":"2.7pt","margin-right":"0mm","margin-bottom":"0.0001pt","margin-left":"5.05pt"}
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"16pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.3pt"} }, "目次", -1))
const _hoisted_33 = {
  lang: "EN-US",
  style: {"font-size":"16pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_34 = {
  class: "MsoToc1",
  style: {"tab-stops":"right dotted 521.3pt"}
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#_Toc221547741" }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.25pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "第１章")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.25pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" })
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.25pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "通則")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1 dotted"} }, "... ")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, "2")
  ])
], -1))
const _hoisted_36 = {
  lang: "EN-US",
  style: {"mso-bidi-font-size":"12pt","font-family":"'游明朝', serif","mso-ascii-theme-font":"minor-latin","mso-fareast-theme-font":"minor-fareast","mso-hansi-theme-font":"minor-latin","mso-bidi-font-family":"'Times New Roman'","mso-bidi-theme-font":"minor-bidi","mso-ligatures":"standardcontextual","mso-no-proof":"yes"}
}
const _hoisted_37 = {
  lang: "EN-US",
  style: {"font-size":"11pt","font-family":"'游明朝', serif","mso-ascii-font-family":"'ＭＳ ゴシック'","mso-fareast-font-family":"'ＭＳ ゴシック'","mso-hansi-font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_38 = {
  class: "MsoToc2",
  style: {"tab-stops":"right dotted 521.3pt"}
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#_Toc221547742" }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "第１条")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" })
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "用語定義")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1 dotted"} }, "... ")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, "2")
  ])
], -1))
const _hoisted_40 = {
  lang: "EN-US",
  style: {"mso-bidi-font-size":"12pt","font-family":"'游明朝', serif","mso-ascii-theme-font":"minor-latin","mso-fareast-theme-font":"minor-fareast","mso-hansi-theme-font":"minor-latin","mso-bidi-font-family":"'Times New Roman'","mso-bidi-theme-font":"minor-bidi","mso-ligatures":"standardcontextual","mso-no-proof":"yes"}
}
const _hoisted_41 = {
  class: "MsoToc2",
  style: {"tab-stops":"right dotted 521.3pt"}
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#_Toc221547743" }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "第２条")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" })
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "目的")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "及び")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "適用・使用言語等")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1 dotted"} }, "... ")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, "2")
  ])
], -1))
const _hoisted_43 = {
  lang: "EN-US",
  style: {"mso-bidi-font-size":"12pt","font-family":"'游明朝', serif","mso-ascii-theme-font":"minor-latin","mso-fareast-theme-font":"minor-fareast","mso-hansi-theme-font":"minor-latin","mso-bidi-font-family":"'Times New Roman'","mso-bidi-theme-font":"minor-bidi","mso-ligatures":"standardcontextual","mso-no-proof":"yes"}
}
const _hoisted_44 = {
  class: "MsoToc1",
  style: {"tab-stops":"right dotted 521.3pt"}
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#_Toc221547744" }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "第２章")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" })
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "本ビューアの利用条件")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1 dotted"} }, "... ")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, "3")
  ])
], -1))
const _hoisted_46 = {
  lang: "EN-US",
  style: {"mso-bidi-font-size":"12pt","font-family":"'游明朝', serif","mso-ascii-theme-font":"minor-latin","mso-fareast-theme-font":"minor-fareast","mso-hansi-theme-font":"minor-latin","mso-bidi-font-family":"'Times New Roman'","mso-bidi-theme-font":"minor-bidi","mso-ligatures":"standardcontextual","mso-no-proof":"yes"}
}
const _hoisted_47 = {
  class: "MsoToc2",
  style: {"tab-stops":"right dotted 521.3pt"}
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#_Toc221547745" }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "第３条")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" })
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "基本的な利用条件")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1 dotted"} }, "... ")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, "3")
  ])
], -1))
const _hoisted_49 = {
  lang: "EN-US",
  style: {"mso-bidi-font-size":"12pt","font-family":"'游明朝', serif","mso-ascii-theme-font":"minor-latin","mso-fareast-theme-font":"minor-fareast","mso-hansi-theme-font":"minor-latin","mso-bidi-font-family":"'Times New Roman'","mso-bidi-theme-font":"minor-bidi","mso-ligatures":"standardcontextual","mso-no-proof":"yes"}
}
const _hoisted_50 = {
  class: "MsoToc2",
  style: {"tab-stops":"right dotted 521.3pt"}
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#_Toc221547746" }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "第４条")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" })
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "禁止事項")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1 dotted"} }, "... ")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, "3")
  ])
], -1))
const _hoisted_52 = {
  lang: "EN-US",
  style: {"mso-bidi-font-size":"12pt","font-family":"'游明朝', serif","mso-ascii-theme-font":"minor-latin","mso-fareast-theme-font":"minor-fareast","mso-hansi-theme-font":"minor-latin","mso-bidi-font-family":"'Times New Roman'","mso-bidi-theme-font":"minor-bidi","mso-ligatures":"standardcontextual","mso-no-proof":"yes"}
}
const _hoisted_53 = {
  class: "MsoToc2",
  style: {"tab-stops":"right dotted 521.3pt"}
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#_Toc221547747" }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.05pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "第５条")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.05pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" })
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.05pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "第三者の利用")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1 dotted"} }, "... ")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, "3")
  ])
], -1))
const _hoisted_55 = {
  lang: "EN-US",
  style: {"mso-bidi-font-size":"12pt","font-family":"'游明朝', serif","mso-ascii-theme-font":"minor-latin","mso-fareast-theme-font":"minor-fareast","mso-hansi-theme-font":"minor-latin","mso-bidi-font-family":"'Times New Roman'","mso-bidi-theme-font":"minor-bidi","mso-ligatures":"standardcontextual","mso-no-proof":"yes"}
}
const _hoisted_56 = {
  class: "MsoToc2",
  style: {"tab-stops":"right dotted 521.3pt"}
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#_Toc221547748" }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "第６条")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" })
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "設備等の維持、管理等")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1 dotted"} }, "... ")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, "3")
  ])
], -1))
const _hoisted_58 = {
  lang: "EN-US",
  style: {"mso-bidi-font-size":"12pt","font-family":"'游明朝', serif","mso-ascii-theme-font":"minor-latin","mso-fareast-theme-font":"minor-fareast","mso-hansi-theme-font":"minor-latin","mso-bidi-font-family":"'Times New Roman'","mso-bidi-theme-font":"minor-bidi","mso-ligatures":"standardcontextual","mso-no-proof":"yes"}
}
const _hoisted_59 = {
  class: "MsoToc2",
  style: {"tab-stops":"right dotted 521.3pt"}
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#_Toc221547749" }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.05pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "第７条")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.05pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" })
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.05pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "知的財産権")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1 dotted"} }, "... ")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, "3")
  ])
], -1))
const _hoisted_61 = {
  lang: "EN-US",
  style: {"mso-bidi-font-size":"12pt","font-family":"'游明朝', serif","mso-ascii-theme-font":"minor-latin","mso-fareast-theme-font":"minor-fareast","mso-hansi-theme-font":"minor-latin","mso-bidi-font-family":"'Times New Roman'","mso-bidi-theme-font":"minor-bidi","mso-ligatures":"standardcontextual","mso-no-proof":"yes"}
}
const _hoisted_62 = {
  class: "MsoToc2",
  style: {"tab-stops":"right dotted 521.3pt"}
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#_Toc221547750" }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "第８条")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" })
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "提供者の本ビューアへの提供条件")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1 dotted"} }, "... ")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, "4")
  ])
], -1))
const _hoisted_64 = {
  lang: "EN-US",
  style: {"mso-bidi-font-size":"12pt","font-family":"'游明朝', serif","mso-ascii-theme-font":"minor-latin","mso-fareast-theme-font":"minor-fareast","mso-hansi-theme-font":"minor-latin","mso-bidi-font-family":"'Times New Roman'","mso-bidi-theme-font":"minor-bidi","mso-ligatures":"standardcontextual","mso-no-proof":"yes"}
}
const _hoisted_65 = {
  class: "MsoToc2",
  style: {"tab-stops":"right dotted 521.3pt"}
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#_Toc221547751" }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "第９条")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" })
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "限定公開")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1 dotted"} }, "... ")
    ]),
    /*#__PURE__*/_createTextVNode(">"),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, "4"),
    /*#__PURE__*/_createTextVNode(">")
  ])
], -1))
const _hoisted_67 = {
  lang: "EN-US",
  style: {"mso-bidi-font-size":"12pt","font-family":"'游明朝', serif","mso-ascii-theme-font":"minor-latin","mso-fareast-theme-font":"minor-fareast","mso-hansi-theme-font":"minor-latin","mso-bidi-font-family":"'Times New Roman'","mso-bidi-theme-font":"minor-bidi","mso-ligatures":"standardcontextual","mso-no-proof":"yes"}
}
const _hoisted_68 = {
  class: "MsoToc2",
  style: {"tab-stops":"right dotted 521.3pt"}
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#_Toc221547752" }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.1pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "第１０条")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.1pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" })
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.1pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "秘密保持")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1 dotted"} }, "... ")
    ]),
    /*#__PURE__*/_createTextVNode(">"),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, "5"),
    /*#__PURE__*/_createTextVNode(">")
  ])
], -1))
const _hoisted_70 = {
  lang: "EN-US",
  style: {"mso-bidi-font-size":"12pt","font-family":"'游明朝', serif","mso-ascii-theme-font":"minor-latin","mso-fareast-theme-font":"minor-fareast","mso-hansi-theme-font":"minor-latin","mso-bidi-font-family":"'Times New Roman'","mso-bidi-theme-font":"minor-bidi","mso-ligatures":"standardcontextual","mso-no-proof":"yes"}
}
const _hoisted_71 = {
  class: "MsoToc1",
  style: {"tab-stops":"right dotted 521.3pt"}
}
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#_Toc221547753" }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "第３章")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" })
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "提供の中止等")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1 dotted"} }, "... ")
    ]),
    /*#__PURE__*/_createTextVNode(">"),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, "5"),
    /*#__PURE__*/_createTextVNode(">")
  ])
], -1))
const _hoisted_73 = {
  lang: "EN-US",
  style: {"mso-bidi-font-size":"12pt","font-family":"'游明朝', serif","mso-ascii-theme-font":"minor-latin","mso-fareast-theme-font":"minor-fareast","mso-hansi-theme-font":"minor-latin","mso-bidi-font-family":"'Times New Roman'","mso-bidi-theme-font":"minor-bidi","mso-ligatures":"standardcontextual","mso-no-proof":"yes"}
}
const _hoisted_74 = {
  class: "MsoToc2",
  style: {"tab-stops":"right dotted 521.3pt"}
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#_Toc221547754" }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.05pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "第１１条")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.05pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" })
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.05pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "提供の一時停止")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1 dotted"} }, "... ")
    ]),
    /*#__PURE__*/_createTextVNode(">"),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, "5"),
    /*#__PURE__*/_createTextVNode(">")
  ])
], -1))
const _hoisted_76 = {
  lang: "EN-US",
  style: {"mso-bidi-font-size":"12pt","font-family":"'游明朝', serif","mso-ascii-theme-font":"minor-latin","mso-fareast-theme-font":"minor-fareast","mso-hansi-theme-font":"minor-latin","mso-bidi-font-family":"'Times New Roman'","mso-bidi-theme-font":"minor-bidi","mso-ligatures":"standardcontextual","mso-no-proof":"yes"}
}
const _hoisted_77 = {
  class: "MsoToc2",
  style: {"tab-stops":"right dotted 521.3pt"}
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#_Toc221547755" }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.05pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "第１２条")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.05pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" })
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.05pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "提供の中止")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1 dotted"} }, "... ")
    ]),
    /*#__PURE__*/_createTextVNode(">"),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, "5"),
    /*#__PURE__*/_createTextVNode(">")
  ])
], -1))
const _hoisted_79 = {
  lang: "EN-US",
  style: {"mso-bidi-font-size":"12pt","font-family":"'游明朝', serif","mso-ascii-theme-font":"minor-latin","mso-fareast-theme-font":"minor-fareast","mso-hansi-theme-font":"minor-latin","mso-bidi-font-family":"'Times New Roman'","mso-bidi-theme-font":"minor-bidi","mso-ligatures":"standardcontextual","mso-no-proof":"yes"}
}
const _hoisted_80 = {
  class: "MsoToc1",
  style: {"tab-stops":"right dotted 521.3pt"}
}
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#_Toc221547756" }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "ZH-TW",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-fareast-language":"ZH-TW","mso-no-proof":"yes"}
    }, "第４章 免責等"),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1 dotted"} }, "... ")
    ]),
    /*#__PURE__*/_createTextVNode(">"),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, "5"),
    /*#__PURE__*/_createTextVNode(">")
  ])
], -1))
const _hoisted_82 = {
  lang: "EN-US",
  style: {"mso-bidi-font-size":"12pt","font-family":"'游明朝', serif","mso-ascii-theme-font":"minor-latin","mso-fareast-theme-font":"minor-fareast","mso-hansi-theme-font":"minor-latin","mso-bidi-font-family":"'Times New Roman'","mso-bidi-theme-font":"minor-bidi","mso-ligatures":"standardcontextual","mso-no-proof":"yes"}
}
const _hoisted_83 = {
  class: "MsoToc2",
  style: {"tab-stops":"right dotted 521.3pt"}
}
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#_Toc221547757" }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "ZH-TW",
      style: {"font-family":"'ＭＳ ゴシック'","mso-fareast-language":"ZH-TW","mso-no-proof":"yes"}
    }, "第１３条 非保証、免責"),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1 dotted"} }, "... ")
    ]),
    /*#__PURE__*/_createTextVNode(">"),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, "5"),
    /*#__PURE__*/_createTextVNode(">")
  ])
], -1))
const _hoisted_85 = {
  lang: "EN-US",
  style: {"mso-bidi-font-size":"12pt","font-family":"'游明朝', serif","mso-ascii-theme-font":"minor-latin","mso-fareast-theme-font":"minor-fareast","mso-hansi-theme-font":"minor-latin","mso-bidi-font-family":"'Times New Roman'","mso-bidi-theme-font":"minor-bidi","mso-ligatures":"standardcontextual","mso-no-proof":"yes"}
}
const _hoisted_86 = {
  class: "MsoToc1",
  style: {"tab-stops":"right dotted 521.3pt"}
}
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#_Toc221547758" }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.25pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "第５章")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.25pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" })
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.25pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "雑則")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1 dotted"} }, "... ")
    ]),
    /*#__PURE__*/_createTextVNode(">"),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, "6"),
    /*#__PURE__*/_createTextVNode(">")
  ])
], -1))
const _hoisted_88 = {
  lang: "EN-US",
  style: {"mso-bidi-font-size":"12pt","font-family":"'游明朝', serif","mso-ascii-theme-font":"minor-latin","mso-fareast-theme-font":"minor-fareast","mso-hansi-theme-font":"minor-latin","mso-bidi-font-family":"'Times New Roman'","mso-bidi-theme-font":"minor-bidi","mso-ligatures":"standardcontextual","mso-no-proof":"yes"}
}
const _hoisted_89 = {
  class: "MsoToc2",
  style: {"tab-stops":"right dotted 521.3pt"}
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#_Toc221547759" }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "第１４条")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" })
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "リンクについて")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1 dotted"} }, "... ")
    ]),
    /*#__PURE__*/_createTextVNode(">"),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, "6"),
    /*#__PURE__*/_createTextVNode(">")
  ])
], -1))
const _hoisted_91 = {
  lang: "EN-US",
  style: {"mso-bidi-font-size":"12pt","font-family":"'游明朝', serif","mso-ascii-theme-font":"minor-latin","mso-fareast-theme-font":"minor-fareast","mso-hansi-theme-font":"minor-latin","mso-bidi-font-family":"'Times New Roman'","mso-bidi-theme-font":"minor-bidi","mso-ligatures":"standardcontextual","mso-no-proof":"yes"}
}
const _hoisted_92 = {
  class: "MsoToc2",
  style: {"tab-stops":"right dotted 521.3pt"}
}
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#_Toc221547760" }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "第１５条")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" })
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "ビューア管理の委託")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1 dotted"} }, "... ")
    ]),
    /*#__PURE__*/_createTextVNode(">"),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, "6"),
    /*#__PURE__*/_createTextVNode(">")
  ])
], -1))
const _hoisted_94 = {
  lang: "EN-US",
  style: {"mso-bidi-font-size":"12pt","font-family":"'游明朝', serif","mso-ascii-theme-font":"minor-latin","mso-fareast-theme-font":"minor-fareast","mso-hansi-theme-font":"minor-latin","mso-bidi-font-family":"'Times New Roman'","mso-bidi-theme-font":"minor-bidi","mso-ligatures":"standardcontextual","mso-no-proof":"yes"}
}
const _hoisted_95 = {
  class: "MsoToc2",
  style: {"tab-stops":"right dotted 521.3pt"}
}
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#_Toc221547761" }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "第１６条")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" })
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "個人情報の保護")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1 dotted"} }, "... ")
    ]),
    /*#__PURE__*/_createTextVNode(">"),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, "6"),
    /*#__PURE__*/_createTextVNode(">")
  ])
], -1))
const _hoisted_97 = {
  lang: "EN-US",
  style: {"mso-bidi-font-size":"12pt","font-family":"'游明朝', serif","mso-ascii-theme-font":"minor-latin","mso-fareast-theme-font":"minor-fareast","mso-hansi-theme-font":"minor-latin","mso-bidi-font-family":"'Times New Roman'","mso-bidi-theme-font":"minor-bidi","mso-ligatures":"standardcontextual","mso-no-proof":"yes"}
}
const _hoisted_98 = {
  class: "MsoToc2",
  style: {"tab-stops":"right dotted 521.3pt"}
}
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#_Toc221547762" }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "第１７条")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" })
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "反社会的勢力の排除")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1 dotted"} }, "... ")
    ]),
    /*#__PURE__*/_createTextVNode(">"),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, "6"),
    /*#__PURE__*/_createTextVNode(">")
  ])
], -1))
const _hoisted_100 = {
  lang: "EN-US",
  style: {"mso-bidi-font-size":"12pt","font-family":"'游明朝', serif","mso-ascii-theme-font":"minor-latin","mso-fareast-theme-font":"minor-fareast","mso-hansi-theme-font":"minor-latin","mso-bidi-font-family":"'Times New Roman'","mso-bidi-theme-font":"minor-bidi","mso-ligatures":"standardcontextual","mso-no-proof":"yes"}
}
const _hoisted_101 = {
  class: "MsoToc2",
  style: {"tab-stops":"right dotted 521.3pt"}
}
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#_Toc221547763" }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "第１８条")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" })
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "準拠法と合意管轄")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1 dotted"} }, "... ")
    ]),
    /*#__PURE__*/_createTextVNode(">"),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, "6"),
    /*#__PURE__*/_createTextVNode(">")
  ])
], -1))
const _hoisted_103 = {
  lang: "EN-US",
  style: {"mso-bidi-font-size":"12pt","font-family":"'游明朝', serif","mso-ascii-theme-font":"minor-latin","mso-fareast-theme-font":"minor-fareast","mso-hansi-theme-font":"minor-latin","mso-bidi-font-family":"'Times New Roman'","mso-bidi-theme-font":"minor-bidi","mso-ligatures":"standardcontextual","mso-no-proof":"yes"}
}
const _hoisted_104 = {
  class: "MsoToc2",
  style: {"tab-stops":"right dotted 521.3pt"}
}
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#_Toc221547764" }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.1pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "第１９条")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.1pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" })
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.1pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "本規約の変更")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1 dotted"} }, "... ")
    ]),
    /*#__PURE__*/_createTextVNode(">"),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, "7"),
    /*#__PURE__*/_createTextVNode(">")
  ])
], -1))
const _hoisted_106 = {
  lang: "EN-US",
  style: {"mso-bidi-font-size":"12pt","font-family":"'游明朝', serif","mso-ascii-theme-font":"minor-latin","mso-fareast-theme-font":"minor-fareast","mso-hansi-theme-font":"minor-latin","mso-bidi-font-family":"'Times New Roman'","mso-bidi-theme-font":"minor-bidi","mso-ligatures":"standardcontextual","mso-no-proof":"yes"}
}
const _hoisted_107 = {
  class: "MsoToc2",
  style: {"tab-stops":"right dotted 521.3pt"}
}
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#_Toc221547765" }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "第２０条")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" })
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "その他")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1 dotted"} }, "... ")
    ]),
    /*#__PURE__*/_createTextVNode(">"),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, "7"),
    /*#__PURE__*/_createTextVNode(">")
  ])
], -1))
const _hoisted_109 = {
  lang: "EN-US",
  style: {"mso-bidi-font-size":"12pt","font-family":"'游明朝', serif","mso-ascii-theme-font":"minor-latin","mso-fareast-theme-font":"minor-fareast","mso-hansi-theme-font":"minor-latin","mso-bidi-font-family":"'Times New Roman'","mso-bidi-theme-font":"minor-bidi","mso-ligatures":"standardcontextual","mso-no-proof":"yes"}
}
const _hoisted_110 = {
  class: "MsoToc1",
  style: {"tab-stops":"right dotted 521.3pt"}
}
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#_Toc221547766" }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.4pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "附則")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1 dotted"} }, "... ")
    ]),
    /*#__PURE__*/_createTextVNode(">"),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, "7"),
    /*#__PURE__*/_createTextVNode(">")
  ])
], -1))
const _hoisted_112 = {
  lang: "EN-US",
  style: {"mso-bidi-font-size":"12pt","font-family":"'游明朝', serif","mso-ascii-theme-font":"minor-latin","mso-fareast-theme-font":"minor-fareast","mso-hansi-theme-font":"minor-latin","mso-bidi-font-family":"'Times New Roman'","mso-bidi-theme-font":"minor-bidi","mso-ligatures":"standardcontextual","mso-no-proof":"yes"}
}
const _hoisted_113 = {
  class: "MsoToc2",
  style: {"tab-stops":"right dotted 521.3pt"}
}
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#_Toc221547767" }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "第１条")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" })
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "適用開始")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1 dotted"} }, "... ")
    ]),
    /*#__PURE__*/_createTextVNode(">"),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, "7"),
    /*#__PURE__*/_createTextVNode(">")
  ])
], -1))
const _hoisted_115 = {
  lang: "EN-US",
  style: {"mso-bidi-font-size":"12pt","font-family":"'游明朝', serif","mso-ascii-theme-font":"minor-latin","mso-fareast-theme-font":"minor-fareast","mso-hansi-theme-font":"minor-latin","mso-bidi-font-family":"'Times New Roman'","mso-bidi-theme-font":"minor-bidi","mso-ligatures":"standardcontextual","mso-no-proof":"yes"}
}
const _hoisted_116 = {
  class: "MsoToc1",
  style: {"tab-stops":"right dotted 521.3pt"}
}
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#_Toc221547768" }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.4pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "別紙")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1 dotted"} }, "... ")
    ]),
    /*#__PURE__*/_createTextVNode(">"),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, "8"),
    /*#__PURE__*/_createTextVNode(">")
  ])
], -1))
const _hoisted_118 = {
  lang: "EN-US",
  style: {"mso-bidi-font-size":"12pt","font-family":"'游明朝', serif","mso-ascii-theme-font":"minor-latin","mso-fareast-theme-font":"minor-fareast","mso-hansi-theme-font":"minor-latin","mso-bidi-font-family":"'Times New Roman'","mso-bidi-theme-font":"minor-bidi","mso-ligatures":"standardcontextual","mso-no-proof":"yes"}
}
const _hoisted_119 = {
  class: "MsoToc2",
  style: {"tab-stops":"right dotted 521.3pt"}
}
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#_Toc221547769" }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"} }, "○"),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "別表1")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
        /*#__PURE__*/_createTextVNode(" データ・提供者"),
        /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "の一覧、出典の記載例（第１条・第７条３項関係）")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1 dotted"} }, "... ")
    ]),
    /*#__PURE__*/_createTextVNode(">"),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, "8"),
    /*#__PURE__*/_createTextVNode(">")
  ])
], -1))
const _hoisted_121 = {
  lang: "EN-US",
  style: {"mso-bidi-font-size":"12pt","font-family":"'游明朝', serif","mso-ascii-theme-font":"minor-latin","mso-fareast-theme-font":"minor-fareast","mso-hansi-theme-font":"minor-latin","mso-bidi-font-family":"'Times New Roman'","mso-bidi-theme-font":"minor-bidi","mso-ligatures":"standardcontextual","mso-no-proof":"yes"}
}
const _hoisted_122 = {
  class: "MsoToc2",
  style: {"tab-stops":"right dotted 521.3pt"}
}
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#_Toc221547770" }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"} }, "○"),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "別表2")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" })
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "別の利用ルールの適用を明示しているコンテンツ")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "（第３条・第７条８項・第８条２項関係）")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1 dotted"} }, "... ")
    ]),
    /*#__PURE__*/_createTextVNode(">"),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, "8"),
    /*#__PURE__*/_createTextVNode(">")
  ])
], -1))
const _hoisted_124 = {
  lang: "EN-US",
  style: {"mso-bidi-font-size":"12pt","font-family":"'游明朝', serif","mso-ascii-theme-font":"minor-latin","mso-fareast-theme-font":"minor-fareast","mso-hansi-theme-font":"minor-latin","mso-bidi-font-family":"'Times New Roman'","mso-bidi-theme-font":"minor-bidi","mso-ligatures":"standardcontextual","mso-no-proof":"yes"}
}
const _hoisted_125 = {
  class: "MsoToc2",
  style: {"tab-stops":"right dotted 521.3pt"}
}
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#_Toc221547771" }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"} }, "○"),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "別表3")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" })
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "第三者に権利があることを表示・示唆している場合の例")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "（第７条５項関係）")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1 dotted"} }, "... ")
    ]),
    /*#__PURE__*/_createTextVNode(">"),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, "9"),
    /*#__PURE__*/_createTextVNode(">")
  ])
], -1))
const _hoisted_127 = {
  lang: "EN-US",
  style: {"mso-bidi-font-size":"12pt","font-family":"'游明朝', serif","mso-ascii-theme-font":"minor-latin","mso-fareast-theme-font":"minor-fareast","mso-hansi-theme-font":"minor-latin","mso-bidi-font-family":"'Times New Roman'","mso-bidi-theme-font":"minor-bidi","mso-ligatures":"standardcontextual","mso-no-proof":"yes"}
}
const _hoisted_128 = {
  class: "MsoToc2",
  style: {"tab-stops":"right dotted 521.3pt"}
}
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#_Toc221547772" }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"} }, "○"),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "別表4")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" })
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "外部データベース等とのAPI")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "連携等により取得しているコンテンツ")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-no-proof":"yes"}
    }, [
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "（第７条６項関係）")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1 dotted"} }, "... ")
    ]),
    /*#__PURE__*/_createTextVNode(">"),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"windowtext","display":"none","mso-hide":"screen","mso-no-proof":"yes","text-decoration":"none","text-underline":"none"} }, "9"),
    /*#__PURE__*/_createTextVNode(">")
  ])
], -1))
const _hoisted_130 = {
  lang: "EN-US",
  style: {"mso-bidi-font-size":"12pt","font-family":"'游明朝', serif","mso-ascii-theme-font":"minor-latin","mso-fareast-theme-font":"minor-fareast","mso-hansi-theme-font":"minor-latin","mso-bidi-font-family":"'Times New Roman'","mso-bidi-theme-font":"minor-bidi","mso-ligatures":"standardcontextual","mso-no-proof":"yes"}
}
const _hoisted_131 = { class: "MsoNormal" }
const _hoisted_132 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_133 = { class: "WordSection3" }
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-size":"16pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'Yu Gothic'","letter-spacing":"-0.25pt","mso-font-kerning":"0pt","mso-ansi-language":"EN-US","mso-fareast-language":"JA","mso-bidi-language":"AR-SA"}
}, [
  /*#__PURE__*/_createElementVNode("br", {
    clear: "all",
    style: {"mso-special-character":"line-break","page-break-before":"always"}
  })
], -1))
const _hoisted_135 = {
  class: "MsoNormal",
  style: {"mso-pagination":"widow-orphan","text-autospace":"ideograph-numeric ideograph-other"}
}
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "国土交通データプラットフォーム利用規約" }, null, -1))
const _hoisted_137 = {
  lang: "EN-US",
  style: {"font-size":"16pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.25pt"}
}
const _hoisted_138 = {
  class: "MsoNormal",
  align: "center",
  style: {"margin-top":"4.1pt","margin-right":"38.85pt","margin-bottom":"0.0001pt","margin-left":"27.85pt","text-align":"center"}
}
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"16pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.25pt"} }, "道路データプラットフォームデータビューア利用規約", -1))
const _hoisted_140 = {
  lang: "EN-US",
  style: {"font-size":"16pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_141 = {
  class: "MsoBodyText",
  style: {"margin-top":"0.4pt"}
}
const _hoisted_142 = {
  lang: "EN-US",
  style: {"font-size":"8pt","mso-bidi-font-size":"10.5pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_143 = { style: {"margin-top":"0.05pt"} }
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc221547741" }, null, -1))
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "第１章_通則" }, null, -1))
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547741"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.25pt"} }, "第１章 通則")
], -1))
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547741"} }, null, -1))
const _hoisted_148 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_149 = {
  class: "MsoBodyText",
  style: {"margin-top":"0.2pt"}
}
const _hoisted_150 = {
  lang: "EN-US",
  style: {"font-size":"7.5pt","mso-bidi-font-size":"10.5pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_151 = {
  align: "left",
  style: {"margin-top":"0.05pt","text-align":"left"}
}
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc221547742" }, null, -1))
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "第１条_用語定義" }, null, -1))
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547742"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt"} }, "第１条 用語定義")
], -1))
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547742"} }, null, -1))
const _hoisted_156 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_157 = {
  class: "MsoBodyText",
  style: {"margin-top":"7.85pt","margin-right":"15.95pt","margin-bottom":"0.0001pt","margin-left":"42.55pt","line-height":"90%"}
}
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"} }, "この道路データプラットフォームデータビューア利用規約（", -1))
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.65pt"} }, "以下、「本規約」といいます", -1))
const _hoisted_160 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"} }
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "第２条_目的および適用・使用言語等" }, null, -1))
const _hoisted_162 = { lang: "EN-US" }
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, null, -1))
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, null, -1))
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, null, -1))
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, null, -1))
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, null, -1))
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, null, -1))
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, null, -1))
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, null, -1))
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, null, -1))
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, null, -1))
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, null, -1))
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, null, -1))
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, null, -1))
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, null, -1))
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, null, -1))
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, null, -1))
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, null, -1))
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, null, -1))
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, null, -1))
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, null, -1))
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, null, -1))
const _hoisted_184 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, null, -1))
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, null, -1))
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, null, -1))
const _hoisted_187 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, null, -1))
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, null, -1))
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, null, -1))
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, null, -1))
const _hoisted_191 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, null, -1))
const _hoisted_192 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, null, -1))
const _hoisted_193 = {
  class: "TableNormal",
  border: "1",
  cellspacing: "0",
  cellpadding: "0",
  align: "left",
  width: "96%",
  style: {"width":"96.88%","border-collapse":"collapse","border":"none","mso-border-alt":"solid black 0.5pt","mso-yfti-tbllook":"480","mso-table-lspace":"7.1pt","margin-left":"5.6pt","mso-table-rspace":"7.1pt","margin-right":"5.6pt","mso-table-anchor-vertical":"paragraph","mso-table-anchor-horizontal":"margin","mso-table-left":"21pt","mso-table-top":"4.8pt","mso-padding-alt":"0mm 0mm 0mm 0mm","mso-border-insideh":"0.5pt solid black","mso-border-insidev":"0.5pt solid black"}
}
const _hoisted_194 = { style: {"mso-yfti-irow":"0","mso-yfti-firstrow":"yes","height":"17.95pt"} }
const _hoisted_195 = {
  width: "36%",
  valign: "top",
  style: {"width":"36.04%","border":"solid black 1pt","mso-border-alt":"solid black 0.5pt","background":"#bebebe","padding":"0mm 0mm 0mm 0mm","height":"17.95pt"}
}
const _hoisted_196 = {
  class: "TableParagraph",
  align: "center",
  style: {"margin-top":"0mm","margin-right":"37.8pt","margin-bottom":"0.0001pt","margin-left":"38.3pt","text-align":"center","line-height":"17pt","mso-line-height-rule":"exactly","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_197 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Hlk153804984" }, [
  /*#__PURE__*/_createElementVNode("span", {
    lang: "EN-US",
    style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.25pt","mso-fareast-language":"EN-US"}
  }, "用語")
], -1))
const _hoisted_198 = { style: {"mso-bookmark":"_Hlk153804984"} }
const _hoisted_199 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","mso-fareast-language":"EN-US"}
}
const _hoisted_200 = {
  width: "63%",
  valign: "top",
  style: {"width":"63.96%","border":"solid black 1pt","border-left":"none","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","background":"#bebebe","padding":"0mm 0mm 0mm 0mm","height":"17.95pt"}
}
const _hoisted_201 = {
  class: "TableParagraph",
  align: "center",
  style: {"margin-top":"0mm","margin-right":"37.8pt","margin-bottom":"0.0001pt","margin-left":"38.3pt","text-align":"center","line-height":"17pt","mso-line-height-rule":"exactly","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_202 = { style: {"mso-bookmark":"_Hlk153804984"} }
const _hoisted_203 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.25pt","mso-fareast-language":"EN-US"}
}
const _hoisted_204 = { style: {"mso-yfti-irow":"1","height":"1pt"} }
const _hoisted_205 = {
  width: "36%",
  style: {"width":"36.04%","border":"solid black 1pt","border-top":"none","mso-border-top-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_206 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"4.05pt","margin-bottom":"0.0001pt","margin-left":"0mm","line-height":"90%","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_207 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","line-height":"90%","font-family":"'ＭＳ ゴシック'","letter-spacing":"0.35pt"} }, "道路データプラットフォーム")
], -1))
const _hoisted_208 = { style: {"mso-bookmark":"_Hlk153804984"} }
const _hoisted_209 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","line-height":"90%","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_210 = {
  width: "63%",
  style: {"width":"63.96%","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_211 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_212 = { style: {"mso-bookmark":"_Hlk153804984"} }
const _hoisted_213 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_214 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "DX", -1))
const _hoisted_215 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "xROAD", -1))
const _hoisted_216 = { lang: "EN-US" }
const _hoisted_217 = { style: {"mso-yfti-irow":"2","height":"1pt"} }
const _hoisted_218 = {
  width: "36%",
  style: {"width":"36.04%","border":"solid black 1pt","border-top":"none","mso-border-top-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_219 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"4.05pt","margin-bottom":"0.0001pt","margin-left":"0mm","line-height":"90%","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_220 = { style: {"mso-bookmark":"_Hlk153804984"} }
const _hoisted_221 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","line-height":"90%","font-family":"'ＭＳ ゴシック'","letter-spacing":"0.35pt"} }
const _hoisted_222 = { lang: "EN-US" }
const _hoisted_223 = {
  width: "63%",
  style: {"width":"63.96%","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_224 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_225 = { style: {"mso-bookmark":"_Hlk153804984"} }
const _hoisted_226 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_227 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "Web", -1))
const _hoisted_228 = { lang: "EN-US" }
const _hoisted_229 = { style: {"mso-yfti-irow":"3","height":"1pt"} }
const _hoisted_230 = {
  width: "36%",
  style: {"width":"36.04%","border":"solid black 1pt","border-top":"none","mso-border-top-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_231 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"4.05pt","margin-bottom":"0.0001pt","margin-left":"0mm","line-height":"90%","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_232 = { style: {"mso-bookmark":"_Hlk153804984"} }
const _hoisted_233 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","line-height":"90%","font-family":"'ＭＳ ゴシック'","letter-spacing":"0.35pt"} }
const _hoisted_234 = { lang: "EN-US" }
const _hoisted_235 = {
  width: "63%",
  style: {"width":"63.96%","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_236 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_237 = { style: {"mso-bookmark":"_Hlk153804984"} }
const _hoisted_238 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_239 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "Web", -1))
const _hoisted_240 = { lang: "EN-US" }
const _hoisted_241 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_242 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, [
  /*#__PURE__*/_createElementVNode("a", { name: "_Hlk153813707" })
], -1))
const _hoisted_243 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://www.xroad.mlit.go.jp/" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153813707"} }, [
      /*#__PURE__*/_createElementVNode("span", {
        lang: "EN-US",
        style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","color":"black","mso-themecolor":"text1","letter-spacing":"0.35pt","mso-fareast-language":"EN-US"}
      }, "https://www.xroad.mlit.go.jp/")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} })
], -1))
const _hoisted_244 = { style: {"mso-bookmark":"_Hlk153804984"} }
const _hoisted_245 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","color":"black","mso-themecolor":"text1","letter-spacing":"0.35pt"}
}
const _hoisted_246 = { style: {"mso-yfti-irow":"4","height":"1pt"} }
const _hoisted_247 = {
  width: "36%",
  style: {"width":"36.04%","border":"solid black 1pt","border-top":"none","mso-border-top-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_248 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"4.05pt","margin-bottom":"0.0001pt","margin-left":"0mm","line-height":"90%","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_249 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","line-height":"90%","font-family":"'ＭＳ ゴシック'","letter-spacing":"0.35pt"} }, "本ビューア")
], -1))
const _hoisted_250 = { style: {"mso-bookmark":"_Hlk153804984"} }
const _hoisted_251 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","line-height":"90%","font-family":"'ＭＳ ゴシック'","letter-spacing":"0.35pt","mso-fareast-language":"EN-US"}
}
const _hoisted_252 = {
  width: "63%",
  style: {"width":"63.96%","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_253 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_254 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"0.35pt"} }, "道路データプラットフォームデータビューアのことをいいます。")
], -1))
const _hoisted_255 = { style: {"mso-bookmark":"_Hlk153804984"} }
const _hoisted_256 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_257 = { style: {"mso-yfti-irow":"5","height":"1pt"} }
const _hoisted_258 = {
  width: "36%",
  style: {"width":"36.04%","border":"solid black 1pt","border-top":"none","mso-border-top-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_259 = {
  class: "TableParagraph",
  style: {"margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_260 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }, "サービス")
], -1))
const _hoisted_261 = { style: {"mso-bookmark":"_Hlk153804984"} }
const _hoisted_262 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.2pt","mso-fareast-language":"EN-US"}
}
const _hoisted_263 = {
  width: "63%",
  style: {"width":"63.96%","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_264 = {
  class: "TableParagraph",
  style: {"margin-left":"1.75pt","mso-para-margin-left":"0.15gd","text-indent":"-0.1pt","mso-char-indent-count":"-0.01","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_265 = { style: {"mso-bookmark":"_Hlk153804984"} }
const _hoisted_266 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_267 = {
  lang: "EN-US",
  style: {"letter-spacing":"-0.05pt"}
}
const _hoisted_268 = { style: {"mso-yfti-irow":"6","height":"1pt"} }
const _hoisted_269 = {
  width: "36%",
  style: {"width":"36.04%","border":"solid black 1pt","border-top":"none","mso-border-top-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_270 = {
  class: "TableParagraph",
  style: {"margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_271 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.2pt"} }, "コンテンツ")
], -1))
const _hoisted_272 = { style: {"mso-bookmark":"_Hlk153804984"} }
const _hoisted_273 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.2pt","mso-fareast-language":"EN-US"}
}
const _hoisted_274 = {
  width: "63%",
  style: {"width":"63.96%","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_275 = {
  class: "TableParagraph",
  style: {"margin-left":"1.75pt","mso-para-margin-left":"0.15gd","text-indent":"-0.1pt","mso-char-indent-count":"-0.01","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_276 = { style: {"mso-bookmark":"_Hlk153804984"} }
const _hoisted_277 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_278 = {
  lang: "EN-US",
  style: {"letter-spacing":"-0.05pt"}
}
const _hoisted_279 = { style: {"mso-yfti-irow":"7","height":"1pt"} }
const _hoisted_280 = {
  width: "36%",
  style: {"width":"36.04%","border":"solid black 1pt","border-top":"none","mso-border-top-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_281 = {
  class: "TableParagraph",
  style: {"margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_282 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.2pt"} }, "データ")
], -1))
const _hoisted_283 = { style: {"mso-bookmark":"_Hlk153804984"} }
const _hoisted_284 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.2pt","mso-fareast-language":"EN-US"}
}
const _hoisted_285 = {
  width: "63%",
  style: {"width":"63.96%","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_286 = {
  class: "TableParagraph",
  style: {"margin-left":"1.75pt","mso-para-margin-left":"0.15gd","text-indent":"-0.1pt","mso-char-indent-count":"-0.01","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_287 = { style: {"mso-bookmark":"_Hlk153804984"} }
const _hoisted_288 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }
const _hoisted_289 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "1", -1))
const _hoisted_290 = { lang: "EN-US" }
const _hoisted_291 = { style: {"mso-yfti-irow":"8","height":"1pt"} }
const _hoisted_292 = {
  width: "36%",
  style: {"width":"36.04%","border":"solid black 1pt","border-top":"none","mso-border-top-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_293 = {
  class: "TableParagraph",
  style: {"margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_294 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.2pt"} }, "機能")
], -1))
const _hoisted_295 = { style: {"mso-bookmark":"_Hlk153804984"} }
const _hoisted_296 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.2pt","mso-fareast-language":"EN-US"}
}
const _hoisted_297 = {
  width: "63%",
  style: {"width":"63.96%","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_298 = {
  class: "TableParagraph",
  style: {"margin-left":"1.75pt","mso-para-margin-left":"0.15gd","text-indent":"-0.1pt","mso-char-indent-count":"-0.01","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_299 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }, "本ビューアにて利用者がデータ利用するために本ビューアが備えている機能すべてをいい、データの表示、出力等を含みます。")
], -1))
const _hoisted_300 = { style: {"mso-bookmark":"_Hlk153804984"} }
const _hoisted_301 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_302 = {
  lang: "EN-US",
  style: {"letter-spacing":"-0.05pt"}
}
const _hoisted_303 = { style: {"mso-yfti-irow":"9","height":"1pt"} }
const _hoisted_304 = {
  width: "36%",
  style: {"width":"36.04%","border":"solid black 1pt","border-top":"none","mso-border-top-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_305 = {
  class: "TableParagraph",
  style: {"margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_306 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, [
  /*#__PURE__*/_createElementVNode("span", {
    lang: "EN-US",
    style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.2pt","mso-fareast-language":"EN-US"}
  }, "管理者")
], -1))
const _hoisted_307 = { style: {"mso-bookmark":"_Hlk153804984"} }
const _hoisted_308 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","mso-fareast-language":"EN-US"}
}
const _hoisted_309 = {
  width: "63%",
  style: {"width":"63.96%","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_310 = {
  class: "TableParagraph",
  style: {"margin-left":"1.75pt","mso-para-margin-left":"0.15gd","text-indent":"-0.1pt","mso-char-indent-count":"-0.01","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_311 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }, "本ビューアを運営及び管")
], -1))
const _hoisted_312 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.15pt"} }, "理する者をいい、国土交通省のことをいいます。")
], -1))
const _hoisted_313 = { style: {"mso-bookmark":"_Hlk153804984"} }
const _hoisted_314 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_315 = { style: {"mso-yfti-irow":"10","height":"1pt"} }
const _hoisted_316 = {
  width: "36%",
  style: {"width":"36.04%","border":"solid black 1pt","border-top":"none","mso-border-top-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_317 = {
  class: "TableParagraph",
  style: {"margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_318 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }, "利用者")
], -1))
const _hoisted_319 = { style: {"mso-bookmark":"_Hlk153804984"} }
const _hoisted_320 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","mso-fareast-language":"EN-US"}
}
const _hoisted_321 = {
  width: "63%",
  style: {"width":"63.96%","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_322 = {
  class: "TableParagraph",
  style: {"margin-left":"1.75pt","mso-para-margin-left":"0.15gd","text-indent":"-0.1pt","mso-char-indent-count":"-0.01","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_323 = { style: {"mso-bookmark":"_Hlk153804984"} }
const _hoisted_324 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_325 = { lang: "EN-US" }
const _hoisted_326 = { style: {"mso-yfti-irow":"11","height":"1pt"} }
const _hoisted_327 = {
  width: "36%",
  style: {"width":"36.04%","border":"solid black 1pt","border-top":"none","mso-border-top-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_328 = {
  class: "TableParagraph",
  style: {"margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_329 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }, "提供者")
], -1))
const _hoisted_330 = { style: {"mso-bookmark":"_Hlk153804984"} }
const _hoisted_331 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.2pt","mso-fareast-language":"EN-US"}
}
const _hoisted_332 = {
  width: "63%",
  style: {"width":"63.96%","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_333 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"4.3pt","margin-bottom":"0.0001pt","margin-left":"1.75pt","mso-para-margin-top":"0mm","mso-para-margin-right":"4.3pt","mso-para-margin-bottom":"0.0001pt","mso-para-margin-left":"0.15gd","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-0.1pt","mso-char-indent-count":"-0.01","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_334 = { style: {"mso-bookmark":"_Hlk153804984"} }
const _hoisted_335 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_336 = { style: {"letter-spacing":"-0.05pt"} }
const _hoisted_337 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "1", -1))
const _hoisted_338 = { lang: "EN-US" }
const _hoisted_339 = { style: {"mso-yfti-irow":"12","height":"1pt"} }
const _hoisted_340 = {
  width: "36%",
  style: {"width":"36.04%","border":"solid black 1pt","border-top":"none","mso-border-top-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_341 = {
  class: "TableParagraph",
  style: {"margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_342 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }, "公開")
], -1))
const _hoisted_343 = { style: {"mso-bookmark":"_Hlk153804984"} }
const _hoisted_344 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","mso-fareast-language":"EN-US"}
}
const _hoisted_345 = {
  width: "63%",
  style: {"width":"63.96%","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_346 = {
  class: "TableParagraph",
  style: {"margin-left":"1.75pt","mso-para-margin-left":"0.15gd","text-indent":"-0.1pt","mso-char-indent-count":"-0.01","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_347 = { style: {"mso-bookmark":"_Hlk153804984"} }
const _hoisted_348 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_349 = { lang: "EN-US" }
const _hoisted_350 = { style: {"mso-yfti-irow":"13","height":"1pt"} }
const _hoisted_351 = {
  width: "36%",
  style: {"width":"36.04%","border":"solid black 1pt","border-top":"none","mso-border-top-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_352 = {
  class: "TableParagraph",
  style: {"margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_353 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }, "限定公開")
], -1))
const _hoisted_354 = { style: {"mso-bookmark":"_Hlk153804984"} }
const _hoisted_355 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","mso-fareast-language":"EN-US"}
}
const _hoisted_356 = {
  width: "63%",
  style: {"width":"63.96%","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_357 = {
  class: "TableParagraph",
  style: {"margin-left":"1.75pt","mso-para-margin-left":"0.15gd","text-indent":"-0.1pt","mso-char-indent-count":"-0.01","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_358 = { style: {"mso-bookmark":"_Hlk153804984"} }
const _hoisted_359 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_360 = { lang: "EN-US" }
const _hoisted_361 = { style: {"mso-yfti-irow":"14","mso-yfti-lastrow":"yes","height":"1pt"} }
const _hoisted_362 = {
  width: "36%",
  style: {"width":"36.04%","border":"solid black 1pt","border-top":"none","mso-border-top-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_363 = {
  class: "TableParagraph",
  style: {"margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_364 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }, "認証情報")
], -1))
const _hoisted_365 = { style: {"mso-bookmark":"_Hlk153804984"} }
const _hoisted_366 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","mso-fareast-language":"EN-US"}
}
const _hoisted_367 = {
  width: "63%",
  style: {"width":"63.96%","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_368 = {
  class: "TableParagraph",
  style: {"margin-left":"1.75pt","mso-para-margin-left":"0.15gd","text-indent":"-0.1pt","mso-char-indent-count":"-0.01","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_369 = { style: {"mso-bookmark":"_Hlk153804984"} }
const _hoisted_370 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_371 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "ID", -1))
const _hoisted_372 = { lang: "EN-US" }
const _hoisted_373 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153804984"} }, null, -1))
const _hoisted_374 = {
  class: "MsoBodyText",
  style: {"margin-top":"7.85pt","margin-right":"15.95pt","margin-bottom":"0.0001pt","margin-left":"0mm","line-height":"90%"}
}
const _hoisted_375 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"}
}
const _hoisted_376 = {
  class: "MsoBodyText",
  style: {"margin-top":"7.85pt","margin-right":"15.95pt","margin-bottom":"0.0001pt","margin-left":"0mm","line-height":"90%"}
}
const _hoisted_377 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"}
}
const _hoisted_378 = {
  align: "left",
  style: {"margin-top":"0.05pt","text-align":"left"}
}
const _hoisted_379 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc221547743" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt"} }, "第２条 目的及び適用・使用言語等")
], -1))
const _hoisted_380 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547743"} }, null, -1))
const _hoisted_381 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_382 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.15pt","mso-list":"l9 level1 lfo3"}
}
const _hoisted_383 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "１．_本規約は、運営管理者が提供する本サービスの利用条件について規定するものです" }, null, -1))
const _hoisted_384 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("１."),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "      ")
  ])
], -1))
const _hoisted_385 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }, "本規約は、管理者が運営する本ビューアの利用条件について規定するもので", -1))
const _hoisted_386 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.3pt"} }, "す。", -1))
const _hoisted_387 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_388 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.15pt","mso-list":"l9 level1 lfo3"}
}
const _hoisted_389 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "２．_運営管理者は、本規約に基づき、サービス利用者と契約（以下、「利用契約」とい" }, null, -1))
const _hoisted_390 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "３．_本規約、これに基づく利用契約および運営管理者による本サービスに関する説明（" }, null, -1))
const _hoisted_391 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("２."),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "      ")
  ])
], -1))
const _hoisted_392 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }, "本規約及び管理者による本ビューアに関する説明", -1))
const _hoisted_393 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.2pt"} }, "は、全て日本語によるものが正文であり、他の言語によるものは正文とはなりません。日本語に", -1))
const _hoisted_394 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.25pt"} }, "よるものの内容と他の言語によるものとの内容に相違がある場合は、日本語によ", -1))
const _hoisted_395 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.45pt"} }, "るものの内容を優先し、他の言語によるものにより日本語によるものの内容を補", -1))
const _hoisted_396 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"} }, "充または修正することはできません。", -1))
const _hoisted_397 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_398 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.15pt","mso-list":"l9 level1 lfo3"}
}
const _hoisted_399 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "４．_本規約に基づく利用契約において、年、月、日、時間等は日本の日付表記に従うも" }, null, -1))
const _hoisted_400 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("３."),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "      ")
  ])
], -1))
const _hoisted_401 = { style: {"font-family":"'ＭＳ ゴシック'"} }
const _hoisted_402 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"letter-spacing":"-0.1pt"} }, "ものとします。", -1))
const _hoisted_403 = { lang: "EN-US" }
const _hoisted_404 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.15pt","mso-list":"l9 level1 lfo3"}
}
const _hoisted_405 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "５．_本規約において、法令の名称は特に断りがない場合、日本の法令の名称を意味しま" }, null, -1))
const _hoisted_406 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.2pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("４."),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "      ")
  ])
], -1))
const _hoisted_407 = { style: {"font-family":"'ＭＳ ゴシック'"} }
const _hoisted_408 = { style: {"letter-spacing":"-0.2pt"} }
const _hoisted_409 = { lang: "EN-US" }
const _hoisted_410 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"56.05pt","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-34pt","line-height":"90%"}
}
const _hoisted_411 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_412 = {
  class: "MsoBodyText",
  style: {"margin-right":"-0.05pt","text-align":"justify","text-justify":"inter-ideograph"}
}
const _hoisted_413 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "第３条_規約の変更" }, null, -1))
const _hoisted_414 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "１．_運営管理者は、本規約を変更することがあります。" }, null, -1))
const _hoisted_415 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "２．_変更後の本規約については、運営管理者が別途定めた日（以下、「効力発生日」と" }, null, -1))
const _hoisted_416 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "３．_運営管理者は、本規約を変更する場合は、変更する３０日前までに、変更する旨、" }, null, -1))
const _hoisted_417 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "第２章_利用契約" }, null, -1))
const _hoisted_418 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}
const _hoisted_419 = { style: {"margin-top":"5.8pt","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"5.05pt"} }
const _hoisted_420 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc221547744" }, null, -1))
const _hoisted_421 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "１．_サービス利用者が本サービスを利用した場合、サービス利用者は本規約の全文を確" }, null, -1))
const _hoisted_422 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "２．_本サービスを通じて、特定データの利用、ならびにデータおよびデータの活用事例" }, null, -1))
const _hoisted_423 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "３．_本サービスを通じて、特定データの利用を希望する者、ならびにデータおよびデー" }, null, -1))
const _hoisted_424 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "第３章_本サービスの利用条件" }, null, -1))
const _hoisted_425 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547744"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.15pt"} }, "第２章 本ビューアの利用条件")
], -1))
const _hoisted_426 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547744"} }, null, -1))
const _hoisted_427 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_428 = {
  class: "MsoBodyText",
  style: {"margin-top":"0.25pt","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"0mm"}
}
const _hoisted_429 = {
  lang: "EN-US",
  style: {"font-size":"7.5pt","mso-bidi-font-size":"10.5pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_430 = {
  align: "left",
  style: {"margin-top":"0.05pt","text-align":"left"}
}
const _hoisted_431 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc221547745" }, null, -1))
const _hoisted_432 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "第８条_禁止事項" }, null, -1))
const _hoisted_433 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547745"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt"} }, "第３条 基本的な利用条件")
], -1))
const _hoisted_434 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547745"} }, null, -1))
const _hoisted_435 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_436 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.15pt","mso-list":"l3 level1 lfo28"}
}
const _hoisted_437 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("１."),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "      ")
  ])
], -1))
const _hoisted_438 = { style: {"font-family":"'ＭＳ ゴシック'"} }
const _hoisted_439 = { lang: "EN-US" }
const _hoisted_440 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.15pt","mso-list":"l3 level1 lfo28"}
}
const _hoisted_441 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("２."),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "      ")
  ])
], -1))
const _hoisted_442 = { style: {"font-family":"'ＭＳ ゴシック'"} }
const _hoisted_443 = { lang: "EN-US" }
const _hoisted_444 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.15pt","mso-list":"l3 level1 lfo28"}
}
const _hoisted_445 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("３."),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "      ")
  ])
], -1))
const _hoisted_446 = { style: {"font-family":"'ＭＳ ゴシック'"} }
const _hoisted_447 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Hlk162005522" }, "第１", -1))
const _hoisted_448 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"letter-spacing":"-0.05pt"} }, [
  /*#__PURE__*/_createTextVNode("詳しくは別表"),
  /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "2"),
  /*#__PURE__*/_createTextVNode("をご確認ください。")
], -1))
const _hoisted_449 = { lang: "EN-US" }
const _hoisted_450 = { class: "MsoBodyText" }
const _hoisted_451 = { lang: "EN-US" }
const _hoisted_452 = {
  align: "left",
  style: {"margin-right":"-0.05pt","text-align":"left"}
}
const _hoisted_453 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc221547746" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt"} }, "第４条 禁止事項")
], -1))
const _hoisted_454 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547746"} }, null, -1))
const _hoisted_455 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_456 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-indent":"-35.4pt","mso-list":"l10 level1 lfo29"}
}
const _hoisted_457 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "サービス利用者は、本サービスの利用（二次成果物の利用も含みます）に際し、次の各号" }, null, -1))
const _hoisted_458 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("１."),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "      ")
  ])
], -1))
const _hoisted_459 = { style: {"font-family":"'ＭＳ ゴシック'"} }
const _hoisted_460 = { lang: "EN-US" }
const _hoisted_461 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"78pt","text-indent":"-42.55pt"}
}
const _hoisted_462 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "（１）_本規約に違反する行為" }, null, -1))
const _hoisted_463 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"} }
const _hoisted_464 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1"} }, "  ")
], -1))
const _hoisted_465 = { lang: "EN-US" }
const _hoisted_466 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"78pt","text-indent":"-42.55pt"}
}
const _hoisted_467 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "（２）_法令に違反する行為" }, null, -1))
const _hoisted_468 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"} }
const _hoisted_469 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1"} }, "  ")
], -1))
const _hoisted_470 = { lang: "EN-US" }
const _hoisted_471 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"78pt","text-indent":"-42.55pt"}
}
const _hoisted_472 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "（３）_公序良俗に反する行為" }, null, -1))
const _hoisted_473 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"} }
const _hoisted_474 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1"} }, "  ")
], -1))
const _hoisted_475 = { lang: "EN-US" }
const _hoisted_476 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"78pt","text-indent":"-42.55pt"}
}
const _hoisted_477 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "（４）_第三者の権利を侵害する行為" }, null, -1))
const _hoisted_478 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"} }
const _hoisted_479 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1"} }, "  ")
], -1))
const _hoisted_480 = { lang: "EN-US" }
const _hoisted_481 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"78pt","text-indent":"-42.55pt"}
}
const _hoisted_482 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Hlk153376675" }, null, -1))
const _hoisted_483 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "（６）_本サービスを構成するサーバ、ネットワーク等機器に関する次の行為" }, null, -1))
const _hoisted_484 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153376675"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"} }, [
    /*#__PURE__*/_createTextVNode("（"),
    /*#__PURE__*/_createElementVNode("span", null, "５"),
    /*#__PURE__*/_createTextVNode("）"),
    /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1"} }, "  ")
    ]),
    /*#__PURE__*/_createTextVNode("本ビューアのサービスを提供するために構成されたシステム、ネットワーク等に関する次の行為")
  ])
], -1))
const _hoisted_485 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"}
}
const _hoisted_486 = {
  class: "MsoListParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"85.2pt","mso-para-margin-top":"0mm","mso-para-margin-right":"-0.05pt","mso-para-margin-bottom":"0.0001pt","mso-para-margin-left":"5.8gd","text-indent":"-21.4pt","mso-char-indent-count":"-2.07","mso-list":"l28 level1 lfo11","tab-stops":"99.25pt"}
}
const _hoisted_487 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "i．_過度な負担をかける行為" }, null, -1))
const _hoisted_488 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-size":"9.5pt","letter-spacing":"-0.05pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("i."),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "        ")
  ])
], -1))
const _hoisted_489 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.15pt"} }, "過度な負担をかける行為", -1))
const _hoisted_490 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_491 = {
  class: "MsoListParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"85.35pt","mso-para-margin-top":"0mm","mso-para-margin-right":"-0.05pt","mso-para-margin-bottom":"0.0001pt","mso-para-margin-left":"5.8gd","text-indent":"-21.55pt","mso-char-indent-count":"-2.07","mso-list":"l28 level1 lfo11","tab-stops":"62.4pt 99.25pt"}
}
const _hoisted_492 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "ii．_不正アクセス、クラッキングなど、その仕様または利用に支障を与える行為" }, null, -1))
const _hoisted_493 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-size":"9.5pt","letter-spacing":"-0.05pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("ii."),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "       ")
  ])
], -1))
const _hoisted_494 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"} }, "不正アクセス、クラッキングなど、利用に支障を与える行為", -1))
const _hoisted_495 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "iii．_解析、リバースエンジニアリングその他ソースコードを取得する行為" }, null, -1))
const _hoisted_496 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_497 = {
  class: "MsoListParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"85.2pt","mso-para-margin-top":"0mm","mso-para-margin-right":"-0.05pt","mso-para-margin-bottom":"0.0001pt","mso-para-margin-left":"5.8gd","text-indent":"-21.4pt","mso-char-indent-count":"-2.07","mso-list":"l28 level1 lfo11","tab-stops":"62.4pt 99.25pt"}
}
const _hoisted_498 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-size":"9.5pt","letter-spacing":"-0.05pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("iii."),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "      ")
  ])
], -1))
const _hoisted_499 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.15pt"} }
const _hoisted_500 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "iv．_その全部または一部を他のソフトウェアに組み込む行為" }, null, -1))
const _hoisted_501 = { lang: "EN-US" }
const _hoisted_502 = {
  class: "MsoListParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"85.2pt","mso-para-margin-top":"0mm","mso-para-margin-right":"-0.05pt","mso-para-margin-bottom":"0.0001pt","mso-para-margin-left":"5.8gd","text-indent":"-21.4pt","mso-char-indent-count":"-2.07","mso-list":"l28 level1 lfo11","tab-stops":"62.4pt 99.25pt"}
}
const _hoisted_503 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-size":"9.5pt","letter-spacing":"-0.05pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("iv."),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "      ")
  ])
], -1))
const _hoisted_504 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.15pt"} }
const _hoisted_505 = { lang: "EN-US" }
const _hoisted_506 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"78pt","text-indent":"-42.55pt"}
}
const _hoisted_507 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"} }
const _hoisted_508 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "６", -1))
const _hoisted_509 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1"} }, "  ")
], -1))
const _hoisted_510 = { lang: "EN-US" }
const _hoisted_511 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"46.25pt"}
}
const _hoisted_512 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_513 = {
  align: "left",
  style: {"margin-top":"7pt","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"13.55pt","text-align":"left"}
}
const _hoisted_514 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc221547747" }, null, -1))
const _hoisted_515 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "第９条_第三者の利用" }, null, -1))
const _hoisted_516 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547747"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.05pt"} }, "第５条 第三者の利用")
], -1))
const _hoisted_517 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547747"} }, null, -1))
const _hoisted_518 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_519 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l5 level1 lfo12"}
}
const _hoisted_520 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "サービス利用者は、本サービスの全部または一部を、有償または無償を問わず、自己以外" }, null, -1))
const _hoisted_521 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("１．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_522 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_523 = { lang: "EN-US" }
const _hoisted_524 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"56.95pt","mso-para-margin-top":"0mm","mso-para-margin-right":"-0.05pt","mso-para-margin-bottom":"0.0001pt","mso-para-margin-left":"1.94gd","text-indent":"-35.6pt","mso-char-indent-count":"-3.39"}
}
const _hoisted_525 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_526 = {
  align: "left",
  style: {"margin-top":"7.1pt","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"13.55pt","text-align":"left"}
}
const _hoisted_527 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc221547748" }, null, -1))
const _hoisted_528 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "第１０条_情報の維持、管理等" }, null, -1))
const _hoisted_529 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547748"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }, "第６条 設備等の維持、管理等")
], -1))
const _hoisted_530 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547748"} }, null, -1))
const _hoisted_531 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_532 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-34.5pt","mso-list":"l4 level1 lfo6"}
}
const _hoisted_533 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "１．_サービス利用者は、本サービスの利用にあたって、第4条2項で発行されたアカウ" }, null, -1))
const _hoisted_534 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("１．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_535 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_536 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Hlk161158444" }, "本ビューアを利用するために必要な通信費用、その他本サービスの利用に係る一切の費用は、利用者の負担とします。", -1))
const _hoisted_537 = { lang: "EN-US" }
const _hoisted_538 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"56.05pt","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-34pt"}
}
const _hoisted_539 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "２．_データ提供者は、データ提供者が本サービスに提供したデータおよびデータの活用" }, null, -1))
const _hoisted_540 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"}
}
const _hoisted_541 = { style: {"margin-top":"6.85pt","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"13.55pt"} }
const _hoisted_542 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc221547749" }, null, -1))
const _hoisted_543 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "第１１条_データ等の利用" }, null, -1))
const _hoisted_544 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "第１４条_知的財産権" }, null, -1))
const _hoisted_545 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547749"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.05pt"} }, "第７条 知的財産権")
], -1))
const _hoisted_546 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547749"} }, null, -1))
const _hoisted_547 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_548 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l27 level1 lfo10"}
}
const _hoisted_549 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Hlk161957477" }, null, -1))
const _hoisted_550 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "１．_本サービスを構成し、または、付属する有形および無形の構成物（ソフトウェア、" }, null, -1))
const _hoisted_551 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk161957477"} }, [
  /*#__PURE__*/_createElementVNode("span", {
    lang: "EN-US",
    style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
      /*#__PURE__*/_createTextVNode("１．"),
      /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
    ])
  ])
], -1))
const _hoisted_552 = { style: {"mso-bookmark":"_Hlk161957477"} }
const _hoisted_553 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_554 = { lang: "EN-US" }
const _hoisted_555 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l27 level1 lfo10"}
}
const _hoisted_556 = { style: {"mso-bookmark":"_Hlk161957477"} }
const _hoisted_557 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "２．_利用契約に基づく本サービスの使用または利用に係る許諾は、本サービスの使用ま" }, null, -1))
const _hoisted_558 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("２．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_559 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_560 = { lang: "EN-US" }
const _hoisted_561 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk161957477"} }, null, -1))
const _hoisted_562 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l27 level1 lfo10"}
}
const _hoisted_563 = { name: "_Hlk161957560" }
const _hoisted_564 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("３．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_565 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_566 = { lang: "EN-US" }
const _hoisted_567 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk161957560"} }, null, -1))
const _hoisted_568 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"63.8pt","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-10mm","mso-list":"l27 level2 lfo10"}
}
const _hoisted_569 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("(ア)"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "   ")
  ])
], -1))
const _hoisted_570 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }, "コンテンツを利用する際には、出典", -1))
const _hoisted_571 = { style: {"font-family":"'ＭＳ ゴシック'"} }
const _hoisted_572 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"letter-spacing":"-0.05pt"} }, [
  /*#__PURE__*/_createTextVNode("別表"),
  /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "1")
], -1))
const _hoisted_573 = { lang: "EN-US" }
const _hoisted_574 = {
  class: "MsoCommentText",
  style: {"margin-left":"63.8pt","mso-para-margin-left":"5.8gd"}
}
const _hoisted_575 = { style: {"font-size":"10.5pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_576 = { lang: "EN-US" }
const _hoisted_577 = {
  class: "MsoCommentText",
  style: {"margin-left":"30mm","mso-para-margin-left":"7.73gd"}
}
const _hoisted_578 = { style: {"font-size":"10.5pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_579 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1"} }, "       ")
], -1))
const _hoisted_580 = { lang: "EN-US" }
const _hoisted_581 = {
  class: "MsoCommentText",
  style: {"margin-left":"63.8pt","mso-para-margin-left":"5.8gd"}
}
const _hoisted_582 = { style: {"font-size":"10.5pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_583 = { lang: "EN-US" }
const _hoisted_584 = {
  class: "MsoCommentText",
  style: {"margin-left":"30mm","mso-para-margin-left":"7.73gd"}
}
const _hoisted_585 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","font-family":"'ＭＳ ゴシック'"} }, "出典：「○○調査」", -1))
const _hoisted_586 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"0.35pt"}
}, "(", -1))
const _hoisted_587 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"0.35pt"} }, [
  /*#__PURE__*/_createTextVNode("国土交通省"),
  /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, ")")
], -1))
const _hoisted_588 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","font-family":"'ＭＳ ゴシック'"} }, "（", -1))
const _hoisted_589 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"0.35pt"} }, "道路データプラットフォームデータビューア", -1))
const _hoisted_590 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://view.xroad.mlit.go.jp/" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "cf01" }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"Arial","color":"windowtext"} }, "https://view.xroad.mlit.go.jp/")
    ])
  ])
], -1))
const _hoisted_591 = { style: {"font-size":"10.5pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_592 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1"} }, "   ")
], -1))
const _hoisted_593 = { lang: "EN-US" }
const _hoisted_594 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"63.8pt","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-10mm","mso-list":"l27 level2 lfo10"}
}
const _hoisted_595 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("(イ)"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "   ")
  ])
], -1))
const _hoisted_596 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_597 = { lang: "EN-US" }
const _hoisted_598 = {
  class: "MsoCommentText",
  style: {"margin-left":"63.8pt","mso-para-margin-left":"5.8gd"}
}
const _hoisted_599 = { style: {"font-size":"10.5pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_600 = { lang: "EN-US" }
const _hoisted_601 = {
  class: "MsoCommentText",
  style: {"margin-left":"30mm","mso-para-margin-left":"7.09gd","text-indent":"-7.05pt"}
}
const _hoisted_602 = { style: {"font-size":"10.5pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_603 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "URL", -1))
const _hoisted_604 = { lang: "EN-US" }
const _hoisted_605 = {
  class: "MsoCommentText",
  style: {"margin-left":"30mm","mso-para-margin-left":"7.09gd","text-indent":"-7.05pt"}
}
const _hoisted_606 = { style: {"font-size":"10.5pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_607 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "URL", -1))
const _hoisted_608 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "○○", -1))
const _hoisted_609 = { lang: "EN-US" }
const _hoisted_610 = {
  class: "MsoCommentText",
  style: {"margin-left":"84pt","text-indent":"1.05pt"}
}
const _hoisted_611 = { style: {"font-size":"10.5pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_612 = { lang: "EN-US" }
const _hoisted_613 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l27 level1 lfo10"}
}
const _hoisted_614 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("４．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_615 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_616 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Hlk132126795" }, "管理者及び提供者以外の第三者が著作権その他の権利を有しているものがあります。コンテンツのうち、第三者が著作権を有しているデータや、第三者が著作権以外の権利（例：写真における肖像権、パブリシティ権等）を有しているデータについては、特に権利処理済であることが明示されているものを除き、利用者の責任で、当該第三者から利用の許諾を得てください。", -1))
const _hoisted_617 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "３．_コンテンツに関する著作権その他の一切の権利は、コンテンツの権利者に帰属しま" }, null, -1))
const _hoisted_618 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "４．_データ利用者は、前三項に定めるデータ利用者に認められた利用範囲を超えたコン" }, null, -1))
const _hoisted_619 = { style: {"mso-bookmark":"_Hlk132126795"} }
const _hoisted_620 = { lang: "EN-US" }
const _hoisted_621 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l27 level1 lfo10"}
}
const _hoisted_622 = { style: {"mso-bookmark":"_Hlk132126795"} }
const _hoisted_623 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("５．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_624 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_625 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Hlk153813528" }, [
  /*#__PURE__*/_createTextVNode("第三者に権利があることを表示・示唆している場合の例は別表"),
  /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "3"),
  /*#__PURE__*/_createTextVNode("に列挙しています。")
], -1))
const _hoisted_626 = { lang: "EN-US" }
const _hoisted_627 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l27 level1 lfo10"}
}
const _hoisted_628 = { style: {"mso-bookmark":"_Hlk132126795"} }
const _hoisted_629 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("６．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_630 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_631 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "API", -1))
const _hoisted_632 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "Application Programming Interface", -1))
const _hoisted_633 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "4", -1))
const _hoisted_634 = { lang: "EN-US" }
const _hoisted_635 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l27 level1 lfo10"}
}
const _hoisted_636 = { style: {"mso-bookmark":"_Hlk132126795"} }
const _hoisted_637 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("７．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_638 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_639 = { lang: "EN-US" }
const _hoisted_640 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l27 level1 lfo10"}
}
const _hoisted_641 = { style: {"mso-bookmark":"_Hlk132126795"} }
const _hoisted_642 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("８．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_643 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_644 = { lang: "EN-US" }
const _hoisted_645 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"64.45pt","mso-para-margin-top":"0mm","mso-para-margin-right":"-0.05pt","mso-para-margin-bottom":"0.0001pt","mso-para-margin-left":"3.87gd","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-21.9pt","mso-char-indent-count":"-2.16"}
}
const _hoisted_646 = { style: {"mso-bookmark":"_Hlk132126795"} }
const _hoisted_647 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_648 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1"} }, "  ")
], -1))
const _hoisted_649 = { lang: "EN-US" }
const _hoisted_650 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"64.45pt","mso-para-margin-top":"0mm","mso-para-margin-right":"-0.05pt","mso-para-margin-bottom":"0.0001pt","mso-para-margin-left":"3.87gd","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-21.9pt","mso-char-indent-count":"-2.16"}
}
const _hoisted_651 = { style: {"mso-bookmark":"_Hlk132126795"} }
const _hoisted_652 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_653 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1"} })
], -1))
const _hoisted_654 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "2", -1))
const _hoisted_655 = { lang: "EN-US" }
const _hoisted_656 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk132126795"} }, null, -1))
const _hoisted_657 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l27 level1 lfo10"}
}
const _hoisted_658 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("９．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_659 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_660 = { lang: "EN-US" }
const _hoisted_661 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l27 level1 lfo10"}
}
const _hoisted_662 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("１０．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "  ")
  ])
], -1))
const _hoisted_663 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_664 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Hlk161956704" }, "本条に定める利用条件が遵守されなかったことにより、利用者、提供者、", -1))
const _hoisted_665 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Hlk161956741" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk161956704"} }, "許諾者")
], -1))
const _hoisted_666 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk161956704"} }, "及びその他の第三者の相互間で生じた", -1))
const _hoisted_667 = { lang: "EN-US" }
const _hoisted_668 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"56.1pt","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-34pt"}
}
const _hoisted_669 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"}
}
const _hoisted_670 = { style: {"margin-top":"6.7pt","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"13.55pt"} }
const _hoisted_671 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc221547750" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-weight":"normal"} }, "第８条")
], -1))
const _hoisted_672 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547750"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","font-weight":"normal"} })
], -1))
const _hoisted_673 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547750"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'"} }, "提供者の本ビューアへの提供条件")
], -1))
const _hoisted_674 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "１．_データ提供者は、提供データの利用規約をデータ利用者に提示するものとします。" }, null, -1))
const _hoisted_675 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_676 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-34.5pt","mso-list":"l22 level1 lfo9"}
}
const _hoisted_677 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("１．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_678 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_679 = { lang: "EN-US" }
const _hoisted_680 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-34.5pt","mso-list":"l22 level1 lfo9"}
}
const _hoisted_681 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("２．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_682 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_683 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Hlk153483675" }, "利用ルール", -1))
const _hoisted_684 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "2", -1))
const _hoisted_685 = { lang: "EN-US" }
const _hoisted_686 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"56.1pt","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-34pt"}
}
const _hoisted_687 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_688 = { style: {"margin-top":"0.6pt","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"13.55pt"} }
const _hoisted_689 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc221547751" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'"} }, "第９条 限定公開")
], -1))
const _hoisted_690 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_691 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-34.5pt","mso-list":"l17 level1 lfo16"}
}
const _hoisted_692 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "１．_データ利用者は、コンテンツを、クリエイティブ・コモンズ表示4.0国際（CC" }, null, -1))
const _hoisted_693 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "２．_一部のコンテンツについては、関連法規や約款、規約、ライセンスその他名称の如" }, null, -1))
const _hoisted_694 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "第１２条_上位規約への同意" }, null, -1))
const _hoisted_695 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "１．_データ利用者は、コンテンツについて、上位規約等を定められている場合、コンテ" }, null, -1))
const _hoisted_696 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "２．_本規約に特別に定める場合を除き、コンテンツの利用に関し本規約と上位規約等に" }, null, -1))
const _hoisted_697 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "第１３条_データの提供" }, null, -1))
const _hoisted_698 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("１．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_699 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_700 = { lang: "EN-US" }
const _hoisted_701 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-34.5pt","mso-list":"l17 level1 lfo16"}
}
const _hoisted_702 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("２．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_703 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_704 = { lang: "EN-US" }
const _hoisted_705 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-34.5pt","mso-list":"l17 level1 lfo16"}
}
const _hoisted_706 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("３．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_707 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_708 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Hlk161113094" }, null, -1))
const _hoisted_709 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Hlk161113447" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk161113094"} }, "（限定公開の対象となるデータもしくは機能の利用を認められる者をいいます）")
], -1))
const _hoisted_710 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk161113094"} }, "は、提供者との同意に基づき管理者が指定するものとします", -1))
const _hoisted_711 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Hlk153814003" }, "指定した内容は、限定公開の対象者に別途周知します。", -1))
const _hoisted_712 = { lang: "EN-US" }
const _hoisted_713 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-34.5pt","mso-list":"l17 level1 lfo16"}
}
const _hoisted_714 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("４．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_715 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_716 = { lang: "EN-US" }
const _hoisted_717 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-34.5pt","mso-list":"l17 level1 lfo16"}
}
const _hoisted_718 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Hlk154611507" }, [
  /*#__PURE__*/_createElementVNode("span", {
    lang: "EN-US",
    style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
      /*#__PURE__*/_createTextVNode("５．"),
      /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }, "限定公開のデータ及び認証情報は、次条における秘密情報として扱います。")
], -1))
const _hoisted_719 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_720 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Hlk153831910" }, "（当該限定公開データから作成した二次著作物を含みます）", -1))
const _hoisted_721 = { lang: "EN-US" }
const _hoisted_722 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-34.5pt","mso-list":"l17 level1 lfo16"}
}
const _hoisted_723 = { name: "_Hlk161114789" }
const _hoisted_724 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("６．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_725 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_726 = { lang: "EN-US" }
const _hoisted_727 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk161114789"} }, null, -1))
const _hoisted_728 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"56.1pt","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-34pt"}
}
const _hoisted_729 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_730 = { style: {"margin-top":"6.9pt","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"13.55pt"} }
const _hoisted_731 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc221547752" }, null, -1))
const _hoisted_732 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "第１５条_秘密保持" }, null, -1))
const _hoisted_733 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547752"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.1pt"} }, "第１０条 秘密保持")
], -1))
const _hoisted_734 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547752"} }, null, -1))
const _hoisted_735 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_736 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-34.5pt","mso-list":"l21 level1 lfo17"}
}
const _hoisted_737 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "１．_「秘密情報」とは、次の各号のいずれかに該当する情報をいいます。ただし、サー" }, null, -1))
const _hoisted_738 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("１．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_739 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_740 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "（１）_本サービスの利用に際して、または、関連して、サービス利用者が知り得た運営" }, null, -1))
const _hoisted_741 = { lang: "EN-US" }
const _hoisted_742 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-34.5pt","mso-list":"l21 level1 lfo17"}
}
const _hoisted_743 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Hlk154611943" }, null, -1))
const _hoisted_744 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "（２）_本サービスに関連する一切の情報" }, null, -1))
const _hoisted_745 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "（３）_その他社会通念上合理的に秘密であるとサービス利用者に認識されるべき情報" }, null, -1))
const _hoisted_746 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "２．_前項の規定にかかわらず、次の各号のいずれかに該当する情報は、秘密情報にあた" }, null, -1))
const _hoisted_747 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk154611943"} }, [
  /*#__PURE__*/_createElementVNode("span", {
    lang: "EN-US",
    style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
      /*#__PURE__*/_createTextVNode("２．"),
      /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
    ])
  ])
], -1))
const _hoisted_748 = { style: {"mso-bookmark":"_Hlk154611943"} }
const _hoisted_749 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_750 = { lang: "EN-US" }
const _hoisted_751 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"78pt","text-indent":"-42.55pt"}
}
const _hoisted_752 = { style: {"mso-bookmark":"_Hlk154611943"} }
const _hoisted_753 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Hlk153832004" }, null, -1))
const _hoisted_754 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "（１）_開示の時点ですでにサービス利用者が保持していた情報" }, null, -1))
const _hoisted_755 = { style: {"mso-bookmark":"_Hlk153832004"} }
const _hoisted_756 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"} }
const _hoisted_757 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1"} }, "  ")
], -1))
const _hoisted_758 = { lang: "EN-US" }
const _hoisted_759 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"78pt","text-indent":"-42.55pt"}
}
const _hoisted_760 = { style: {"mso-bookmark":"_Hlk154611943"} }
const _hoisted_761 = { style: {"mso-bookmark":"_Hlk153832004"} }
const _hoisted_762 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "（２）_秘密情報によらずサービス利用者が独自に生成した情報" }, null, -1))
const _hoisted_763 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"} }
const _hoisted_764 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1"} }, "  ")
], -1))
const _hoisted_765 = { lang: "EN-US" }
const _hoisted_766 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"78pt","text-indent":"-42.55pt"}
}
const _hoisted_767 = { style: {"mso-bookmark":"_Hlk154611943"} }
const _hoisted_768 = { style: {"mso-bookmark":"_Hlk153832004"} }
const _hoisted_769 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "（３）_開示の時点で公知の情報" }, null, -1))
const _hoisted_770 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"} }
const _hoisted_771 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1"} }, "  ")
], -1))
const _hoisted_772 = { lang: "EN-US" }
const _hoisted_773 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"78pt","text-indent":"-42.55pt"}
}
const _hoisted_774 = { style: {"mso-bookmark":"_Hlk154611943"} }
const _hoisted_775 = { style: {"mso-bookmark":"_Hlk153832004"} }
const _hoisted_776 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "（４）_開示後にサービス利用者の責めに帰すべき事由によらずに公知となった情報" }, null, -1))
const _hoisted_777 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"} }
const _hoisted_778 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1"} }, "  ")
], -1))
const _hoisted_779 = { lang: "EN-US" }
const _hoisted_780 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"78pt","text-indent":"-42.55pt"}
}
const _hoisted_781 = { style: {"mso-bookmark":"_Hlk154611943"} }
const _hoisted_782 = { style: {"mso-bookmark":"_Hlk153832004"} }
const _hoisted_783 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "（５）_正当な権限を有する第三者から秘密保持義務を負うことなく開示された情報" }, null, -1))
const _hoisted_784 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"} }
const _hoisted_785 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1"} }, "  ")
], -1))
const _hoisted_786 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "３．_サービス利用者は、秘密情報の全部または一部について、秘密として管理し、運営" }, null, -1))
const _hoisted_787 = { lang: "EN-US" }
const _hoisted_788 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153832004"} }, null, -1))
const _hoisted_789 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk154611943"} }, null, -1))
const _hoisted_790 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-34.5pt","mso-list":"l21 level1 lfo17"}
}
const _hoisted_791 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("３．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_792 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_793 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Hlk161158868" }, "、提供者及び管理者", -1))
const _hoisted_794 = { lang: "EN-US" }
const _hoisted_795 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"78pt","text-indent":"-42.55pt"}
}
const _hoisted_796 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "（１）_第三者に開示または漏洩しない" }, null, -1))
const _hoisted_797 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"} }
const _hoisted_798 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1"} }, "  ")
], -1))
const _hoisted_799 = { lang: "EN-US" }
const _hoisted_800 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"78pt","text-indent":"-42.55pt"}
}
const _hoisted_801 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "（２）_利用契約上の権利の行使または義務の履行以外の目的に使用または利用しない" }, null, -1))
const _hoisted_802 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"} }
const _hoisted_803 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1"} }, "  ")
], -1))
const _hoisted_804 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "４．_本条の義務は、利用契約終了後も2年間は有効に存続します。" }, null, -1))
const _hoisted_805 = { lang: "EN-US" }
const _hoisted_806 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-34.5pt","mso-list":"l21 level1 lfo17"}
}
const _hoisted_807 = { name: "_Hlk153835306" }
const _hoisted_808 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("４．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_809 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_810 = { lang: "EN-US" }
const _hoisted_811 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153835306"} }, null, -1))
const _hoisted_812 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"21.3pt","text-align":"justify","text-justify":"inter-ideograph"}
}
const _hoisted_813 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}
const _hoisted_814 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"21.3pt","text-align":"justify","text-justify":"inter-ideograph"}
}
const _hoisted_815 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}
const _hoisted_816 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"22.1pt","tab-stops":"56.05pt"}
}
const _hoisted_817 = {
  lang: "EN-US",
  style: {"font-size":"4pt","mso-bidi-font-size":"10.5pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_818 = { style: {"margin-right":"-0.05pt"} }
const _hoisted_819 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc221547753" }, null, -1))
const _hoisted_820 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "第４章_提供の中断等" }, null, -1))
const _hoisted_821 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547753"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }, "第３章 提供の中止等")
], -1))
const _hoisted_822 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547753"} }, null, -1))
const _hoisted_823 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_824 = {
  class: "MsoBodyText",
  style: {"margin-top":"0.25pt","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"0mm"}
}
const _hoisted_825 = {
  lang: "EN-US",
  style: {"font-size":"7.5pt","mso-bidi-font-size":"10.5pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_826 = {
  align: "left",
  style: {"margin-right":"-0.05pt","text-align":"left"}
}
const _hoisted_827 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc221547754" }, null, -1))
const _hoisted_828 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "第１６条_提供の中断" }, null, -1))
const _hoisted_829 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547754"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.05pt"} }, "第１１条 提供の一時停止")
], -1))
const _hoisted_830 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547754"} }, null, -1))
const _hoisted_831 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_832 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l24 level1 lfo19"}
}
const _hoisted_833 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "１．_運営管理者は、次に掲げる事由がある場合は、本サービスの一部または全部の提供" }, null, -1))
const _hoisted_834 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("１．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_835 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_836 = { lang: "EN-US" }
const _hoisted_837 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"78pt","text-indent":"-42.55pt"}
}
const _hoisted_838 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "（１）_サーバ設備または電気通信設備等の保守、工事、移設等のため必要である場合" }, null, -1))
const _hoisted_839 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"} }, [
  /*#__PURE__*/_createTextVNode("（１）"),
  /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1"} }, "  ")
  ]),
  /*#__PURE__*/_createTextVNode("サーバ設備または電気通信設備等の保守、工事、移設等のため必要である場")
], -1))
const _hoisted_840 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.5pt"} }, "合", -1))
const _hoisted_841 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_842 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"78pt","text-indent":"-42.55pt"}
}
const _hoisted_843 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "（２）_電気通信事業者等が、電気通信サービスの提供を中断した場合" }, null, -1))
const _hoisted_844 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"} }, [
  /*#__PURE__*/_createTextVNode("（２）"),
  /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1"} }, "  ")
  ])
], -1))
const _hoisted_845 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.15pt"} }, "電気通信事業者等が、電気通信サービスの提供を中断した場合", -1))
const _hoisted_846 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_847 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"78pt","text-indent":"-42.55pt"}
}
const _hoisted_848 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "（３）_日本または日本以外の国の公権力（公的機関を含みます。以下、「公的機関等」" }, null, -1))
const _hoisted_849 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"} }, [
  /*#__PURE__*/_createTextVNode("（３）"),
  /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1"} }, "  ")
  ])
], -1))
const _hoisted_850 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.4pt"} }, "日本または日本以外の国の公権力", -1))
const _hoisted_851 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"} }, "（", -1))
const _hoisted_852 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.55pt"} }, "公的機関を含みます", -1))
const _hoisted_853 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"} }
const _hoisted_854 = { lang: "EN-US" }
const _hoisted_855 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"78pt","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-42.55pt"}
}
const _hoisted_856 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "（４）_第三者の行為（不作為を含みます）により本サービスのサーバ設備または電気通" }, null, -1))
const _hoisted_857 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"} }
const _hoisted_858 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1"} }, "  ")
], -1))
const _hoisted_859 = { lang: "EN-US" }
const _hoisted_860 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"78pt","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-42.55pt"}
}
const _hoisted_861 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"} }
const _hoisted_862 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1"} }, "  ")
], -1))
const _hoisted_863 = { lang: "EN-US" }
const _hoisted_864 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l24 level1 lfo19"}
}
const _hoisted_865 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "２．_運営管理者は、前項に基づき本サービスの提供を中断する場合には、各サービス利" }, null, -1))
const _hoisted_866 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("２．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_867 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }, "管理者は利用者に対して、前項に基づき本サービスの提供の停止または制限を、", -1))
const _hoisted_868 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.35pt"} }, "道路データプラットフォームポータルサイト", -1))
const _hoisted_869 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_870 = { lang: "EN-US" }
const _hoisted_871 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l24 level1 lfo19"}
}
const _hoisted_872 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "３．_運営管理者は、第１項に基づき本サービスの提供を中断する場合に、当該中断によ" }, null, -1))
const _hoisted_873 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("３．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_874 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_875 = { lang: "EN-US" }
const _hoisted_876 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"56.1pt","text-indent":"-34pt","tab-stops":"56.1pt"}
}
const _hoisted_877 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_878 = {
  align: "left",
  style: {"margin-top":"6.55pt","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"13.55pt","text-align":"left"}
}
const _hoisted_879 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc221547755" }, null, -1))
const _hoisted_880 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "第１７条_提供の廃止" }, null, -1))
const _hoisted_881 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547755"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.05pt"} }, "第１２条 提供の中止")
], -1))
const _hoisted_882 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547755"} }, null, -1))
const _hoisted_883 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_884 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l1 level1 lfo20"}
}
const _hoisted_885 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "１．_運営管理者は、やむを得ず本サービスの全部または一部を廃止することがあります" }, null, -1))
const _hoisted_886 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("１．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_887 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_888 = { lang: "EN-US" }
const _hoisted_889 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l1 level1 lfo20"}
}
const _hoisted_890 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "２．_運営管理者は、前項に基づき本サービスの提供を廃止する場合に、当該廃止により" }, null, -1))
const _hoisted_891 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("２．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_892 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_893 = { lang: "EN-US" }
const _hoisted_894 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l1 level1 lfo20"}
}
const _hoisted_895 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("３．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_896 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_897 = { lang: "EN-US" }
const _hoisted_898 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"56.05pt","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-34pt"}
}
const _hoisted_899 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_900 = { style: {"margin-right":"-0.05pt"} }
const _hoisted_901 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc221547756" }, null, -1))
const _hoisted_902 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "第５章_免責等" }, null, -1))
const _hoisted_903 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547756"} }, [
  /*#__PURE__*/_createElementVNode("span", {
    lang: "ZH-TW",
    style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt","mso-fareast-language":"ZH-TW"}
  }, "第４章 免責等")
], -1))
const _hoisted_904 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547756"} }, null, -1))
const _hoisted_905 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-fareast-language":"ZH-TW"}
}
const _hoisted_906 = {
  class: "MsoBodyText",
  style: {"margin-top":"0.25pt","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"0mm"}
}
const _hoisted_907 = {
  lang: "EN-US",
  style: {"font-size":"7.5pt","mso-bidi-font-size":"10.5pt","font-family":"'ＭＳ ゴシック'","mso-fareast-language":"ZH-TW"}
}
const _hoisted_908 = { style: {"margin-right":"-0.05pt"} }
const _hoisted_909 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc221547757" }, null, -1))
const _hoisted_910 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "第１８条_非保証、免責" }, null, -1))
const _hoisted_911 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547757"} }, [
  /*#__PURE__*/_createElementVNode("span", {
    lang: "ZH-TW",
    style: {"font-family":"'ＭＳ ゴシック'","mso-fareast-language":"ZH-TW"}
  }, "第１３条 非保証、免責")
], -1))
const _hoisted_912 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547757"} }, null, -1))
const _hoisted_913 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-fareast-language":"ZH-TW"}
}
const _hoisted_914 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l8 level1 lfo21"}
}
const _hoisted_915 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "１．_運営管理者は、本規約で特別に定める場合を除き、サービス利用者への本サービス" }, null, -1))
const _hoisted_916 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("１．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_917 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_918 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Hlk153835637" }, "（コンテンツを編集・加工等した情報を利用することを含みます）", -1))
const _hoisted_919 = { lang: "EN-US" }
const _hoisted_920 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l8 level1 lfo21"}
}
const _hoisted_921 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("２．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_922 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_923 = { lang: "EN-US" }
const _hoisted_924 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l8 level1 lfo21"}
}
const _hoisted_925 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("３．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_926 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_927 = { lang: "EN-US" }
const _hoisted_928 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l8 level1 lfo21"}
}
const _hoisted_929 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("４．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_930 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_931 = { lang: "EN-US" }
const _hoisted_932 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l8 level1 lfo21"}
}
const _hoisted_933 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("５．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_934 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_935 = { lang: "EN-US" }
const _hoisted_936 = {
  class: "MsoBodyText",
  style: {"margin-right":"-0.05pt"}
}
const _hoisted_937 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "２．_運営管理者は、本規約で特に定める場合を除き、サービス利用者が本サービスの利" }, null, -1))
const _hoisted_938 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "５．_サービス利用者の本サービスの利用に起因して日本または日本以外の国における第" }, null, -1))
const _hoisted_939 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "第４条_利用契約" }, null, -1))
const _hoisted_940 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_941 = {
  class: "MsoBodyText",
  style: {"margin-right":"-0.05pt"}
}
const _hoisted_942 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_943 = { style: {"margin-right":"-0.05pt"} }
const _hoisted_944 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc221547758" }, null, -1))
const _hoisted_945 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "第６章_雑則" }, null, -1))
const _hoisted_946 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547758"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.25pt"} }, "第５章 雑則")
], -1))
const _hoisted_947 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547758"} }, null, -1))
const _hoisted_948 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_949 = {
  class: "MsoBodyText",
  style: {"margin-top":"0.25pt","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"0mm"}
}
const _hoisted_950 = {
  lang: "EN-US",
  style: {"font-size":"7.5pt","mso-bidi-font-size":"10.5pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_951 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc221547759" }, null, -1))
const _hoisted_952 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "第１９条_サービス運営の委託" }, null, -1))
const _hoisted_953 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547759"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt"} }, "第１４条 リンクについて")
], -1))
const _hoisted_954 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt"}
}
const _hoisted_955 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l30 level1 lfo22"}
}
const _hoisted_956 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("１．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_957 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_958 = { lang: "EN-US" }
const _hoisted_959 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l30 level1 lfo22"}
}
const _hoisted_960 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("２．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_961 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_962 = { lang: "EN-US" }
const _hoisted_963 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l30 level1 lfo22"}
}
const _hoisted_964 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("３．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_965 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_966 = { lang: "EN-US" }
const _hoisted_967 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l30 level1 lfo22"}
}
const _hoisted_968 = { name: "_Hlk161159156" }
const _hoisted_969 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("４．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_970 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_971 = { lang: "EN-US" }
const _hoisted_972 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk161159156"} }, null, -1))
const _hoisted_973 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"35.45pt","text-align":"justify","text-justify":"inter-ideograph"}
}
const _hoisted_974 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}
const _hoisted_975 = { style: {"margin-right":"-0.05pt"} }
const _hoisted_976 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc221547760" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }, "第１５条 ビューア管理の委託")
], -1))
const _hoisted_977 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547760"} }, null, -1))
const _hoisted_978 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_979 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l0 level1 lfo30"}
}
const _hoisted_980 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "運営管理者は、本サービスの提供に必要となる業務の全部または一部を第三者に委託でき" }, null, -1))
const _hoisted_981 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("１."),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "      ")
  ])
], -1))
const _hoisted_982 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.55pt"} }, "管理者は、本ビューアの提供に必要となる業務の全部または一部を第三者に", -1))
const _hoisted_983 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.2pt"} }, "委託できるものとします。この場合、管理者は、本規約に定める管理者", -1))
const _hoisted_984 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"} }
const _hoisted_985 = { lang: "EN-US" }
const _hoisted_986 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"56.05pt","text-align":"justify","text-justify":"inter-ideograph"}
}
const _hoisted_987 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_988 = { style: {"margin-top":"7.15pt","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"13.55pt"} }
const _hoisted_989 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc221547761" }, null, -1))
const _hoisted_990 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "第２０条_個人情報の保護" }, null, -1))
const _hoisted_991 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547761"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'"} }, "第１６条 個人情報の保護")
], -1))
const _hoisted_992 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_993 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l15 level1 lfo31"}
}
const _hoisted_994 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "運営管理者は、サービス利用者の個人情報を、運営管理者が提供するウェブサイトにおい" }, null, -1))
const _hoisted_995 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.55pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("１."),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "       ")
  ])
], -1))
const _hoisted_996 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.55pt"} }
const _hoisted_997 = { lang: "EN-US" }
const _hoisted_998 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"56.05pt","text-align":"justify","text-justify":"inter-ideograph"}
}
const _hoisted_999 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1000 = { style: {"margin-top":"7.15pt","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"13.55pt"} }
const _hoisted_1001 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc221547762" }, null, -1))
const _hoisted_1002 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "第２１条_反社会的勢力の排除" }, null, -1))
const _hoisted_1003 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547762"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }, "第１７条 反社会的勢力の排除")
], -1))
const _hoisted_1004 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547762"} }, null, -1))
const _hoisted_1005 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1006 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l2 level1 lfo23"}
}
const _hoisted_1007 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "１．_サービス利用者は、運営管理者に対し、次の各号の事項を確約するものとします。" }, null, -1))
const _hoisted_1008 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("１．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_1009 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_1010 = { lang: "EN-US" }
const _hoisted_1011 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"78pt","text-indent":"-35.45pt"}
}
const _hoisted_1012 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "（１）_自らが、暴力団、暴力団関係企業、総会屋もしくはこれらに準ずる者またはその" }, null, -1))
const _hoisted_1013 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"} }
const _hoisted_1014 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1"} })
], -1))
const _hoisted_1015 = { lang: "EN-US" }
const _hoisted_1016 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"78pt","text-indent":"-35.45pt"}
}
const _hoisted_1017 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "（２）_自らの役員（業務を執行する社員、取締役、執行役またはこれらに準ずる者をい" }, null, -1))
const _hoisted_1018 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"} }
const _hoisted_1019 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1"} })
], -1))
const _hoisted_1020 = { lang: "EN-US" }
const _hoisted_1021 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"78pt","text-indent":"-35.45pt"}
}
const _hoisted_1022 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "（３）_反社会的勢力に自己の名義を利用させ、利用契約を締結するものでないこと。" }, null, -1))
const _hoisted_1023 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"} }
const _hoisted_1024 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1"} })
], -1))
const _hoisted_1025 = { lang: "EN-US" }
const _hoisted_1026 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"78pt","text-indent":"-35.45pt"}
}
const _hoisted_1027 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "（４）_自らまたは第三者を利用して、利用契約に関して次の行為をしないこと。" }, null, -1))
const _hoisted_1028 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"} }
const _hoisted_1029 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1"} })
], -1))
const _hoisted_1030 = { lang: "EN-US" }
const _hoisted_1031 = {
  class: "MsoListParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"30mm","text-indent":"-21.25pt","mso-list":"l20 level1 lfo1"}
}
const _hoisted_1032 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "i．_運営管理者に対し脅迫的な言動または暴力を用いる行為" }, null, -1))
const _hoisted_1033 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-size":"9.5pt","letter-spacing":"-0.05pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("i."),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "        ")
  ])
], -1))
const _hoisted_1034 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.15pt"} }, "脅迫的な言動または暴力を用いる行為", -1))
const _hoisted_1035 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1036 = {
  class: "MsoListParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"30mm","text-indent":"-21.25pt","mso-list":"l20 level1 lfo1"}
}
const _hoisted_1037 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "ii．_偽計または威力を用いて運営管理者の業務を妨害し、または信用を毀損する行為" }, null, -1))
const _hoisted_1038 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-size":"9.5pt","letter-spacing":"-0.05pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("ii."),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "       ")
  ])
], -1))
const _hoisted_1039 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.1pt"} }, "偽計または威力を用いて管理者の業務を妨害し、または信用を毀損", -1))
const _hoisted_1040 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.2pt"} }, "する行為", -1))
const _hoisted_1041 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1042 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l2 level1 lfo23"}
}
const _hoisted_1043 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "２．_運営管理者は、サービス利用者が次のいずれかに該当した場合には、何らの催告を" }, null, -1))
const _hoisted_1044 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("２．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_1045 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_1046 = { lang: "EN-US" }
const _hoisted_1047 = {
  class: "MsoListParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"30mm","text-indent":"-21.25pt","mso-list":"l23 level1 lfo27"}
}
const _hoisted_1048 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "i．_前項（１）または前項（２）の確約に反することが判明した場合" }, null, -1))
const _hoisted_1049 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-size":"9.5pt","letter-spacing":"-0.05pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("i."),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "        ")
  ])
], -1))
const _hoisted_1050 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.15pt"} }
const _hoisted_1051 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "ii．_前項（３）の確約に反し契約をしたことが判明した場合" }, null, -1))
const _hoisted_1052 = { lang: "EN-US" }
const _hoisted_1053 = {
  class: "MsoListParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"30mm","text-indent":"-21.25pt","mso-list":"l23 level1 lfo27"}
}
const _hoisted_1054 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-size":"9.5pt","letter-spacing":"-0.05pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("ii."),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "       ")
  ])
], -1))
const _hoisted_1055 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.15pt"} }
const _hoisted_1056 = { lang: "EN-US" }
const _hoisted_1057 = {
  class: "MsoListParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"30mm","text-indent":"-21.25pt","mso-list":"l23 level1 lfo27"}
}
const _hoisted_1058 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "iii．_前項（４）の確約に反した行為をした場合" }, null, -1))
const _hoisted_1059 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-size":"9.5pt","letter-spacing":"-0.05pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("iii."),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "      ")
  ])
], -1))
const _hoisted_1060 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.15pt"} }
const _hoisted_1061 = { lang: "EN-US" }
const _hoisted_1062 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l2 level1 lfo23"}
}
const _hoisted_1063 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "３．_第２項の規定により利用契約が解除された場合には、サービス利用者は、解除によ" }, null, -1))
const _hoisted_1064 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("３．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_1065 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_1066 = { lang: "EN-US" }
const _hoisted_1067 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"56.15pt","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-34pt"}
}
const _hoisted_1068 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1069 = { style: {"margin-top":"7.1pt","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"13.55pt"} }
const _hoisted_1070 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Hlk153484155" }, null, -1))
const _hoisted_1071 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc221547763" }, null, -1))
const _hoisted_1072 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc153482780" }, null, -1))
const _hoisted_1073 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "第２２条_準拠法" }, null, -1))
const _hoisted_1074 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153484155"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547763"} }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc153482780"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt"} }, "第１８条 ")
    ])
  ])
], -1))
const _hoisted_1075 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153484155"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547763"} }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt"} }, "準拠法と合意管轄")
  ])
], -1))
const _hoisted_1076 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547763"} }, null, -1))
const _hoisted_1077 = { style: {"mso-bookmark":"_Hlk153484155"} }
const _hoisted_1078 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1079 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l26 level1 lfo24"}
}
const _hoisted_1080 = { style: {"mso-bookmark":"_Hlk153484155"} }
const _hoisted_1081 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "この契約は、日本国の法令に準拠するものとします。" }, null, -1))
const _hoisted_1082 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "１．_利用契約に関して、運営管理者およびサービス利用者間で意見または認識の食い違" }, null, -1))
const _hoisted_1083 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("１．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_1084 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_1085 = { lang: "EN-US" }
const _hoisted_1086 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.4pt","mso-list":"l26 level1 lfo24"}
}
const _hoisted_1087 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153484155"} }, [
  /*#__PURE__*/_createElementVNode("span", {
    lang: "EN-US",
    style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
      /*#__PURE__*/_createTextVNode("２．"),
      /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }, "本規約によるコンテンツの利用及び本規約に関する紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。")
], -1))
const _hoisted_1088 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}
const _hoisted_1089 = {
  class: "MsoBodyText",
  style: {"margin-right":"-0.05pt"}
}
const _hoisted_1090 = {
  lang: "EN-US",
  style: {"font-size":"12.5pt","mso-bidi-font-size":"10.5pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1091 = { style: {"margin-top":"6.65pt"} }
const _hoisted_1092 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc221547764" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.1pt"} }, "第１９条 本規約の変更")
], -1))
const _hoisted_1093 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547764"} }, null, -1))
const _hoisted_1094 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1095 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.15pt","mso-list":"l14 level1 lfo5"}
}
const _hoisted_1096 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("１．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_1097 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_1098 = { lang: "EN-US" }
const _hoisted_1099 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.15pt","mso-list":"l14 level1 lfo5"}
}
const _hoisted_1100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("２．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_1101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }, "管理者は、本規約を変更する場合は、変更する旨、変更後の本規約の内容及び効力発生日を、", -1))
const _hoisted_1102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.35pt"} }, "道路データプラットフォームポータルサイト", -1))
const _hoisted_1103 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_1104 = { lang: "EN-US" }
const _hoisted_1105 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-35.15pt","mso-list":"l14 level1 lfo5"}
}
const _hoisted_1106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("３．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_1107 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_1108 = { lang: "EN-US" }
const _hoisted_1109 = {
  class: "MsoBodyText",
  style: {"margin-right":"-0.05pt"}
}
const _hoisted_1110 = {
  lang: "EN-US",
  style: {"font-size":"12.5pt","mso-bidi-font-size":"10.5pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1111 = { style: {"margin-top":"7.1pt","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"13.55pt"} }
const _hoisted_1112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc221547765" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt"} }, "第２０条 その他")
], -1))
const _hoisted_1113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547765"} }, null, -1))
const _hoisted_1114 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1115 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-34.5pt","mso-list":"l16 level1 lfo32"}
}
const _hoisted_1116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("１．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_1117 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_1118 = { lang: "EN-US" }
const _hoisted_1119 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-34.5pt","mso-list":"l16 level1 lfo32"}
}
const _hoisted_1120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("２．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_1121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }, "本規約は、令和７年", -1))
const _hoisted_1122 = { style: {"font-family":"'ＭＳ ゴシック'"} }
const _hoisted_1123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"letter-spacing":"-0.35pt"} }, "１２", -1))
const _hoisted_1124 = { style: {"letter-spacing":"-0.35pt"} }
const _hoisted_1125 = { lang: "EN-US" }
const _hoisted_1126 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-34.5pt","mso-list":"l16 level1 lfo32"}
}
const _hoisted_1127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("３．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_1128 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_1129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Hlk153820364" }, [
  /*#__PURE__*/_createTextVNode("規約は、クリエイティブ・コモンズ・ライセンスの表示"),
  /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "4.0 "),
  /*#__PURE__*/_createTextVNode("国際ライセンス （"),
  /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "https://creativecommons.org/licenses/by/4.0/legalcode.ja "),
  /*#__PURE__*/_createTextVNode("に規定される著作権利用許諾条件。以下「"),
  /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "CC BY"),
  /*#__PURE__*/_createTextVNode("」といいます）と互換性があります。管理者は、本規約が適用されるコンテンツについて、利用者が"),
  /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "CC BY"),
  /*#__PURE__*/_createTextVNode("に従って利用することを許諾します。")
], -1))
const _hoisted_1130 = { lang: "EN-US" }
const _hoisted_1131 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-34.5pt","mso-list":"l16 level1 lfo32"}
}
const _hoisted_1132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("４．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_1133 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_1134 = { name: "_Hlk190376541" }
const _hoisted_1135 = { lang: "EN-US" }
const _hoisted_1136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk190376541"} }, null, -1))
const _hoisted_1137 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"20mm","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-34.5pt","mso-list":"l16 level1 lfo32"}
}
const _hoisted_1138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-list":"Ignore"} }, [
    /*#__PURE__*/_createTextVNode("５．"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font":"7pt 'Times New Roman'"} }, "     ")
  ])
], -1))
const _hoisted_1139 = { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }
const _hoisted_1140 = { lang: "EN-US" }
const _hoisted_1141 = {
  class: "MsoBodyText",
  style: {"margin-right":"-0.05pt"}
}
const _hoisted_1142 = {
  lang: "EN-US",
  style: {"font-size":"12.5pt","mso-bidi-font-size":"10.5pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1143 = {
  class: "MsoBodyText",
  style: {"margin-right":"-0.05pt"}
}
const _hoisted_1144 = {
  lang: "EN-US",
  style: {"font-size":"12.5pt","mso-bidi-font-size":"10.5pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1145 = { style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"26.3pt"} }
const _hoisted_1146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc221547766" }, null, -1))
const _hoisted_1147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "附則" }, null, -1))
const _hoisted_1148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547766"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.4pt"} }, "附則")
], -1))
const _hoisted_1149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547766"} }, null, -1))
const _hoisted_1150 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1151 = {
  class: "MsoBodyText",
  style: {"margin-top":"0.25pt","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"0mm"}
}
const _hoisted_1152 = {
  lang: "EN-US",
  style: {"font-size":"7.5pt","mso-bidi-font-size":"10.5pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1153 = { style: {"margin-right":"-0.05pt"} }
const _hoisted_1154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc221547767" }, null, -1))
const _hoisted_1155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "第１条_適用開始" }, null, -1))
const _hoisted_1156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547767"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt"} }, "第１条 適用開始")
], -1))
const _hoisted_1157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547767"} }, null, -1))
const _hoisted_1158 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1159 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"56.05pt"}
}
const _hoisted_1160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "本規約は、2021年3月11日より適用されます。" }, null, -1))
const _hoisted_1161 = { style: {"font-family":"'ＭＳ ゴシック'"} }
const _hoisted_1162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"letter-spacing":"-0.35pt"} }, "令和７年", -1))
const _hoisted_1163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"letter-spacing":"-0.35pt"} }, "１２", -1))
const _hoisted_1164 = { style: {"letter-spacing":"-0.2pt"} }
const _hoisted_1165 = { lang: "EN-US" }
const _hoisted_1166 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"56.05pt"}
}
const _hoisted_1167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.2pt"} }, "２．この改定規約は、令和８年３月９日より適用されます。", -1))
const _hoisted_1168 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-size":"11pt","font-family":"'ＭＳ ゴシック'","mso-bidi-font-family":"'Yu Gothic'","letter-spacing":"-0.2pt","mso-font-kerning":"0pt","mso-ansi-language":"EN-US","mso-fareast-language":"JA","mso-bidi-language":"AR-SA"}
}, [
  /*#__PURE__*/_createElementVNode("br", {
    clear: "all",
    style: {"mso-special-character":"line-break","page-break-before":"always"}
  })
], -1))
const _hoisted_1170 = {
  class: "MsoNormal",
  style: {"mso-pagination":"widow-orphan","text-autospace":"ideograph-numeric ideograph-other"}
}
const _hoisted_1171 = { name: "_Hlk153805280" }
const _hoisted_1172 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.2pt"}
}
const _hoisted_1173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805280"} }, null, -1))
const _hoisted_1174 = { style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"26.3pt"} }
const _hoisted_1175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc221547768" }, null, -1))
const _hoisted_1176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc153814572" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547768"} }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.4pt"} }, "別紙")
  ])
], -1))
const _hoisted_1177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547768"} }, null, -1))
const _hoisted_1178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc153814572"} }, null, -1))
const _hoisted_1179 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1180 = {
  class: "MsoBodyText",
  style: {"margin-top":"0.25pt","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"0mm"}
}
const _hoisted_1181 = {
  lang: "EN-US",
  style: {"font-size":"7.5pt","mso-bidi-font-size":"10.5pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1182 = { style: {"margin-right":"-0.05pt"} }
const _hoisted_1183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc221547769" }, null, -1))
const _hoisted_1184 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc153814573" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547769"} }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt"} }, [
      /*#__PURE__*/_createTextVNode("○別表"),
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "1"),
      /*#__PURE__*/_createTextVNode(" データ・提供者の一覧、出典の記載例（第１条・第７条３項関係）")
    ])
  ])
], -1))
const _hoisted_1185 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt"}
}
const _hoisted_1186 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"56.05pt"}
}
const _hoisted_1187 = { style: {"font-family":"'ＭＳ ゴシック'"} }
const _hoisted_1188 = { lang: "EN-US" }
const _hoisted_1189 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"56.05pt"}
}
const _hoisted_1190 = { style: {"font-family":"'ＭＳ ゴシック'"} }
const _hoisted_1191 = { lang: "EN-US" }
const _hoisted_1192 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"56.05pt"}
}
const _hoisted_1193 = { style: {"font-family":"'ＭＳ ゴシック'"} }
const _hoisted_1194 = { name: "_Hlk153805329" }
const _hoisted_1195 = { lang: "EN-US" }
const _hoisted_1196 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1197 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1198 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1199 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1201 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1202 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1203 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1204 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1205 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1206 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1207 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1208 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1209 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1210 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1211 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1212 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1213 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1214 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1215 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1216 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1217 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1218 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1219 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1220 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1221 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1222 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1223 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1224 = {
  class: "TableNormal",
  border: "1",
  cellspacing: "0",
  cellpadding: "0",
  align: "left",
  style: {"border-collapse":"collapse","mso-table-layout-alt":"fixed","border":"none","mso-border-alt":"solid black 0.5pt","mso-yfti-tbllook":"480","mso-table-lspace":"7.1pt","margin-left":"5.6pt","mso-table-rspace":"7.1pt","margin-right":"5.6pt","mso-table-anchor-vertical":"paragraph","mso-table-anchor-horizontal":"margin","mso-table-left":"21pt","mso-table-top":"4.8pt","mso-padding-alt":"0mm 1.4pt 0mm 1.4pt","mso-border-insideh":"0.5pt solid black","mso-border-insidev":"0.5pt solid black"}
}
const _hoisted_1225 = { style: {"mso-yfti-irow":"0","mso-yfti-firstrow":"yes","height":"17.95pt"} }
const _hoisted_1226 = {
  width: "45",
  valign: "top",
  style: {"width":"192.35pt","border":"solid black 1pt","mso-border-alt":"solid black 0.5pt","background":"#bebebe","padding":"0mm 1.4pt 0mm 1.4pt","height":"17.95pt"}
}
const _hoisted_1227 = {
  class: "TableParagraph",
  align: "center",
  style: {"margin-left":"0mm","text-align":"center","line-height":"17pt","mso-line-height-rule":"exactly","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1228 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1229 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_1230 = { lang: "EN-US" }
const _hoisted_1231 = {
  class: "TableParagraph",
  align: "center",
  style: {"margin-left":"0mm","text-align":"center","line-height":"17pt","mso-line-height-rule":"exactly","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1232 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1233 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_1234 = { lang: "EN-US" }
const _hoisted_1235 = {
  width: "580",
  valign: "top",
  style: {"width":"313.85pt","border":"solid black 1pt","border-left":"none","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","background":"#bebebe","padding":"0mm 1.4pt 0mm 1.4pt","height":"17.95pt"}
}
const _hoisted_1236 = {
  class: "TableParagraph",
  align: "center",
  style: {"margin-left":"-7.2pt","text-align":"center","line-height":"17pt","mso-line-height-rule":"exactly","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1237 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1238 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.25pt"} }
const _hoisted_1239 = { lang: "EN-US" }
const _hoisted_1240 = {
  class: "TableParagraph",
  align: "center",
  style: {"margin-left":"-7.2pt","text-align":"center","line-height":"17pt","mso-line-height-rule":"exactly","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1241 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1242 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.25pt"} }
const _hoisted_1243 = { lang: "EN-US" }
const _hoisted_1244 = { style: {"mso-yfti-irow":"1","height":"1pt"} }
const _hoisted_1245 = {
  width: "45",
  style: {"width":"192.35pt","border":"solid black 1pt","border-top":"none","mso-border-top-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1246 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1247 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1248 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_1249 = { lang: "EN-US" }
const _hoisted_1250 = {
  width: "580",
  style: {"width":"313.85pt","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1251 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1252 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1253 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_1254 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "(", -1))
const _hoisted_1255 = { lang: "EN-US" }
const _hoisted_1256 = { style: {"mso-yfti-irow":"2","height":"1pt"} }
const _hoisted_1257 = {
  width: "45",
  style: {"width":"192.35pt","border":"solid black 1pt","border-top":"none","mso-border-left-alt":"solid black 0.5pt","mso-border-bottom-alt":"solid black 0.5pt","mso-border-right-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1258 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1259 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, [
  /*#__PURE__*/_createElementVNode("span", {
    lang: "EN-US",
    style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"}
  }, "ETC2.0")
], -1))
const _hoisted_1260 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1261 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_1262 = { lang: "EN-US" }
const _hoisted_1263 = {
  width: "580",
  style: {"width":"313.85pt","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1264 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1265 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, [
  /*#__PURE__*/_createElementVNode("span", {
    lang: "EN-US",
    style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"}
  }, "ETC2.0")
], -1))
const _hoisted_1266 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1267 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_1268 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "(", -1))
const _hoisted_1269 = { lang: "EN-US" }
const _hoisted_1270 = { style: {"mso-yfti-irow":"3","height":"1pt"} }
const _hoisted_1271 = {
  width: "45",
  style: {"width":"192.35pt","border":"solid black 1pt","border-top":"none","mso-border-left-alt":"solid black 0.5pt","mso-border-bottom-alt":"solid black 0.5pt","mso-border-right-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1272 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1273 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1274 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1275 = {
  width: "580",
  style: {"width":"313.85pt","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1276 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1277 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1278 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_1279 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "(", -1))
const _hoisted_1280 = { lang: "EN-US" }
const _hoisted_1281 = { style: {"mso-yfti-irow":"4","height":"1pt"} }
const _hoisted_1282 = {
  width: "45",
  style: {"width":"192.35pt","border":"solid black 1pt","border-top":"none","mso-border-top-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1283 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1284 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1285 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_1286 = { lang: "EN-US" }
const _hoisted_1287 = {
  width: "580",
  style: {"width":"313.85pt","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1288 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1289 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }, [
    /*#__PURE__*/_createTextVNode("「国土数値情報"),
    /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "("),
    /*#__PURE__*/_createTextVNode("行政区域データ"),
    /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, ")"),
    /*#__PURE__*/_createTextVNode("」"),
    /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "("),
    /*#__PURE__*/_createTextVNode("国土交通省"),
    /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, ")")
  ])
], -1))
const _hoisted_1290 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1291 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://nlftp.mlit.go.jp/ksj/gml/datalist/KsjTmplt-N03-v3_1.html" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","color":"windowtext"}
    }, "https://nlftp.mlit.go.jp/ksj/gml/datalist/KsjTmplt-N03-v3_1.html")
  ]),
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} })
], -1))
const _hoisted_1292 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, [
  /*#__PURE__*/_createElementVNode("span", {
    lang: "EN-US",
    style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"}
  })
], -1))
const _hoisted_1293 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1294 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_1295 = { lang: "EN-US" }
const _hoisted_1296 = { style: {"mso-yfti-irow":"5","height":"1pt"} }
const _hoisted_1297 = {
  width: "45",
  style: {"width":"192.35pt","border":"solid black 1pt","border-top":"none","mso-border-left-alt":"solid black 0.5pt","mso-border-bottom-alt":"solid black 0.5pt","mso-border-right-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1298 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1299 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, [
  /*#__PURE__*/_createElementVNode("span", {
    lang: "ZH-CN",
    style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","mso-fareast-language":"ZH-CN"}
  }, "道路属性（重要物流道路）")
], -1))
const _hoisted_1300 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1301 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","mso-fareast-language":"ZH-CN"}
}
const _hoisted_1302 = {
  width: "580",
  style: {"width":"313.85pt","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1303 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1304 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, [
  /*#__PURE__*/_createElementVNode("span", {
    lang: "ZH-CN",
    style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","mso-fareast-language":"ZH-CN"}
  }, "重要物流道路")
], -1))
const _hoisted_1305 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, [
  /*#__PURE__*/_createElementVNode("span", {
    lang: "EN-US",
    style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","mso-fareast-language":"ZH-CN"}
  }, "(")
], -1))
const _hoisted_1306 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, [
  /*#__PURE__*/_createElementVNode("span", {
    lang: "ZH-CN",
    style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","mso-fareast-language":"ZH-CN"}
  }, "国土交通省")
], -1))
const _hoisted_1307 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1308 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","mso-fareast-language":"ZH-CN"}
}
const _hoisted_1309 = { style: {"mso-yfti-irow":"6","height":"1pt"} }
const _hoisted_1310 = {
  width: "45",
  style: {"width":"192.35pt","border":"solid black 1pt","border-top":"none","mso-border-left-alt":"solid black 0.5pt","mso-border-bottom-alt":"solid black 0.5pt","mso-border-right-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1311 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1312 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1313 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_1314 = { lang: "EN-US" }
const _hoisted_1315 = {
  width: "580",
  style: {"width":"313.85pt","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1316 = {
  class: "TableParagraph",
  style: {"margin-left":"1.75pt","mso-para-margin-left":"0.15gd","text-indent":"-0.1pt","mso-char-indent-count":"-0.01","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1317 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1318 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }
const _hoisted_1319 = { lang: "EN-US" }
const _hoisted_1320 = {
  class: "TableParagraph",
  style: {"margin-left":"1.75pt","mso-para-margin-left":"0.15gd","text-indent":"-0.1pt","mso-char-indent-count":"-0.01","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1321 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1322 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://road-structures-db.mlit.go.jp/" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","color":"windowtext","letter-spacing":"-0.05pt","mso-fareast-language":"EN-US"}
    }, "https://road-structures-db.mlit.go.jp/")
  ])
], -1))
const _hoisted_1323 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1324 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt","mso-fareast-language":"EN-US"}
}
const _hoisted_1325 = { style: {"mso-yfti-irow":"7","height":"1pt"} }
const _hoisted_1326 = {
  width: "45",
  style: {"width":"192.35pt","border":"solid black 1pt","border-top":"none","mso-border-left-alt":"solid black 0.5pt","mso-border-bottom-alt":"solid black 0.5pt","mso-border-right-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1327 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1328 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1329 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1330 = {
  width: "580",
  style: {"width":"313.85pt","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1331 = {
  class: "TableParagraph",
  style: {"margin-left":"1.75pt","mso-para-margin-left":"0.15gd","text-indent":"-0.1pt","mso-char-indent-count":"-0.01","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1332 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, [
  /*#__PURE__*/_createElementVNode("span", {
    lang: "EN-US",
    style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"}
  }, "DRM-DB")
], -1))
const _hoisted_1333 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1334 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }
const _hoisted_1335 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "(", -1))
const _hoisted_1336 = { lang: "EN-US" }
const _hoisted_1337 = {
  class: "TableParagraph",
  style: {"margin-left":"1.75pt","mso-para-margin-left":"0.15gd","text-indent":"-0.1pt","mso-char-indent-count":"-0.01","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1338 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1339 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://pf.drm.jp/FreeViewer/" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","color":"windowtext","letter-spacing":"-0.05pt"}
    }, "https://pf.drm.jp/FreeViewer/")
  ]),
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} })
], -1))
const _hoisted_1340 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1341 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"}
}
const _hoisted_1342 = { style: {"mso-yfti-irow":"8","height":"1pt"} }
const _hoisted_1343 = {
  width: "45",
  style: {"width":"192.35pt","border":"solid black 1pt","border-top":"none","mso-border-left-alt":"solid black 0.5pt","mso-border-bottom-alt":"solid black 0.5pt","mso-border-right-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1344 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1345 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1346 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_1347 = { lang: "EN-US" }
const _hoisted_1348 = {
  width: "580",
  style: {"width":"313.85pt","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1349 = {
  class: "TableParagraph",
  style: {"margin-left":"1.75pt","mso-para-margin-left":"0.15gd","text-indent":"-0.1pt","mso-char-indent-count":"-0.01","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1350 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1351 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_1352 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "(", -1))
const _hoisted_1353 = { lang: "EN-US" }
const _hoisted_1354 = {
  class: "TableParagraph",
  style: {"margin-left":"1.75pt","mso-para-margin-left":"0.15gd","text-indent":"-0.1pt","mso-char-indent-count":"-0.01","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1355 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1356 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://maps.gsi.go.jp/development/ichiran.html" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","color":"windowtext"}
    }, "https://maps.gsi.go.jp/development/ichiran.html")
  ]),
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} })
], -1))
const _hoisted_1357 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1358 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1359 = { style: {"mso-yfti-irow":"9","height":"1pt"} }
const _hoisted_1360 = {
  width: "45",
  style: {"width":"192.35pt","border-top":"none","border-left":"solid black 1pt","border-bottom":"solid windowtext 1pt","border-right":"solid black 1pt","mso-border-left-alt":"solid black 0.5pt","mso-border-bottom-alt":"solid windowtext 0.5pt","mso-border-right-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1361 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1362 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1363 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_1364 = { lang: "EN-US" }
const _hoisted_1365 = {
  width: "580",
  style: {"width":"313.85pt","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1366 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"4.3pt","margin-bottom":"0.0001pt","margin-left":"1.75pt","mso-para-margin-top":"0mm","mso-para-margin-right":"4.3pt","mso-para-margin-bottom":"0.0001pt","mso-para-margin-left":"0.15gd","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-0.1pt","mso-char-indent-count":"-0.01","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1367 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, [
  /*#__PURE__*/_createElementVNode("span", {
    lang: "EN-US",
    style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"}
  }, "CSIS")
], -1))
const _hoisted_1368 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1369 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }
const _hoisted_1370 = { lang: "EN-US" }
const _hoisted_1371 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"4.3pt","margin-bottom":"0.0001pt","margin-left":"1.75pt","mso-para-margin-top":"0mm","mso-para-margin-right":"4.3pt","mso-para-margin-bottom":"0.0001pt","mso-para-margin-left":"0.15gd","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-0.1pt","mso-char-indent-count":"-0.01","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1372 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1373 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://geocode.csis.u-tokyo.ac.jp/" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","color":"windowtext","letter-spacing":"-0.05pt"}
    }, "https://geocode.csis.u-tokyo.ac.jp/")
  ]),
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} })
], -1))
const _hoisted_1374 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1375 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"}
}
const _hoisted_1376 = { style: {"mso-yfti-irow":"10","height":"1pt"} }
const _hoisted_1377 = {
  width: "45",
  style: {"width":"192.35pt","border":"solid windowtext 1pt","border-top":"none","mso-border-top-alt":"solid windowtext 0.5pt","mso-border-alt":"solid windowtext 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1378 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1379 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1380 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","mso-fareast-language":"EN-US"}
}
const _hoisted_1381 = {
  width: "580",
  style: {"width":"313.85pt","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid windowtext 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1382 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"4.3pt","margin-bottom":"0.0001pt","margin-left":"1.75pt","mso-para-margin-top":"0mm","mso-para-margin-right":"4.3pt","mso-para-margin-bottom":"0.0001pt","mso-para-margin-left":"0.15gd","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-0.1pt","mso-char-indent-count":"-0.01","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1383 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1384 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }
const _hoisted_1385 = { lang: "EN-US" }
const _hoisted_1386 = { style: {"mso-yfti-irow":"11","height":"1pt"} }
const _hoisted_1387 = {
  width: "45",
  style: {"width":"192.35pt","border":"solid windowtext 1pt","border-top":"none","mso-border-top-alt":"solid windowtext 0.5pt","mso-border-alt":"solid windowtext 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1388 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1389 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1390 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","mso-fareast-language":"EN-US"}
}
const _hoisted_1391 = {
  width: "580",
  style: {"width":"313.85pt","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid windowtext 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1392 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"4.3pt","margin-bottom":"0.0001pt","margin-left":"1.75pt","mso-para-margin-top":"0mm","mso-para-margin-right":"4.3pt","mso-para-margin-bottom":"0.0001pt","mso-para-margin-left":"0.15gd","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-0.1pt","mso-char-indent-count":"-0.01","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1393 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, [
  /*#__PURE__*/_createElementVNode("span", {
    lang: "ZH-TW",
    style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt","mso-fareast-language":"ZH-TW"}
  }, "主要渋滞箇所（国土交通省）")
], -1))
const _hoisted_1394 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1395 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt","mso-fareast-language":"ZH-TW"}
}
const _hoisted_1396 = { style: {"mso-yfti-irow":"12","height":"1pt"} }
const _hoisted_1397 = {
  width: "45",
  style: {"width":"192.35pt","border":"solid black 1pt","border-top":"none","mso-border-top-alt":"solid windowtext 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1398 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1399 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1400 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","mso-fareast-language":"EN-US"}
}
const _hoisted_1401 = {
  width: "580",
  style: {"width":"313.85pt","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1402 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"4.3pt","margin-bottom":"0.0001pt","margin-left":"1.75pt","mso-para-margin-top":"0mm","mso-para-margin-right":"4.3pt","mso-para-margin-bottom":"0.0001pt","mso-para-margin-left":"0.15gd","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-0.1pt","mso-char-indent-count":"-0.01","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1403 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1404 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }
const _hoisted_1405 = { lang: "EN-US" }
const _hoisted_1406 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"4.3pt","margin-bottom":"0.0001pt","margin-left":"1.75pt","mso-para-margin-top":"0mm","mso-para-margin-right":"4.3pt","mso-para-margin-bottom":"0.0001pt","mso-para-margin-left":"0.15gd","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-0.1pt","mso-char-indent-count":"-0.01","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1407 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1408 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }
const _hoisted_1409 = { lang: "EN-US" }
const _hoisted_1410 = { style: {"mso-yfti-irow":"13","mso-yfti-lastrow":"yes","height":"1pt"} }
const _hoisted_1411 = {
  width: "45",
  style: {"width":"192.35pt","border":"solid black 1pt","border-top":"none","mso-border-left-alt":"solid black 0.5pt","mso-border-bottom-alt":"solid black 0.5pt","mso-border-right-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1412 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1413 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1414 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","mso-fareast-language":"EN-US"}
}
const _hoisted_1415 = {
  width: "580",
  style: {"width":"313.85pt","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1416 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"4.3pt","margin-bottom":"0.0001pt","margin-left":"1.75pt","mso-para-margin-top":"0mm","mso-para-margin-right":"4.3pt","mso-para-margin-bottom":"0.0001pt","mso-para-margin-left":"0.15gd","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-0.1pt","mso-char-indent-count":"-0.01","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1417 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, [
  /*#__PURE__*/_createElementVNode("span", {
    lang: "ZH-TW",
    style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt","mso-fareast-language":"ZH-TW"}
  }, "交通事故統計情報（警察庁）")
], -1))
const _hoisted_1418 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1419 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt","mso-fareast-language":"ZH-TW"}
}
const _hoisted_1420 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"4.3pt","margin-bottom":"0.0001pt","margin-left":"1.75pt","mso-para-margin-top":"0mm","mso-para-margin-right":"4.3pt","mso-para-margin-bottom":"0.0001pt","mso-para-margin-left":"0.15gd","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-0.1pt","mso-char-indent-count":"-0.01","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1421 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1422 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.npa.go.jp/publications/statistics/koutsuu/opendata/index_opendata.html",
  target: "_blank",
  title: "https://www.npa.go.jp/publications/statistics/koutsuu/opendata/index_opendata.html"
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","color":"windowtext","letter-spacing":"-0.05pt","mso-fareast-language":"EN-US"}
    }, "https://www.npa.go.jp/publications/statistics/koutsuu/opendata/index_opendata.html")
  ])
], -1))
const _hoisted_1423 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1424 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt","mso-fareast-language":"EN-US"}
}
const _hoisted_1425 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"35.45pt"}
}
const _hoisted_1426 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1427 = { style: {"font-family":"'ＭＳ ゴシック'"} }
const _hoisted_1428 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "1", -1))
const _hoisted_1429 = { style: {"letter-spacing":"-0.05pt"} }
const _hoisted_1430 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "URL", -1))
const _hoisted_1431 = { lang: "EN-US" }
const _hoisted_1432 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"92.3pt","mso-para-margin-top":"0mm","mso-para-margin-right":"-0.05pt","mso-para-margin-bottom":"0.0001pt","mso-para-margin-left":"5.75gd","text-indent":"-29.05pt","mso-char-indent-count":"-2.78","tab-stops":"63.8pt"}
}
const _hoisted_1433 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, [
  /*#__PURE__*/_createElementVNode("span", {
    lang: "EN-US",
    style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"mso-tab-count":"1"} })
  ])
], -1))
const _hoisted_1434 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://geocode.csis.u-tokyo.ac.jp/home/simple-geocoding/simple-geocoding-tems-of-use/" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","color":"windowtext"}
    }, "https://geocode.csis.u-tokyo.ac.jp/home/simple-geocoding/simple-geocoding-tems-of-use/")
  ])
], -1))
const _hoisted_1435 = { style: {"mso-bookmark":"_Hlk153805329"} }
const _hoisted_1436 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1437 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805329"} }, null, -1))
const _hoisted_1438 = {
  class: "MsoNormal",
  style: {"mso-pagination":"widow-orphan","text-autospace":"ideograph-numeric ideograph-other"}
}
const _hoisted_1439 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1440 = { style: {"margin-right":"-0.05pt"} }
const _hoisted_1441 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc221547770" }, null, -1))
const _hoisted_1442 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc153814574" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547770"} }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt"} }, [
      /*#__PURE__*/_createTextVNode("○別表"),
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "2")
    ])
  ])
], -1))
const _hoisted_1443 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc153814574"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547770"} }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }, "別の利用ルールの適用を明示しているコンテンツ")
  ])
], -1))
const _hoisted_1444 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc153814574"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547770"} }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt"} }, "（第３条・第７条８項・第８条２項関係）")
  ])
], -1))
const _hoisted_1445 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt"}
}
const _hoisted_1446 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"56.05pt"}
}
const _hoisted_1447 = { style: {"font-family":"'ＭＳ ゴシック'"} }
const _hoisted_1448 = { lang: "EN-US" }
const _hoisted_1449 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"56.05pt"}
}
const _hoisted_1450 = { style: {"font-family":"'ＭＳ ゴシック'"} }
const _hoisted_1451 = { lang: "EN-US" }
const _hoisted_1452 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805375"} }, null, -1))
const _hoisted_1453 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805375"} }, null, -1))
const _hoisted_1454 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805375"} }, null, -1))
const _hoisted_1455 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805375"} }, null, -1))
const _hoisted_1456 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805375"} }, null, -1))
const _hoisted_1457 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805375"} }, null, -1))
const _hoisted_1458 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805375"} }, null, -1))
const _hoisted_1459 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805375"} }, null, -1))
const _hoisted_1460 = {
  class: "TableNormal",
  border: "1",
  cellspacing: "0",
  cellpadding: "0",
  align: "left",
  width: "96%",
  style: {"width":"96.88%","border-collapse":"collapse","border":"none","mso-border-alt":"solid black 0.5pt","mso-yfti-tbllook":"480","mso-table-lspace":"7.1pt","margin-left":"5.6pt","mso-table-rspace":"7.1pt","margin-right":"5.6pt","mso-table-anchor-vertical":"paragraph","mso-table-anchor-horizontal":"margin","mso-table-left":"21pt","mso-table-top":"4.8pt","mso-padding-alt":"0mm 0mm 0mm 0mm","mso-border-insideh":"0.5pt solid black","mso-border-insidev":"0.5pt solid black"}
}
const _hoisted_1461 = { style: {"mso-yfti-irow":"0","mso-yfti-firstrow":"yes","height":"17.95pt"} }
const _hoisted_1462 = {
  width: "37%",
  valign: "top",
  style: {"width":"37.72%","border":"solid black 1pt","mso-border-alt":"solid black 0.5pt","background":"#bebebe","padding":"0mm 0mm 0mm 0mm","height":"17.95pt"}
}
const _hoisted_1463 = {
  class: "TableParagraph",
  align: "center",
  style: {"margin-top":"0mm","margin-right":"37.8pt","margin-bottom":"0.0001pt","margin-left":"38.3pt","text-align":"center","line-height":"17pt","mso-line-height-rule":"exactly","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1464 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }, "データ", -1))
const _hoisted_1465 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","mso-fareast-language":"EN-US"}
}
const _hoisted_1466 = {
  width: "62%",
  valign: "top",
  style: {"width":"62.28%","border":"solid black 1pt","border-left":"none","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","background":"#bebebe","padding":"0mm 0mm 0mm 0mm","height":"17.95pt"}
}
const _hoisted_1467 = {
  class: "TableParagraph",
  align: "center",
  style: {"margin-top":"0mm","margin-right":"37.8pt","margin-bottom":"0.0001pt","margin-left":"38.3pt","text-align":"center","line-height":"17pt","mso-line-height-rule":"exactly","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1468 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.25pt"} }, [
  /*#__PURE__*/_createTextVNode("参考"),
  /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "URL"),
  /*#__PURE__*/_createTextVNode("等")
], -1))
const _hoisted_1469 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.25pt","mso-fareast-language":"EN-US"}
}
const _hoisted_1470 = { style: {"mso-yfti-irow":"1","height":"1pt"} }
const _hoisted_1471 = {
  width: "37%",
  style: {"width":"37.72%","border":"solid black 1pt","border-top":"none","mso-border-left-alt":"solid black 0.5pt","mso-border-bottom-alt":"solid black 0.5pt","mso-border-right-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1472 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1473 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt","mso-fareast-language":"EN-US"}
}, "ETC2.0", -1))
const _hoisted_1474 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }, "プローブ情報", -1))
const _hoisted_1475 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt","mso-fareast-language":"EN-US"}
}
const _hoisted_1476 = {
  width: "62%",
  style: {"width":"62.28%","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1477 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"2.1pt","mso-para-margin-top":"0mm","mso-para-margin-right":"-0.75pt","mso-para-margin-bottom":"0.0001pt","mso-para-margin-left":"0.02gd","text-indent":"-1.9pt","mso-char-indent-count":"-0.18","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1478 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }
const _hoisted_1479 = { lang: "EN-US" }
const _hoisted_1480 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"2.1pt","mso-para-margin-top":"0mm","mso-para-margin-right":"-0.75pt","mso-para-margin-bottom":"0.0001pt","mso-para-margin-left":"0.02gd","text-indent":"-1.9pt","mso-char-indent-count":"-0.18","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1481 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }
const _hoisted_1482 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "ID", -1))
const _hoisted_1483 = { lang: "EN-US" }
const _hoisted_1484 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"2.2pt","mso-para-margin-top":"0mm","mso-para-margin-right":"-0.75pt","mso-para-margin-bottom":"0.0001pt","mso-para-margin-left":"0.02gd","text-indent":"-2pt","mso-char-indent-count":"-0.18","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1485 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"mso-fareast-language":"EN-US"}
}, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://www.mlit.go.jp/road/ITS/j-html/spot_dsrc/oshirase.html" }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10pt","mso-bidi-font-size":"10.5pt","font-family":"'ＭＳ ゴシック'","color":"windowtext","letter-spacing":"-0.05pt"} }, "https://www.mlit.go.jp/road/ITS/j-html/spot_dsrc/oshirase.html")
  ])
], -1))
const _hoisted_1486 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt","mso-fareast-language":"EN-US"}
}
const _hoisted_1487 = { style: {"mso-yfti-irow":"2","height":"1pt"} }
const _hoisted_1488 = {
  width: "37%",
  style: {"width":"37.72%","border":"solid black 1pt","border-top":"none","mso-border-left-alt":"solid black 0.5pt","mso-border-bottom-alt":"solid black 0.5pt","mso-border-right-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1489 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1490 = { name: "_Hlk153805375" }
const _hoisted_1491 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }
const _hoisted_1492 = { lang: "EN-US" }
const _hoisted_1493 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1494 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805375"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }, "（全国道路施設点検データベース）")
], -1))
const _hoisted_1495 = { style: {"mso-bookmark":"_Hlk153805375"} }
const _hoisted_1496 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1497 = {
  width: "62%",
  style: {"width":"62.28%","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1498 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"2.1pt","mso-para-margin-top":"0mm","mso-para-margin-right":"-0.75pt","mso-para-margin-bottom":"0.0001pt","mso-para-margin-left":"0.02gd","text-indent":"-1.9pt","mso-char-indent-count":"-0.18","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1499 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805375"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }, "参考：全国道路施設点検データベース データ閲覧・取得に関するご案内")
], -1))
const _hoisted_1500 = { style: {"mso-bookmark":"_Hlk153805375"} }
const _hoisted_1501 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1502 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"2.2pt","mso-para-margin-top":"0mm","mso-para-margin-right":"-0.75pt","mso-para-margin-bottom":"0.0001pt","mso-para-margin-left":"0.02gd","text-indent":"-2pt","mso-char-indent-count":"-0.18","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1503 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805375"} }, null, -1))
const _hoisted_1504 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://rirs.or.jp/tenken-db/view/" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805375"} }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-family":"'ＭＳ ゴシック'","color":"black","mso-themecolor":"text1","mso-fareast-language":"EN-US"}
    }, "https://rirs.or.jp/tenken-db/view/")
  ])
], -1))
const _hoisted_1505 = { style: {"mso-bookmark":"_Hlk153805375"} }
const _hoisted_1506 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","color":"black","mso-themecolor":"text1"}
}
const _hoisted_1507 = { style: {"mso-yfti-irow":"3","height":"1pt"} }
const _hoisted_1508 = {
  width: "37%",
  style: {"width":"37.72%","border":"solid windowtext 1pt","border-top":"none","mso-border-top-alt":"solid windowtext 0.5pt","mso-border-alt":"solid windowtext 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1509 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1510 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805375"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }, "地理院タイル")
], -1))
const _hoisted_1511 = { style: {"mso-bookmark":"_Hlk153805375"} }
const _hoisted_1512 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt","mso-fareast-language":"EN-US"}
}
const _hoisted_1513 = {
  width: "62%",
  style: {"width":"62.28%","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid windowtext 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1514 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"2.1pt","mso-para-margin-top":"0mm","mso-para-margin-right":"-0.75pt","mso-para-margin-bottom":"0.0001pt","mso-para-margin-left":"0.02gd","text-indent":"-1.9pt","mso-char-indent-count":"-0.18","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1515 = { style: {"mso-bookmark":"_Hlk153805375"} }
const _hoisted_1516 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_1517 = { lang: "EN-US" }
const _hoisted_1518 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"2.1pt","mso-para-margin-top":"0mm","mso-para-margin-right":"-0.75pt","mso-para-margin-bottom":"0.0001pt","mso-para-margin-left":"0.02gd","text-indent":"-1.9pt","mso-char-indent-count":"-0.18","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1519 = { style: {"mso-bookmark":"_Hlk153805375"} }
const _hoisted_1520 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_1521 = { lang: "EN-US" }
const _hoisted_1522 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"2.1pt","mso-para-margin-top":"0mm","mso-para-margin-right":"-0.75pt","mso-para-margin-bottom":"0.0001pt","mso-para-margin-left":"0.02gd","text-indent":"-1.9pt","mso-char-indent-count":"-0.18","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1523 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805375"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }, "地理院タイルのご利用について ")
], -1))
const _hoisted_1524 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805375"} }, null, -1))
const _hoisted_1525 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://maps.gsi.go.jp/development/ichiran.html" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805375"} }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","color":"windowtext"}
    }, "https://maps.gsi.go.jp/development/ichiran.html")
  ]),
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805375"} })
], -1))
const _hoisted_1526 = { style: {"mso-bookmark":"_Hlk153805375"} }
const _hoisted_1527 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1528 = { style: {"mso-yfti-irow":"4","height":"1pt"} }
const _hoisted_1529 = {
  width: "37%",
  style: {"width":"37.72%","border":"solid windowtext 1pt","border-top":"none","mso-border-top-alt":"solid windowtext 0.5pt","mso-border-alt":"solid windowtext 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1530 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1531 = { style: {"mso-bookmark":"_Hlk153805375"} }
const _hoisted_1532 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }
const _hoisted_1533 = { lang: "EN-US" }
const _hoisted_1534 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1535 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805375"} }, [
  /*#__PURE__*/_createElementVNode("span", {
    lang: "EN-US",
    style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"}
  }, "(CSIS")
], -1))
const _hoisted_1536 = { style: {"mso-bookmark":"_Hlk153805375"} }
const _hoisted_1537 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }
const _hoisted_1538 = { lang: "EN-US" }
const _hoisted_1539 = {
  width: "62%",
  style: {"width":"62.28%","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid windowtext 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1540 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"2.1pt","mso-para-margin-top":"0mm","mso-para-margin-right":"-0.75pt","mso-para-margin-bottom":"0.0001pt","mso-para-margin-left":"0.02gd","text-indent":"-1.9pt","mso-char-indent-count":"-0.18","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1541 = { style: {"mso-bookmark":"_Hlk153805375"} }
const _hoisted_1542 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_1543 = { lang: "EN-US" }
const _hoisted_1544 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"2.1pt","mso-para-margin-top":"0mm","mso-para-margin-right":"-0.75pt","mso-para-margin-bottom":"0.0001pt","mso-para-margin-left":"0.02gd","text-indent":"-1.9pt","mso-char-indent-count":"-0.18","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1545 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805375"} }, [
  /*#__PURE__*/_createElementVNode("a", { name: "_Hlk154050946" })
], -1))
const _hoisted_1546 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://geocode.csis.u-tokyo.ac.jp/home/simple-geocoding/simple-geocoding-tems-of-use/" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805375"} }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk154050946"} }, [
      /*#__PURE__*/_createElementVNode("span", {
        lang: "EN-US",
        style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","color":"windowtext"}
      }, "https://geocode.csis.u-tokyo.ac.jp/home/simple-geocoding/simple-geocoding-tems-of-use/")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805375"} }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk154050946"} })
  ])
], -1))
const _hoisted_1547 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805375"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk154050946"} }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"}
    })
  ])
], -1))
const _hoisted_1548 = { style: {"mso-bookmark":"_Hlk153805375"} }
const _hoisted_1549 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1550 = { style: {"mso-yfti-irow":"5","mso-yfti-lastrow":"yes","height":"1pt"} }
const _hoisted_1551 = {
  width: "37%",
  style: {"width":"37.72%","border":"solid windowtext 1pt","border-top":"none","mso-border-top-alt":"solid windowtext 0.5pt","mso-border-alt":"solid windowtext 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1552 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1553 = { style: {"mso-bookmark":"_Hlk153805375"} }
const _hoisted_1554 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }
const _hoisted_1555 = { lang: "EN-US" }
const _hoisted_1556 = {
  width: "62%",
  style: {"width":"62.28%","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid windowtext 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1557 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"2.1pt","mso-para-margin-top":"0mm","mso-para-margin-right":"-0.75pt","mso-para-margin-bottom":"0.0001pt","mso-para-margin-left":"0.02gd","text-indent":"-1.9pt","mso-char-indent-count":"-0.18","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1558 = { style: {"mso-bookmark":"_Hlk153805375"} }
const _hoisted_1559 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_1560 = { lang: "EN-US" }
const _hoisted_1561 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"56.05pt"}
}
const _hoisted_1562 = { style: {"mso-bookmark":"_Hlk153805375"} }
const _hoisted_1563 = { name: "_Hlk153813558" }
const _hoisted_1564 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1565 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153805375"} }, null, -1))
const _hoisted_1566 = { style: {"margin-right":"-0.05pt"} }
const _hoisted_1567 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153813558"} }, [
  /*#__PURE__*/_createElementVNode("a", { name: "_Toc221547771" }),
  /*#__PURE__*/_createElementVNode("a", { name: "_Toc153814575" }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547771"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt"} }, [
        /*#__PURE__*/_createTextVNode("○別表"),
        /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "3")
      ])
    ])
  ])
], -1))
const _hoisted_1568 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153813558"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc153814575"} }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547771"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }, "第三者に権利があることを表示・示唆している場合の例")
    ])
  ])
], -1))
const _hoisted_1569 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153813558"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc153814575"} }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547771"} }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt"} }, "（第７条５項関係）")
    ])
  ])
], -1))
const _hoisted_1570 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547771"} }, null, -1))
const _hoisted_1571 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc153814575"} }, null, -1))
const _hoisted_1572 = { style: {"mso-bookmark":"_Hlk153813558"} }
const _hoisted_1573 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1574 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"56.05pt"}
}
const _hoisted_1575 = { style: {"mso-bookmark":"_Hlk153813558"} }
const _hoisted_1576 = { style: {"font-family":"'ＭＳ ゴシック'"} }
const _hoisted_1577 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"letter-spacing":"-0.35pt"} }, "第三者に権利があることを表示・示唆している", -1))
const _hoisted_1578 = { lang: "EN-US" }
const _hoisted_1579 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"56.05pt"}
}
const _hoisted_1580 = { style: {"mso-bookmark":"_Hlk153813558"} }
const _hoisted_1581 = { style: {"font-family":"'ＭＳ ゴシック'"} }
const _hoisted_1582 = { lang: "EN-US" }
const _hoisted_1583 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153813558"} }, null, -1))
const _hoisted_1584 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153813558"} }, null, -1))
const _hoisted_1585 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153813558"} }, null, -1))
const _hoisted_1586 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153813558"} }, null, -1))
const _hoisted_1587 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153813558"} }, null, -1))
const _hoisted_1588 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153813558"} }, null, -1))
const _hoisted_1589 = {
  class: "TableNormal",
  border: "1",
  cellspacing: "0",
  cellpadding: "0",
  align: "left",
  width: "96%",
  style: {"width":"96.88%","border-collapse":"collapse","border":"none","mso-border-alt":"solid black 0.5pt","mso-yfti-tbllook":"480","mso-table-lspace":"7.1pt","margin-left":"5.6pt","mso-table-rspace":"7.1pt","margin-right":"5.6pt","mso-table-anchor-vertical":"paragraph","mso-table-anchor-horizontal":"margin","mso-table-left":"21pt","mso-table-top":"4.8pt","mso-padding-alt":"0mm 0mm 0mm 0mm","mso-border-insideh":"0.5pt solid black","mso-border-insidev":"0.5pt solid black"}
}
const _hoisted_1590 = { style: {"mso-yfti-irow":"0","mso-yfti-firstrow":"yes","height":"17.95pt"} }
const _hoisted_1591 = {
  width: "37%",
  valign: "top",
  style: {"width":"37.72%","border":"solid black 1pt","mso-border-alt":"solid black 0.5pt","background":"#bebebe","padding":"0mm 0mm 0mm 0mm","height":"17.95pt"}
}
const _hoisted_1592 = {
  class: "TableParagraph",
  align: "center",
  style: {"margin-top":"0mm","margin-right":"37.8pt","margin-bottom":"0.0001pt","margin-left":"38.3pt","text-align":"center","line-height":"17pt","mso-line-height-rule":"exactly","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1593 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153813558"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }, "データ")
], -1))
const _hoisted_1594 = { style: {"mso-bookmark":"_Hlk153813558"} }
const _hoisted_1595 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","mso-fareast-language":"EN-US"}
}
const _hoisted_1596 = {
  width: "62%",
  valign: "top",
  style: {"width":"62.28%","border":"solid black 1pt","border-left":"none","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","background":"#bebebe","padding":"0mm 0mm 0mm 0mm","height":"17.95pt"}
}
const _hoisted_1597 = {
  class: "TableParagraph",
  align: "center",
  style: {"margin-top":"0mm","margin-right":"37.8pt","margin-bottom":"0.0001pt","margin-left":"38.3pt","text-align":"center","line-height":"17pt","mso-line-height-rule":"exactly","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1598 = { style: {"mso-bookmark":"_Hlk153813558"} }
const _hoisted_1599 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.25pt"} }
const _hoisted_1600 = { lang: "EN-US" }
const _hoisted_1601 = { style: {"mso-yfti-irow":"1","height":"1pt"} }
const _hoisted_1602 = {
  width: "37%",
  style: {"width":"37.72%","border-top":"none","border-left":"solid black 1pt","border-bottom":"solid windowtext 1pt","border-right":"solid black 1pt","mso-border-left-alt":"solid black 0.5pt","mso-border-bottom-alt":"solid windowtext 0.5pt","mso-border-right-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1603 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1604 = { style: {"mso-bookmark":"_Hlk153813558"} }
const _hoisted_1605 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }
const _hoisted_1606 = { lang: "EN-US" }
const _hoisted_1607 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1608 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153813558"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }, "（全国道路施設点検データベース）")
], -1))
const _hoisted_1609 = { style: {"mso-bookmark":"_Hlk153813558"} }
const _hoisted_1610 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1611 = {
  width: "62%",
  style: {"width":"62.28%","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1612 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"2.1pt","mso-para-margin-top":"0mm","mso-para-margin-right":"-0.75pt","mso-para-margin-bottom":"0.0001pt","mso-para-margin-left":"0.02gd","text-indent":"-1.9pt","mso-char-indent-count":"-0.18","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1613 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153813558"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }, "参考：全国道路施設点検データベースの「データ閲覧・取得」に関する利用規約")
], -1))
const _hoisted_1614 = { style: {"mso-bookmark":"_Hlk153813558"} }
const _hoisted_1615 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1616 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1617 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153813558"} }, [
  /*#__PURE__*/_createElementVNode("span", {
    lang: "EN-US",
    style: {"mso-fareast-language":"EN-US"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"mso-field-code":"' HYPERLINK '"} })
  ])
], -1))
const _hoisted_1618 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://rirs.or.jp/tenken-db/pdf/view/etsuran_kiyaku.pdf" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153813558"} }, [
    /*#__PURE__*/_createElementVNode("span", {
      lang: "EN-US",
      style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","color":"black","mso-themecolor":"text1","mso-fareast-language":"EN-US"}
    }, "https://rirs.or.jp/tenken-db/pdf/view/etsuran_kiyaku.pdf")
  ])
], -1))
const _hoisted_1619 = { style: {"mso-bookmark":"_Hlk153813558"} }
const _hoisted_1620 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","color":"black","mso-themecolor":"text1"}
}
const _hoisted_1621 = { style: {"mso-yfti-irow":"2","mso-yfti-lastrow":"yes","height":"1pt"} }
const _hoisted_1622 = {
  width: "37%",
  style: {"width":"37.72%","border":"solid windowtext 1pt","border-top":"none","mso-border-top-alt":"solid windowtext 0.5pt","mso-border-alt":"solid windowtext 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1623 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1624 = { style: {"mso-bookmark":"_Hlk153813558"} }
const _hoisted_1625 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt","mso-fareast-language":"EN-US"}
}
const _hoisted_1626 = {
  width: "62%",
  style: {"width":"62.28%","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid windowtext 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1627 = {
  class: "TableParagraph",
  style: {"margin-left":"2.1pt","mso-para-margin-left":"0.02gd","text-indent":"-1.9pt","mso-char-indent-count":"-0.18","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1628 = { style: {"mso-bookmark":"_Hlk153813558"} }
const _hoisted_1629 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }
const _hoisted_1630 = { lang: "EN-US" }
const _hoisted_1631 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"2.1pt","mso-para-margin-top":"0mm","mso-para-margin-right":"-0.75pt","mso-para-margin-bottom":"0.0001pt","mso-para-margin-left":"0.02gd","text-indent":"-1.9pt","mso-char-indent-count":"-0.18","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1632 = { style: {"mso-bookmark":"_Hlk153813558"} }
const _hoisted_1633 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt","mso-fareast-language":"EN-US"}
}
const _hoisted_1634 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Hlk153813558"} }, null, -1))
const _hoisted_1635 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"56.05pt"}
}
const _hoisted_1636 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1637 = { style: {"margin-right":"-0.05pt"} }
const _hoisted_1638 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc221547772" }, null, -1))
const _hoisted_1639 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_Toc153814576" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547772"} }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt"} }, [
      /*#__PURE__*/_createTextVNode("○別表"),
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "4")
    ])
  ])
], -1))
const _hoisted_1640 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc153814576"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547772"} }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.35pt"} }, [
      /*#__PURE__*/_createTextVNode("外部データベース等との"),
      /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "API"),
      /*#__PURE__*/_createTextVNode("連携等により取得しているコンテンツ")
    ])
  ])
], -1))
const _hoisted_1641 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc153814576"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547772"} }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'ＭＳ ゴシック'","letter-spacing":"0.15pt"} }, "（第７条６項関係）")
  ])
], -1))
const _hoisted_1642 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc221547772"} }, null, -1))
const _hoisted_1643 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"mso-bookmark":"_Toc153814576"} }, null, -1))
const _hoisted_1644 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1645 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"56.05pt"}
}
const _hoisted_1646 = { style: {"font-family":"'ＭＳ ゴシック'"} }
const _hoisted_1647 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "API", -1))
const _hoisted_1648 = { lang: "EN-US" }
const _hoisted_1649 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"56.05pt"}
}
const _hoisted_1650 = { style: {"font-family":"'ＭＳ ゴシック'"} }
const _hoisted_1651 = { lang: "EN-US" }
const _hoisted_1652 = {
  class: "TableNormal",
  border: "1",
  cellspacing: "0",
  cellpadding: "0",
  align: "left",
  width: "96%",
  style: {"width":"96.88%","border-collapse":"collapse","border":"none","mso-border-alt":"solid black 0.5pt","mso-yfti-tbllook":"480","mso-table-lspace":"7.1pt","margin-left":"5.6pt","mso-table-rspace":"7.1pt","margin-right":"5.6pt","mso-table-anchor-vertical":"paragraph","mso-table-anchor-horizontal":"margin","mso-table-left":"21pt","mso-table-top":"4.8pt","mso-padding-alt":"0mm 0mm 0mm 0mm","mso-border-insideh":"0.5pt solid black","mso-border-insidev":"0.5pt solid black"}
}
const _hoisted_1653 = { style: {"mso-yfti-irow":"0","mso-yfti-firstrow":"yes","height":"17.95pt"} }
const _hoisted_1654 = {
  width: "37%",
  valign: "top",
  style: {"width":"37.72%","border":"solid black 1pt","mso-border-alt":"solid black 0.5pt","background":"#bebebe","padding":"0mm 0mm 0mm 0mm","height":"17.95pt"}
}
const _hoisted_1655 = {
  class: "TableParagraph",
  align: "center",
  style: {"margin-top":"0mm","margin-right":"37.8pt","margin-bottom":"0.0001pt","margin-left":"38.3pt","text-align":"center","line-height":"17pt","mso-line-height-rule":"exactly","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1656 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }, "データ", -1))
const _hoisted_1657 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","mso-fareast-language":"EN-US"}
}
const _hoisted_1658 = {
  width: "62%",
  valign: "top",
  style: {"width":"62.28%","border":"solid black 1pt","border-left":"none","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","background":"#bebebe","padding":"0mm 0mm 0mm 0mm","height":"17.95pt"}
}
const _hoisted_1659 = {
  class: "TableParagraph",
  align: "center",
  style: {"margin-top":"0mm","margin-right":"37.8pt","margin-bottom":"0.0001pt","margin-left":"38.3pt","text-align":"center","line-height":"17pt","mso-line-height-rule":"exactly","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1660 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.25pt"} }, [
  /*#__PURE__*/_createTextVNode("参考"),
  /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "URL"),
  /*#__PURE__*/_createTextVNode("等")
], -1))
const _hoisted_1661 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.25pt","mso-fareast-language":"EN-US"}
}
const _hoisted_1662 = { style: {"mso-yfti-irow":"1","height":"1pt"} }
const _hoisted_1663 = {
  width: "37%",
  style: {"width":"37.72%","border":"solid black 1pt","border-top":"none","mso-border-top-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1664 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1665 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }, "交通量データ", -1))
const _hoisted_1666 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt","mso-fareast-language":"EN-US"}
}
const _hoisted_1667 = {
  width: "62%",
  style: {"width":"62.28%","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1668 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1669 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }
const _hoisted_1670 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "API", -1))
const _hoisted_1671 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "(", -1))
const _hoisted_1672 = { lang: "EN-US" }
const _hoisted_1673 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1674 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"mso-fareast-language":"EN-US"}
}, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://www.jartic-open-traffic.org/" }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","color":"windowtext","letter-spacing":"-0.05pt"} }, "https://www.jartic-open-traffic.org/")
  ])
], -1))
const _hoisted_1675 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"}
}
const _hoisted_1676 = { style: {"mso-yfti-irow":"2","height":"1pt"} }
const _hoisted_1677 = {
  width: "37%",
  style: {"width":"37.72%","border":"solid black 1pt","border-top":"none","mso-border-top-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1678 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1679 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }
const _hoisted_1680 = { lang: "EN-US" }
const _hoisted_1681 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1682 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }, "（全国道路施設点検データベース）", -1))
const _hoisted_1683 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1684 = {
  width: "62%",
  style: {"width":"62.28%","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1685 = {
  class: "TableParagraph",
  style: {"margin-left":"1.75pt","mso-para-margin-left":"0.15gd","text-indent":"-0.1pt","mso-char-indent-count":"-0.01","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1686 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }
const _hoisted_1687 = { lang: "EN-US" }
const _hoisted_1688 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1689 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"mso-fareast-language":"EN-US"}
}, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://road-structures-db.mlit.go.jp/" }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","color":"windowtext","letter-spacing":"-0.05pt"} }, "https://road-structures-db.mlit.go.jp/")
  ])
], -1))
const _hoisted_1690 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1691 = { style: {"mso-yfti-irow":"3","height":"1pt"} }
const _hoisted_1692 = {
  width: "37%",
  style: {"width":"37.72%","border":"solid black 1pt","border-top":"none","mso-border-left-alt":"solid black 0.5pt","mso-border-bottom-alt":"solid black 0.5pt","mso-border-right-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1693 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1694 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1695 = {
  width: "62%",
  style: {"width":"62.28%","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1696 = {
  class: "TableParagraph",
  style: {"margin-left":"1.75pt","mso-para-margin-left":"0.15gd","text-indent":"-0.1pt","mso-char-indent-count":"-0.01","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1697 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"}
}, "DRM-DB", -1))
const _hoisted_1698 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }
const _hoisted_1699 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "(", -1))
const _hoisted_1700 = { lang: "EN-US" }
const _hoisted_1701 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1702 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"mso-fareast-language":"EN-US"}
}, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://pf.drm.jp/FreeViewer/" }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","color":"windowtext","letter-spacing":"-0.05pt","mso-fareast-language":"JA"} }, "https://pf.drm.jp/FreeViewer/")
  ])
], -1))
const _hoisted_1703 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"0.35pt","mso-fareast-language":"EN-US"}
}
const _hoisted_1704 = { style: {"mso-yfti-irow":"4","height":"1pt"} }
const _hoisted_1705 = {
  width: "37%",
  style: {"width":"37.72%","border":"solid black 1pt","border-top":"none","mso-border-left-alt":"solid black 0.5pt","mso-border-bottom-alt":"solid black 0.5pt","mso-border-right-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1706 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1707 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }, "地理院地図", -1))
const _hoisted_1708 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","mso-fareast-language":"EN-US"}
}
const _hoisted_1709 = {
  width: "62%",
  style: {"width":"62.28%","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1710 = {
  class: "TableParagraph",
  style: {"margin-left":"1.75pt","mso-para-margin-left":"0.15gd","text-indent":"-0.1pt","mso-char-indent-count":"-0.01","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1711 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_1712 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { lang: "EN-US" }, "(", -1))
const _hoisted_1713 = { lang: "EN-US" }
const _hoisted_1714 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1715 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"mso-fareast-language":"EN-US"}
}, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://maps.gsi.go.jp/development/ichiran.html" }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","color":"windowtext","mso-fareast-language":"JA"} }, "https://maps.gsi.go.jp/development/ichiran.html")
  ])
], -1))
const _hoisted_1716 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","mso-fareast-language":"EN-US"}
}
const _hoisted_1717 = { style: {"mso-yfti-irow":"5","mso-yfti-lastrow":"yes","height":"1pt"} }
const _hoisted_1718 = {
  width: "37%",
  style: {"width":"37.72%","border":"solid black 1pt","border-top":"none","mso-border-left-alt":"solid black 0.5pt","mso-border-bottom-alt":"solid black 0.5pt","mso-border-right-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1719 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1720 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"} }
const _hoisted_1721 = { lang: "EN-US" }
const _hoisted_1722 = {
  width: "62%",
  style: {"width":"62.28%","border-top":"none","border-left":"none","border-bottom":"solid black 1pt","border-right":"solid black 1pt","mso-border-top-alt":"solid black 0.5pt","mso-border-left-alt":"solid black 0.5pt","mso-border-alt":"solid black 0.5pt","padding":"1.4pt 1.4pt 1.4pt 1.4pt","height":"1pt"}
}
const _hoisted_1723 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"4.3pt","margin-bottom":"0.0001pt","margin-left":"1.75pt","mso-para-margin-top":"0mm","mso-para-margin-right":"4.3pt","mso-para-margin-bottom":"0.0001pt","mso-para-margin-left":"0.15gd","text-align":"justify","text-justify":"inter-ideograph","text-indent":"-0.1pt","mso-char-indent-count":"-0.01","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1724 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"}
}, "CSIS", -1))
const _hoisted_1725 = { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","letter-spacing":"-0.05pt"} }
const _hoisted_1726 = { lang: "EN-US" }
const _hoisted_1727 = {
  class: "TableParagraph",
  style: {"margin-top":"0mm","margin-right":"-0.75pt","margin-bottom":"0.0001pt","margin-left":"0mm","mso-element":"frame","mso-element-frame-hspace":"7.1pt","mso-element-wrap":"around","mso-element-anchor-vertical":"paragraph","mso-element-anchor-horizontal":"margin","mso-element-left":"21.05pt","mso-element-top":"4.8pt","mso-height-rule":"exactly"}
}
const _hoisted_1728 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  lang: "EN-US",
  style: {"mso-fareast-language":"EN-US"}
}, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://geocode.csis.u-tokyo.ac.jp/" }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'","color":"windowtext","letter-spacing":"-0.05pt","mso-fareast-language":"JA"} }, "https://geocode.csis.u-tokyo.ac.jp/")
  ])
], -1))
const _hoisted_1729 = {
  lang: "EN-US",
  style: {"font-size":"10.5pt","mso-bidi-font-size":"11pt","font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1730 = {
  class: "MsoBodyText",
  style: {"margin-top":"0mm","margin-right":"-0.05pt","margin-bottom":"0.0001pt","margin-left":"56.05pt"}
}
const _hoisted_1731 = {
  lang: "EN-US",
  style: {"font-family":"'ＭＳ ゴシック'"}
}
const _hoisted_1732 = { class: "terms-condition-button-area" }
const _hoisted_1733 = { class: "confirm-button" }
const _hoisted_1734 = { class: "cancel-text" }
const _hoisted_1735 = ["href"]

import { PopupWindow, ButtonItem } from "@/components/modules";
import { ref } from "vue";
import { ScrollContent } from "@/components/modules";


export default /*#__PURE__*/_defineComponent({
  __name: 'terms-condition',
  emits: ["close"],
  setup(__props, { emit }) {



/**
 * タイトル
 */
const title = ref("利用規約");

/**
 * ポータルサイトURL
 */
const portalUrl = process.env.VUE_APP_PORTAL_URL;

/**
 * 表示位置
 */
const style = ref({
  top: (document.documentElement.scrollHeight - 420) / 2 + "px",
  left: (document.documentElement.scrollWidth - 900) / 2 + "px",
});

/**
 * 同意する選択時
 */
const confirm = () => {
  const date = new Date();
  const limit = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    23,
    59,
    59
  );
  document.cookie =
    "TermsCondeition = Confirmed; Secure; Expires = " + limit.toUTCString();
  emit("close");
};

return (_ctx: any,_cache: any) => {
  const _component_o58p = _resolveComponent("o:p")!
  const _component_w58sdtpr = _resolveComponent("w:sdtpr")!
  const _component_w58sdt = _resolveComponent("w:sdt")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_unref(PopupWindow), {
      "data-html2canvas-ignore": "",
      title: title.value,
      width: "900px",
      windowId: "termsCondition",
      draggable: false,
      noPadding: true,
      style: _normalizeStyle(style.value),
      hideClose: true
    }, {
      "main-content": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(ScrollContent), { height: '280px' }, {
            default: _withCtx(() => [
              _createElementVNode("body", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("p", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, [
                      _createTextVNode("道路データプラットフォーム"),
                      _createElementVNode("span", _hoisted_7, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, [
                      _createTextVNode("データビューア利用規約"),
                      _createElementVNode("span", _hoisted_10, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("span", _hoisted_13, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("span", _hoisted_18, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("span", _hoisted_23, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_24, [
                    _createElementVNode("span", _hoisted_25, [
                      _createTextVNode("改定：令和８年３月"),
                      _createElementVNode("span", _hoisted_26, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ])
                ]),
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("p", _hoisted_29, [
                    _createElementVNode("span", _hoisted_30, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_31, [
                    _hoisted_32,
                    _createElementVNode("span", _hoisted_33, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createVNode(_component_w58sdt, {
                    sdtdocpart: "t",
                    docparttype: "Table of Contents",
                    docpartunique: "t",
                    id: "-238710386"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_34, [
                        _hoisted_35,
                        _createElementVNode("span", _hoisted_36, [
                          _createVNode(_component_o58p)
                        ]),
                        _createElementVNode("span", _hoisted_37, [
                          _createVNode(_component_w58sdtpr)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_38, [
                        _hoisted_39,
                        _createElementVNode("span", _hoisted_40, [
                          _createVNode(_component_o58p)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_41, [
                        _hoisted_42,
                        _createElementVNode("span", _hoisted_43, [
                          _createVNode(_component_o58p)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_44, [
                        _hoisted_45,
                        _createElementVNode("span", _hoisted_46, [
                          _createVNode(_component_o58p)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_47, [
                        _hoisted_48,
                        _createElementVNode("span", _hoisted_49, [
                          _createVNode(_component_o58p)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_50, [
                        _hoisted_51,
                        _createElementVNode("span", _hoisted_52, [
                          _createVNode(_component_o58p)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_53, [
                        _hoisted_54,
                        _createElementVNode("span", _hoisted_55, [
                          _createVNode(_component_o58p)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_56, [
                        _hoisted_57,
                        _createElementVNode("span", _hoisted_58, [
                          _createVNode(_component_o58p)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_59, [
                        _hoisted_60,
                        _createElementVNode("span", _hoisted_61, [
                          _createVNode(_component_o58p)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_62, [
                        _hoisted_63,
                        _createElementVNode("span", _hoisted_64, [
                          _createVNode(_component_o58p)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_65, [
                        _hoisted_66,
                        _createElementVNode("span", _hoisted_67, [
                          _createVNode(_component_o58p)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_68, [
                        _hoisted_69,
                        _createElementVNode("span", _hoisted_70, [
                          _createVNode(_component_o58p)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_71, [
                        _hoisted_72,
                        _createElementVNode("span", _hoisted_73, [
                          _createVNode(_component_o58p)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_74, [
                        _hoisted_75,
                        _createElementVNode("span", _hoisted_76, [
                          _createVNode(_component_o58p)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_77, [
                        _hoisted_78,
                        _createElementVNode("span", _hoisted_79, [
                          _createVNode(_component_o58p)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_80, [
                        _hoisted_81,
                        _createElementVNode("span", _hoisted_82, [
                          _createVNode(_component_o58p)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_83, [
                        _hoisted_84,
                        _createElementVNode("span", _hoisted_85, [
                          _createVNode(_component_o58p)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_86, [
                        _hoisted_87,
                        _createElementVNode("span", _hoisted_88, [
                          _createVNode(_component_o58p)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_89, [
                        _hoisted_90,
                        _createElementVNode("span", _hoisted_91, [
                          _createVNode(_component_o58p)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_92, [
                        _hoisted_93,
                        _createElementVNode("span", _hoisted_94, [
                          _createVNode(_component_o58p)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_95, [
                        _hoisted_96,
                        _createElementVNode("span", _hoisted_97, [
                          _createVNode(_component_o58p)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_98, [
                        _hoisted_99,
                        _createElementVNode("span", _hoisted_100, [
                          _createVNode(_component_o58p)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_101, [
                        _hoisted_102,
                        _createElementVNode("span", _hoisted_103, [
                          _createVNode(_component_o58p)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_104, [
                        _hoisted_105,
                        _createElementVNode("span", _hoisted_106, [
                          _createVNode(_component_o58p)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_107, [
                        _hoisted_108,
                        _createElementVNode("span", _hoisted_109, [
                          _createVNode(_component_o58p)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_110, [
                        _hoisted_111,
                        _createElementVNode("span", _hoisted_112, [
                          _createVNode(_component_o58p)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_113, [
                        _hoisted_114,
                        _createElementVNode("span", _hoisted_115, [
                          _createVNode(_component_o58p)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_116, [
                        _hoisted_117,
                        _createElementVNode("span", _hoisted_118, [
                          _createVNode(_component_o58p)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_119, [
                        _hoisted_120,
                        _createElementVNode("span", _hoisted_121, [
                          _createVNode(_component_o58p)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_122, [
                        _hoisted_123,
                        _createElementVNode("span", _hoisted_124, [
                          _createVNode(_component_o58p)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_125, [
                        _hoisted_126,
                        _createElementVNode("span", _hoisted_127, [
                          _createVNode(_component_o58p)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_128, [
                        _hoisted_129,
                        _createElementVNode("span", _hoisted_130, [
                          _createVNode(_component_o58p)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_131, [
                        _createElementVNode("span", _hoisted_132, [
                          _createVNode(_component_o58p, null, {
                            default: _withCtx(() => [
                              _createTextVNode(" ")
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_133, [
                  _hoisted_134,
                  _createElementVNode("p", _hoisted_135, [
                    _hoisted_136,
                    _createElementVNode("span", _hoisted_137, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_138, [
                    _hoisted_139,
                    _createElementVNode("span", _hoisted_140, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_141, [
                    _createElementVNode("span", _hoisted_142, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("h1", _hoisted_143, [
                    _hoisted_144,
                    _hoisted_145,
                    _hoisted_146,
                    _hoisted_147,
                    _createElementVNode("span", _hoisted_148, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_149, [
                    _createElementVNode("span", _hoisted_150, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("h2", _hoisted_151, [
                    _hoisted_152,
                    _hoisted_153,
                    _hoisted_154,
                    _hoisted_155,
                    _createElementVNode("span", _hoisted_156, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_157, [
                    _hoisted_158,
                    _hoisted_159,
                    _createElementVNode("span", _hoisted_160, [
                      _createTextVNode("）において、次の用語は、特に断りのない限り次の意味を有します。"),
                      _hoisted_161,
                      _createElementVNode("span", _hoisted_162, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _hoisted_163,
                  _hoisted_164,
                  _hoisted_165,
                  _hoisted_166,
                  _hoisted_167,
                  _hoisted_168,
                  _hoisted_169,
                  _hoisted_170,
                  _hoisted_171,
                  _hoisted_172,
                  _hoisted_173,
                  _hoisted_174,
                  _hoisted_175,
                  _hoisted_176,
                  _hoisted_177,
                  _hoisted_178,
                  _hoisted_179,
                  _hoisted_180,
                  _hoisted_181,
                  _hoisted_182,
                  _hoisted_183,
                  _hoisted_184,
                  _hoisted_185,
                  _hoisted_186,
                  _hoisted_187,
                  _hoisted_188,
                  _hoisted_189,
                  _hoisted_190,
                  _hoisted_191,
                  _hoisted_192,
                  _createElementVNode("table", _hoisted_193, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", _hoisted_194, [
                        _createElementVNode("td", _hoisted_195, [
                          _createElementVNode("p", _hoisted_196, [
                            _hoisted_197,
                            _createElementVNode("span", _hoisted_198, [
                              _createElementVNode("span", _hoisted_199, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_200, [
                          _createElementVNode("p", _hoisted_201, [
                            _createElementVNode("span", _hoisted_202, [
                              _createElementVNode("span", _hoisted_203, [
                                _createTextVNode("意味"),
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_204, [
                        _createElementVNode("td", _hoisted_205, [
                          _createElementVNode("p", _hoisted_206, [
                            _hoisted_207,
                            _createElementVNode("span", _hoisted_208, [
                              _createElementVNode("span", _hoisted_209, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_210, [
                          _createElementVNode("p", _hoisted_211, [
                            _createElementVNode("span", _hoisted_212, [
                              _createElementVNode("span", _hoisted_213, [
                                _createTextVNode("国土交通省が推進する道路システムの"),
                                _hoisted_214,
                                _createTextVNode("の取組「"),
                                _hoisted_215,
                                _createTextVNode("」の一環として、道路に関するデータを一元的に利活用するため、国土交通省道路局が整備するデータプラットフォームです。"),
                                _createElementVNode("span", _hoisted_216, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_217, [
                        _createElementVNode("td", _hoisted_218, [
                          _createElementVNode("p", _hoisted_219, [
                            _createElementVNode("span", _hoisted_220, [
                              _createElementVNode("span", _hoisted_221, [
                                _createTextVNode("道路データプラットフォームデータビューア"),
                                _createElementVNode("span", _hoisted_222, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_223, [
                          _createElementVNode("p", _hoisted_224, [
                            _createElementVNode("span", _hoisted_225, [
                              _createElementVNode("span", _hoisted_226, [
                                _createTextVNode("道路データプラットフォームにおいて連携するデータの利活用等を促進する目的で、データを地図上で表示する等の機能を有した"),
                                _hoisted_227,
                                _createTextVNode("アプリケーションであり、本規約の適用対象です。"),
                                _createElementVNode("span", _hoisted_228, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_229, [
                        _createElementVNode("td", _hoisted_230, [
                          _createElementVNode("p", _hoisted_231, [
                            _createElementVNode("span", _hoisted_232, [
                              _createElementVNode("span", _hoisted_233, [
                                _createTextVNode("道路データプラットフォームポータルサイト"),
                                _createElementVNode("span", _hoisted_234, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_235, [
                          _createElementVNode("p", _hoisted_236, [
                            _createElementVNode("span", _hoisted_237, [
                              _createElementVNode("span", _hoisted_238, [
                                _createTextVNode("データの利活用等を促進する目的で、道路に関するデータやデータを提供するシステム、データを利用するアプリ等を利用者に紹介する"),
                                _hoisted_239,
                                _createTextVNode("サイトです。国土交通省道路局が管理します。（ポータルサイトをご利用される際は別途定める利用規約に同意のうえご利用ください）"),
                                _createElementVNode("span", _hoisted_240, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_241, [
                            _hoisted_242,
                            _hoisted_243,
                            _createElementVNode("span", _hoisted_244, [
                              _createElementVNode("span", _hoisted_245, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_246, [
                        _createElementVNode("td", _hoisted_247, [
                          _createElementVNode("p", _hoisted_248, [
                            _hoisted_249,
                            _createElementVNode("span", _hoisted_250, [
                              _createElementVNode("span", _hoisted_251, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_252, [
                          _createElementVNode("p", _hoisted_253, [
                            _hoisted_254,
                            _createElementVNode("span", _hoisted_255, [
                              _createElementVNode("span", _hoisted_256, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_257, [
                        _createElementVNode("td", _hoisted_258, [
                          _createElementVNode("p", _hoisted_259, [
                            _hoisted_260,
                            _createElementVNode("span", _hoisted_261, [
                              _createElementVNode("span", _hoisted_262, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_263, [
                          _createElementVNode("p", _hoisted_264, [
                            _createElementVNode("span", _hoisted_265, [
                              _createElementVNode("span", _hoisted_266, [
                                _createTextVNode("管理者が本ビューアを介してコンテンツを提供する役務をいいます。"),
                                _createElementVNode("span", _hoisted_267, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_268, [
                        _createElementVNode("td", _hoisted_269, [
                          _createElementVNode("p", _hoisted_270, [
                            _hoisted_271,
                            _createElementVNode("span", _hoisted_272, [
                              _createElementVNode("span", _hoisted_273, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_274, [
                          _createElementVNode("p", _hoisted_275, [
                            _createElementVNode("span", _hoisted_276, [
                              _createElementVNode("span", _hoisted_277, [
                                _createTextVNode("本ビューアで提供している情報すべてをいい、提供者から提供を受けたデータのほか、本ビューアの円滑な運営・利用のために提供される情報を含みます。"),
                                _createElementVNode("span", _hoisted_278, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_279, [
                        _createElementVNode("td", _hoisted_280, [
                          _createElementVNode("p", _hoisted_281, [
                            _hoisted_282,
                            _createElementVNode("span", _hoisted_283, [
                              _createElementVNode("span", _hoisted_284, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_285, [
                          _createElementVNode("p", _hoisted_286, [
                            _createElementVNode("span", _hoisted_287, [
                              _createElementVNode("span", _hoisted_288, [
                                _createTextVNode("提供者からの提供を受けて本ビューアに掲載されたデータをいいます。詳しくは別表"),
                                _hoisted_289,
                                _createTextVNode("をご確認ください。"),
                                _createElementVNode("span", _hoisted_290, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_291, [
                        _createElementVNode("td", _hoisted_292, [
                          _createElementVNode("p", _hoisted_293, [
                            _hoisted_294,
                            _createElementVNode("span", _hoisted_295, [
                              _createElementVNode("span", _hoisted_296, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_297, [
                          _createElementVNode("p", _hoisted_298, [
                            _hoisted_299,
                            _createElementVNode("span", _hoisted_300, [
                              _createElementVNode("span", _hoisted_301, [
                                _createTextVNode("（データの種類等により提供する機能が異なります）"),
                                _createElementVNode("span", _hoisted_302, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_303, [
                        _createElementVNode("td", _hoisted_304, [
                          _createElementVNode("p", _hoisted_305, [
                            _hoisted_306,
                            _createElementVNode("span", _hoisted_307, [
                              _createElementVNode("span", _hoisted_308, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_309, [
                          _createElementVNode("p", _hoisted_310, [
                            _hoisted_311,
                            _hoisted_312,
                            _createElementVNode("span", _hoisted_313, [
                              _createElementVNode("span", _hoisted_314, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_315, [
                        _createElementVNode("td", _hoisted_316, [
                          _createElementVNode("p", _hoisted_317, [
                            _hoisted_318,
                            _createElementVNode("span", _hoisted_319, [
                              _createElementVNode("span", _hoisted_320, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_321, [
                          _createElementVNode("p", _hoisted_322, [
                            _createElementVNode("span", _hoisted_323, [
                              _createElementVNode("span", _hoisted_324, [
                                _createTextVNode("本ビューアの機能を利用する者をいいます。ただし、本ビューアを利用して取得したデータ等を本ビューア以外の場で二次利用する場合は含みません。"),
                                _createElementVNode("span", _hoisted_325, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_326, [
                        _createElementVNode("td", _hoisted_327, [
                          _createElementVNode("p", _hoisted_328, [
                            _hoisted_329,
                            _createElementVNode("span", _hoisted_330, [
                              _createElementVNode("span", _hoisted_331, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_332, [
                          _createElementVNode("p", _hoisted_333, [
                            _createElementVNode("span", _hoisted_334, [
                              _createElementVNode("span", _hoisted_335, [
                                _createTextVNode("本ビューアにコンテンツを提供する管理者以外の者をいいます。"),
                                _createElementVNode("span", _hoisted_336, [
                                  _createTextVNode("詳しくは別表"),
                                  _hoisted_337,
                                  _createTextVNode("をご確認ください。"),
                                  _createElementVNode("span", _hoisted_338, [
                                    _createVNode(_component_o58p)
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_339, [
                        _createElementVNode("td", _hoisted_340, [
                          _createElementVNode("p", _hoisted_341, [
                            _hoisted_342,
                            _createElementVNode("span", _hoisted_343, [
                              _createElementVNode("span", _hoisted_344, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_345, [
                          _createElementVNode("p", _hoisted_346, [
                            _createElementVNode("span", _hoisted_347, [
                              _createElementVNode("span", _hoisted_348, [
                                _createTextVNode("本ビューアを介してデータや機能を利用者に提供し、利用者が求めるデータを閲覧、ダウンロード等することが可能な状態にすることをいいます。（データの種類等により公開の方法（提供する機能）が異なります）"),
                                _createElementVNode("span", _hoisted_349, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_350, [
                        _createElementVNode("td", _hoisted_351, [
                          _createElementVNode("p", _hoisted_352, [
                            _hoisted_353,
                            _createElementVNode("span", _hoisted_354, [
                              _createElementVNode("span", _hoisted_355, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_356, [
                          _createElementVNode("p", _hoisted_357, [
                            _createElementVNode("span", _hoisted_358, [
                              _createElementVNode("span", _hoisted_359, [
                                _createTextVNode("一部のデータ及び機能について、管理者が指定した一部の利用者に限定して公開することをいいます。"),
                                _createElementVNode("span", _hoisted_360, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_361, [
                        _createElementVNode("td", _hoisted_362, [
                          _createElementVNode("p", _hoisted_363, [
                            _hoisted_364,
                            _createElementVNode("span", _hoisted_365, [
                              _createElementVNode("span", _hoisted_366, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_367, [
                          _createElementVNode("p", _hoisted_368, [
                            _createElementVNode("span", _hoisted_369, [
                              _createElementVNode("span", _hoisted_370, [
                                _createTextVNode("限定公開のデータ及び機能を利用するためのユーザー認証に必要な情報（ユーザー"),
                                _hoisted_371,
                                _createTextVNode("とパスワード等）をいいます。"),
                                _createElementVNode("span", _hoisted_372, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_373,
                  _createElementVNode("p", _hoisted_374, [
                    _createElementVNode("span", _hoisted_375, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_376, [
                    _createElementVNode("span", _hoisted_377, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("h2", _hoisted_378, [
                    _hoisted_379,
                    _hoisted_380,
                    _createElementVNode("span", _hoisted_381, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_382, [
                    _hoisted_383,
                    _hoisted_384,
                    _hoisted_385,
                    _hoisted_386,
                    _createElementVNode("span", _hoisted_387, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_388, [
                    _hoisted_389,
                    _hoisted_390,
                    _hoisted_391,
                    _hoisted_392,
                    _hoisted_393,
                    _hoisted_394,
                    _hoisted_395,
                    _hoisted_396,
                    _createElementVNode("span", _hoisted_397, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_398, [
                    _hoisted_399,
                    _hoisted_400,
                    _createElementVNode("span", _hoisted_401, [
                      _createTextVNode("本規約において、年、月、日、時間等は日本の日付表記に従う"),
                      _hoisted_402,
                      _createElementVNode("span", _hoisted_403, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_404, [
                    _hoisted_405,
                    _hoisted_406,
                    _createElementVNode("span", _hoisted_407, [
                      _createTextVNode("本規約において、法令の名称は特に断りがない場合、日本の法令の名称を意味し"),
                      _createElementVNode("span", _hoisted_408, [
                        _createTextVNode("ます。"),
                        _createElementVNode("span", _hoisted_409, [
                          _createVNode(_component_o58p)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_410, [
                    _createElementVNode("span", _hoisted_411, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_412, [
                    _hoisted_413,
                    _hoisted_414,
                    _hoisted_415,
                    _hoisted_416,
                    _hoisted_417,
                    _createElementVNode("span", _hoisted_418, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("h1", _hoisted_419, [
                    _hoisted_420,
                    _hoisted_421,
                    _hoisted_422,
                    _hoisted_423,
                    _hoisted_424,
                    _hoisted_425,
                    _hoisted_426,
                    _createElementVNode("span", _hoisted_427, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_428, [
                    _createElementVNode("span", _hoisted_429, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("h2", _hoisted_430, [
                    _hoisted_431,
                    _hoisted_432,
                    _hoisted_433,
                    _hoisted_434,
                    _createElementVNode("span", _hoisted_435, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_436, [
                    _hoisted_437,
                    _createElementVNode("span", _hoisted_438, [
                      _createTextVNode("本ビューアで公開しているコンテンツは、別の利用ルールが適用されるコンテンツを除き、どなたでも本規約に従って、複製、公衆送信、翻訳・変形等の翻案等、自由に利用でき、商用利用も可能です。"),
                      _createElementVNode("span", _hoisted_439, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_440, [
                    _hoisted_441,
                    _createElementVNode("span", _hoisted_442, [
                      _createTextVNode("利用者は、本ビューアの利用にあたり、本規約への同意が必要となります。本ビューアの利用の開始を以て本規約に同意したものとみなします。"),
                      _createElementVNode("span", _hoisted_443, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_444, [
                    _hoisted_445,
                    _createElementVNode("span", _hoisted_446, [
                      _createTextVNode("本ビューアを利用して、"),
                      _hoisted_447,
                      _createTextVNode("項の「別の利用ルールが適用されるコンテンツ」を利用するにあたっては、利用者は本規約及び当該データの利用ルールの双方に同意する必要があります。当該データについて"),
                      _hoisted_448,
                      _createElementVNode("span", _hoisted_449, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_450, [
                    _createElementVNode("span", _hoisted_451, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("h2", _hoisted_452, [
                    _hoisted_453,
                    _hoisted_454,
                    _createElementVNode("span", _hoisted_455, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_456, [
                    _hoisted_457,
                    _hoisted_458,
                    _createElementVNode("span", _hoisted_459, [
                      _createTextVNode("利用者は、本ビューアの利用に際し、次の各号に該当する行為を行ってはなりません。"),
                      _createElementVNode("span", _hoisted_460, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_461, [
                    _hoisted_462,
                    _createElementVNode("span", _hoisted_463, [
                      _createTextVNode("（１）"),
                      _hoisted_464,
                      _createTextVNode("本規約に違反する行為"),
                      _createElementVNode("span", _hoisted_465, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_466, [
                    _hoisted_467,
                    _createElementVNode("span", _hoisted_468, [
                      _createTextVNode("（２）"),
                      _hoisted_469,
                      _createTextVNode("法令に違反する行為"),
                      _createElementVNode("span", _hoisted_470, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_471, [
                    _hoisted_472,
                    _createElementVNode("span", _hoisted_473, [
                      _createTextVNode("（３）"),
                      _hoisted_474,
                      _createTextVNode("公序良俗に反する行為"),
                      _createElementVNode("span", _hoisted_475, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_476, [
                    _hoisted_477,
                    _createElementVNode("span", _hoisted_478, [
                      _createTextVNode("（４）"),
                      _hoisted_479,
                      _createTextVNode("管理者、提供者、他の利用者またはその他の第三者の権利を侵害する行為、不利益や損害を与える行為"),
                      _createElementVNode("span", _hoisted_480, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_481, [
                    _hoisted_482,
                    _hoisted_483,
                    _hoisted_484,
                    _createElementVNode("span", _hoisted_485, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_486, [
                    _hoisted_487,
                    _hoisted_488,
                    _hoisted_489,
                    _createElementVNode("span", _hoisted_490, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_491, [
                    _hoisted_492,
                    _hoisted_493,
                    _hoisted_494,
                    _hoisted_495,
                    _createElementVNode("span", _hoisted_496, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_497, [
                    _hoisted_498,
                    _createElementVNode("span", _hoisted_499, [
                      _createTextVNode("解析、リバースエンジニアリングその他ソースコードを取得する行為"),
                      _hoisted_500,
                      _createTextVNode("、またその全部または一部を他のソフトウェアに組み込む行為"),
                      _createElementVNode("span", _hoisted_501, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_502, [
                    _hoisted_503,
                    _createElementVNode("span", _hoisted_504, [
                      _createTextVNode("不正なデータまたは命令を入力する行為"),
                      _createElementVNode("span", _hoisted_505, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_506, [
                    _createElementVNode("span", _hoisted_507, [
                      _createTextVNode("（"),
                      _hoisted_508,
                      _createTextVNode("）"),
                      _hoisted_509,
                      _createTextVNode("その他本ビューアの管理及び運用、サービスの提供に支障を及ぼし、または支障を及ぼすおそれがある行為"),
                      _createElementVNode("span", _hoisted_510, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_511, [
                    _createElementVNode("span", _hoisted_512, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("h2", _hoisted_513, [
                    _hoisted_514,
                    _hoisted_515,
                    _hoisted_516,
                    _hoisted_517,
                    _createElementVNode("span", _hoisted_518, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_519, [
                    _hoisted_520,
                    _hoisted_521,
                    _createElementVNode("span", _hoisted_522, [
                      _createTextVNode("利用者は、本ビューアのサービスの全部または一部を、管理者及び提供者双方の許諾を得ずに、有償、無償を問わず、自己以外の者に利用させる（本ビューアを組み込んだサービスを利用させることを含みます）ことはできません。"),
                      _createElementVNode("span", _hoisted_523, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_524, [
                    _createElementVNode("span", _hoisted_525, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("h2", _hoisted_526, [
                    _hoisted_527,
                    _hoisted_528,
                    _hoisted_529,
                    _hoisted_530,
                    _createElementVNode("span", _hoisted_531, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_532, [
                    _hoisted_533,
                    _hoisted_534,
                    _createElementVNode("span", _hoisted_535, [
                      _createTextVNode("利用者は、本ビューアを利用するために利用者において必要とするすべての機器、ソフトウェア、通信手段等について、自己の責任において適切に管理するものとします。"),
                      _hoisted_536,
                      _createElementVNode("span", _hoisted_537, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_538, [
                    _hoisted_539,
                    _createElementVNode("span", _hoisted_540, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("h2", _hoisted_541, [
                    _hoisted_542,
                    _hoisted_543,
                    _hoisted_544,
                    _hoisted_545,
                    _hoisted_546,
                    _createElementVNode("span", _hoisted_547, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_548, [
                    _hoisted_549,
                    _hoisted_550,
                    _hoisted_551,
                    _createElementVNode("span", _hoisted_552, [
                      _createElementVNode("span", _hoisted_553, [
                        _createTextVNode("本ビューアを構成する、または、これに付属するデータ（有形か無形かを問いません）の知的財産権は、すべて、管理者、提供者、またはこれらに利用を許諾している管理者、提供者以外の第三者（以下、本条において「許諾者」といいます）に帰属します。"),
                        _createElementVNode("span", _hoisted_554, [
                          _createVNode(_component_o58p)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_555, [
                    _createElementVNode("span", _hoisted_556, [
                      _hoisted_557,
                      _hoisted_558,
                      _createElementVNode("span", _hoisted_559, [
                        _createTextVNode("本規約に基づく本ビューアの利用に係る許諾は、その利用に必要な範囲を超えて、管理者、提供者または許諾者の有する本ビューアに関する知的財産権の利用を許諾するものではありません。"),
                        _createElementVNode("span", _hoisted_560, [
                          _createVNode(_component_o58p)
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_561,
                  _createElementVNode("p", _hoisted_562, [
                    _createElementVNode("a", _hoisted_563, [
                      _hoisted_564,
                      _createElementVNode("span", _hoisted_565, [
                        _createTextVNode("利用者が本ビューアで提供されるコンテンツを利用する際の出典の記載に関するルールは以下のとおりです。"),
                        _createElementVNode("span", _hoisted_566, [
                          _createVNode(_component_o58p)
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_567,
                  _createElementVNode("p", _hoisted_568, [
                    _hoisted_569,
                    _hoisted_570,
                    _createElementVNode("span", _hoisted_571, [
                      _createTextVNode("を記載してください。出典の記載方法は以下のとおりです。各コンテンツの出典の記載方法については、"),
                      _hoisted_572,
                      _createTextVNode("をご確認ください。"),
                      _createElementVNode("span", _hoisted_573, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_574, [
                    _createElementVNode("span", _hoisted_575, [
                      _createTextVNode("（特定のコンテンツに関する出典記載例）"),
                      _createElementVNode("span", _hoisted_576, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_577, [
                    _createElementVNode("span", _hoisted_578, [
                      _createTextVNode("出典：「○○調査」（国土交通省）"),
                      _hoisted_579,
                      _createTextVNode("など"),
                      _createElementVNode("span", _hoisted_580, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_581, [
                    _createElementVNode("span", _hoisted_582, [
                      _createTextVNode("（本ビューアからの出典であることを明示する際の出典記載例）"),
                      _createElementVNode("span", _hoisted_583, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_584, [
                    _hoisted_585,
                    _hoisted_586,
                    _hoisted_587,
                    _hoisted_588,
                    _hoisted_589,
                    _hoisted_590,
                    _createElementVNode("span", _hoisted_591, [
                      _createTextVNode("より）"),
                      _hoisted_592,
                      _createTextVNode("など"),
                      _createElementVNode("span", _hoisted_593, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_594, [
                    _hoisted_595,
                    _createElementVNode("span", _hoisted_596, [
                      _createTextVNode("コンテンツを編集・加工等して利用する場合は、上記出典とは別に、編集・加工等を行ったこと及びその主体を記載してください。なお、編集・加工した情報を、あたかも国または府省等が作成した未加工のものと誤認されるおそれのある態様で公表・利用してはいけません。"),
                      _createElementVNode("span", _hoisted_597, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_598, [
                    _createElementVNode("span", _hoisted_599, [
                      _createTextVNode("（コンテンツを編集・加工等して利用する場合の記載例）"),
                      _createElementVNode("span", _hoisted_600, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_601, [
                    _createElementVNode("span", _hoisted_602, [
                      _createTextVNode("「○○調査」（国土交通省）（当該ページの"),
                      _hoisted_603,
                      _createTextVNode("）を加工して作成"),
                      _createElementVNode("span", _hoisted_604, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_605, [
                    _createElementVNode("span", _hoisted_606, [
                      _createTextVNode("「○○統計」（国土交通省）（当該ページの"),
                      _hoisted_607,
                      _createTextVNode("）をもとに"),
                      _hoisted_608,
                      _createTextVNode("株式会社作成"),
                      _createElementVNode("span", _hoisted_609, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_610, [
                    _createElementVNode("span", _hoisted_611, [
                      _createTextVNode("など"),
                      _createElementVNode("span", _hoisted_612, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_613, [
                    _hoisted_614,
                    _createElementVNode("span", _hoisted_615, [
                      _createTextVNode("コンテンツの中には、"),
                      _hoisted_616,
                      _hoisted_617,
                      _hoisted_618,
                      _createElementVNode("span", _hoisted_619, [
                        _createElementVNode("span", _hoisted_620, [
                          _createVNode(_component_o58p)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_621, [
                    _createElementVNode("span", _hoisted_622, [
                      _hoisted_623,
                      _createElementVNode("span", _hoisted_624, [
                        _createTextVNode("コンテンツのうち第三者が権利を有しているものについては、出典の表記等によって第三者が権利を有していることを直接的または間接的に表示・示唆しているものもありますが、明確に第三者が権利を有している部分の特定・明示等を行っていないものもあります。利用する場合は利用者の責任において確認してください。"),
                        _hoisted_625,
                        _createElementVNode("span", _hoisted_626, [
                          _createVNode(_component_o58p)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_627, [
                    _createElementVNode("span", _hoisted_628, [
                      _hoisted_629,
                      _createElementVNode("span", _hoisted_630, [
                        _createTextVNode("外部データベース等との"),
                        _hoisted_631,
                        _createTextVNode("（"),
                        _hoisted_632,
                        _createTextVNode("）連携等により取得しているコンテンツについては、その提供者が定める利用条件に従ってください。当該コンテンツの一覧は別表"),
                        _hoisted_633,
                        _createTextVNode("に列挙しています。"),
                        _createElementVNode("span", _hoisted_634, [
                          _createVNode(_component_o58p)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_635, [
                    _createElementVNode("span", _hoisted_636, [
                      _hoisted_637,
                      _createElementVNode("span", _hoisted_638, [
                        _createTextVNode("第三者が著作権等を有しているコンテンツであっても、著作権法上認められている引用など、著作権者等の許諾なしに利用できる場合があります。"),
                        _createElementVNode("span", _hoisted_639, [
                          _createVNode(_component_o58p)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_640, [
                    _createElementVNode("span", _hoisted_641, [
                      _hoisted_642,
                      _createElementVNode("span", _hoisted_643, [
                        _createTextVNode("以下のコンテンツについては、本条の適用外です。"),
                        _createElementVNode("span", _hoisted_644, [
                          _createVNode(_component_o58p)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_645, [
                    _createElementVNode("span", _hoisted_646, [
                      _createElementVNode("span", _hoisted_647, [
                        _createTextVNode("ア"),
                        _hoisted_648,
                        _createTextVNode("組織や特定の事業を表すシンボルマーク、ロゴ、キャラクターデザイン"),
                        _createElementVNode("span", _hoisted_649, [
                          _createVNode(_component_o58p)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_650, [
                    _createElementVNode("span", _hoisted_651, [
                      _createElementVNode("span", _hoisted_652, [
                        _createTextVNode("イ "),
                        _hoisted_653,
                        _createTextVNode("具体的かつ合理的な根拠の説明とともに、別の利用ルールが適用されることが明示されているコンテンツ（別の利用ルールの適用を明示しているコンテンツは、本規約の別表"),
                        _hoisted_654,
                        _createTextVNode("に列挙しています）"),
                        _createElementVNode("span", _hoisted_655, [
                          _createVNode(_component_o58p)
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_656,
                  _createElementVNode("p", _hoisted_657, [
                    _hoisted_658,
                    _createElementVNode("span", _hoisted_659, [
                      _createTextVNode("利用者は、本条に定める利用者に認められた利用条件を遵守しないことにより管理者に損害を与えた場合、これを賠償する責任を負うものとします。"),
                      _createElementVNode("span", _hoisted_660, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_661, [
                    _hoisted_662,
                    _createElementVNode("span", _hoisted_663, [
                      _createTextVNode("管理者は、"),
                      _hoisted_664,
                      _hoisted_665,
                      _hoisted_666,
                      _createTextVNode("一切の紛争に関して責任を負いません。"),
                      _createElementVNode("span", _hoisted_667, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_668, [
                    _createElementVNode("span", _hoisted_669, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("h2", _hoisted_670, [
                    _hoisted_671,
                    _hoisted_672,
                    _hoisted_673,
                    _hoisted_674,
                    _createElementVNode("span", _hoisted_675, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_676, [
                    _hoisted_677,
                    _createElementVNode("span", _hoisted_678, [
                      _createTextVNode("提供者によるデータの提供にあたっては、管理者が別に定める規約にて提供者に求める条件等を定めます。"),
                      _createElementVNode("span", _hoisted_679, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_680, [
                    _hoisted_681,
                    _createElementVNode("span", _hoisted_682, [
                      _createTextVNode("前項で定める規約によりがたい場合は、提供者と管理者の間で個別に協議の上で特別の条件を定めることができます。本規約及び提供者が従来定めている"),
                      _hoisted_683,
                      _createTextVNode("のほかに当該条件により利用者に対して新たに生じる制約等がある場合、管理者の責において本規約の別表"),
                      _hoisted_684,
                      _createTextVNode("にコンテンツの対象を明示するとともに、提供者の責において利用者に周知するものとします。"),
                      _createElementVNode("span", _hoisted_685, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_686, [
                    _createElementVNode("span", _hoisted_687, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("h2", _hoisted_688, [
                    _hoisted_689,
                    _createElementVNode("span", _hoisted_690, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_691, [
                    _hoisted_692,
                    _hoisted_693,
                    _hoisted_694,
                    _hoisted_695,
                    _hoisted_696,
                    _hoisted_697,
                    _hoisted_698,
                    _createElementVNode("span", _hoisted_699, [
                      _createTextVNode("管理者は、本ビューアに掲載するデータの一部または全部を限定公開とすることがあります。"),
                      _createElementVNode("span", _hoisted_700, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_701, [
                    _hoisted_702,
                    _createElementVNode("span", _hoisted_703, [
                      _createTextVNode("管理者は、本ビューアの一部または全部の機能を限定公開とすることがあります。"),
                      _createElementVNode("span", _hoisted_704, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_705, [
                    _hoisted_706,
                    _createElementVNode("span", _hoisted_707, [
                      _createTextVNode("限定公開するデータ、機能及び限定公開の対象者"),
                      _hoisted_708,
                      _hoisted_709,
                      _hoisted_710,
                      _createTextVNode("。"),
                      _hoisted_711,
                      _createElementVNode("span", _hoisted_712, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_713, [
                    _hoisted_714,
                    _createElementVNode("span", _hoisted_715, [
                      _createTextVNode("管理者は、限定公開の対象者に対し、別に定める条件に同意することを要件として、限定公開データ及び機能を利用するための認証情報を配布することがあります。この認証情報の配布を受けた者は、これを他者に提供することはできません。"),
                      _createElementVNode("span", _hoisted_716, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_717, [
                    _hoisted_718,
                    _createElementVNode("span", _hoisted_719, [
                      _createTextVNode("限定公開の対象者は、管理者及び提供者双方の許可を得ずに、当該限定公開データ"),
                      _hoisted_720,
                      _createTextVNode("を他者に提供、開示することはできません。"),
                      _createElementVNode("span", _hoisted_721, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_722, [
                    _createElementVNode("a", _hoisted_723, [
                      _hoisted_724,
                      _createElementVNode("span", _hoisted_725, [
                        _createTextVNode("限定公開対象のデータ及び機能の取り扱いの詳細については、別に定める規定に準拠することとします。"),
                        _createElementVNode("span", _hoisted_726, [
                          _createVNode(_component_o58p)
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_727,
                  _createElementVNode("p", _hoisted_728, [
                    _createElementVNode("span", _hoisted_729, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("h2", _hoisted_730, [
                    _hoisted_731,
                    _hoisted_732,
                    _hoisted_733,
                    _hoisted_734,
                    _createElementVNode("span", _hoisted_735, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_736, [
                    _hoisted_737,
                    _hoisted_738,
                    _createElementVNode("span", _hoisted_739, [
                      _createTextVNode("「秘密情報」とは、"),
                      _hoisted_740,
                      _createTextVNode("本ビューアの利用に際して、または、関連して、利用者が知り得た管理者及び提供者に関する情報であって、管理者が秘密であることを示したものをいいます。"),
                      _createElementVNode("span", _hoisted_741, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_742, [
                    _hoisted_743,
                    _hoisted_744,
                    _hoisted_745,
                    _hoisted_746,
                    _hoisted_747,
                    _createElementVNode("span", _hoisted_748, [
                      _createElementVNode("span", _hoisted_749, [
                        _createTextVNode("前項の規定にかかわらず、次の各号のいずれかに該当する情報は、秘密情報にあたりません。"),
                        _createElementVNode("span", _hoisted_750, [
                          _createVNode(_component_o58p)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_751, [
                    _createElementVNode("span", _hoisted_752, [
                      _hoisted_753,
                      _hoisted_754,
                      _createElementVNode("span", _hoisted_755, [
                        _createElementVNode("span", _hoisted_756, [
                          _createTextVNode("（１）"),
                          _hoisted_757,
                          _createTextVNode("当該データを取得した時点ですでに利用者が保持していた情報"),
                          _createElementVNode("span", _hoisted_758, [
                            _createVNode(_component_o58p)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_759, [
                    _createElementVNode("span", _hoisted_760, [
                      _createElementVNode("span", _hoisted_761, [
                        _hoisted_762,
                        _createElementVNode("span", _hoisted_763, [
                          _createTextVNode("（２）"),
                          _hoisted_764,
                          _createTextVNode("秘密情報によらず利用者が独自に生成した情報"),
                          _createElementVNode("span", _hoisted_765, [
                            _createVNode(_component_o58p)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_766, [
                    _createElementVNode("span", _hoisted_767, [
                      _createElementVNode("span", _hoisted_768, [
                        _hoisted_769,
                        _createElementVNode("span", _hoisted_770, [
                          _createTextVNode("（３）"),
                          _hoisted_771,
                          _createTextVNode("当該データを取得した時点で公知の情報"),
                          _createElementVNode("span", _hoisted_772, [
                            _createVNode(_component_o58p)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_773, [
                    _createElementVNode("span", _hoisted_774, [
                      _createElementVNode("span", _hoisted_775, [
                        _hoisted_776,
                        _createElementVNode("span", _hoisted_777, [
                          _createTextVNode("（４）"),
                          _hoisted_778,
                          _createTextVNode("当該データを取得した後に利用者の責めに帰すべき事由によらずに公知となった情報"),
                          _createElementVNode("span", _hoisted_779, [
                            _createVNode(_component_o58p)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_780, [
                    _createElementVNode("span", _hoisted_781, [
                      _createElementVNode("span", _hoisted_782, [
                        _hoisted_783,
                        _createElementVNode("span", _hoisted_784, [
                          _createTextVNode("（５）"),
                          _hoisted_785,
                          _createTextVNode("正当な権限を有する第三者から秘密保持義務を負うことなく開示された情報 "),
                          _hoisted_786,
                          _createElementVNode("span", _hoisted_787, [
                            _createVNode(_component_o58p)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_788,
                  _hoisted_789,
                  _createElementVNode("p", _hoisted_790, [
                    _hoisted_791,
                    _createElementVNode("span", _hoisted_792, [
                      _createTextVNode("利用者"),
                      _hoisted_793,
                      _createTextVNode("は、秘密情報を秘密として管理し、管理者の承諾がある場合を除いて次の各号の義務を負います。"),
                      _createElementVNode("span", _hoisted_794, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_795, [
                    _hoisted_796,
                    _createElementVNode("span", _hoisted_797, [
                      _createTextVNode("（１）"),
                      _hoisted_798,
                      _createTextVNode("第三者に開示または漏洩しない"),
                      _createElementVNode("span", _hoisted_799, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_800, [
                    _hoisted_801,
                    _createElementVNode("span", _hoisted_802, [
                      _createTextVNode("（２）"),
                      _hoisted_803,
                      _createTextVNode("本規約上の権利の行使または義務の履行以外の目的に利用しな"),
                      _hoisted_804,
                      _createTextVNode("い"),
                      _createElementVNode("span", _hoisted_805, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_806, [
                    _createElementVNode("a", _hoisted_807, [
                      _hoisted_808,
                      _createElementVNode("span", _hoisted_809, [
                        _createTextVNode("本条の義務は、管理者が特に定めた場合を除き、本ビューアの利用終了後も有効に存続します。"),
                        _createElementVNode("span", _hoisted_810, [
                          _createVNode(_component_o58p)
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_811,
                  _createElementVNode("p", _hoisted_812, [
                    _createElementVNode("span", _hoisted_813, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_814, [
                    _createElementVNode("span", _hoisted_815, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_816, [
                    _createElementVNode("span", _hoisted_817, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("h1", _hoisted_818, [
                    _hoisted_819,
                    _hoisted_820,
                    _hoisted_821,
                    _hoisted_822,
                    _createElementVNode("span", _hoisted_823, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_824, [
                    _createElementVNode("span", _hoisted_825, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("h2", _hoisted_826, [
                    _hoisted_827,
                    _hoisted_828,
                    _hoisted_829,
                    _hoisted_830,
                    _createElementVNode("span", _hoisted_831, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_832, [
                    _hoisted_833,
                    _hoisted_834,
                    _createElementVNode("span", _hoisted_835, [
                      _createTextVNode("管理者は、次に掲げる事由がある場合は、本サービスの一部または全部の提供を一時停止、または制限することがあります。"),
                      _createElementVNode("span", _hoisted_836, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_837, [
                    _hoisted_838,
                    _hoisted_839,
                    _hoisted_840,
                    _createElementVNode("span", _hoisted_841, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_842, [
                    _hoisted_843,
                    _hoisted_844,
                    _hoisted_845,
                    _createElementVNode("span", _hoisted_846, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_847, [
                    _hoisted_848,
                    _hoisted_849,
                    _hoisted_850,
                    _hoisted_851,
                    _hoisted_852,
                    _createElementVNode("span", _hoisted_853, [
                      _createTextVNode("。以下、「公的機関等」といいます）による命令、処分、要請等があった場合"),
                      _createElementVNode("span", _hoisted_854, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_855, [
                    _hoisted_856,
                    _createElementVNode("span", _hoisted_857, [
                      _createTextVNode("（４）"),
                      _hoisted_858,
                      _createTextVNode("第三者の行為（不作為を含みます）により本ビューアのサーバ設備または電気通信設備等に支障が生じ、またはそのおそれがある等、管理者の業務の遂行に支障が生じると管理者が合理的に認めた場合"),
                      _createElementVNode("span", _hoisted_859, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_860, [
                    _createElementVNode("span", _hoisted_861, [
                      _createTextVNode("（５）"),
                      _hoisted_862,
                      _createTextVNode("その他、サービスの提供に支障をきたす事象が生じた場合"),
                      _createElementVNode("span", _hoisted_863, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_864, [
                    _hoisted_865,
                    _hoisted_866,
                    _hoisted_867,
                    _hoisted_868,
                    _createElementVNode("span", _hoisted_869, [
                      _createTextVNode("への掲載、またはその他の方法により通知します。"),
                      _createElementVNode("span", _hoisted_870, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_871, [
                    _hoisted_872,
                    _hoisted_873,
                    _createElementVNode("span", _hoisted_874, [
                      _createTextVNode("管理者は、第１項に基づき本サービスの提供を一時停止する場合に、当該一時停止により利用者及び提供者が被った損害について、賠償する責任を負いません。"),
                      _createElementVNode("span", _hoisted_875, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_876, [
                    _createElementVNode("span", _hoisted_877, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("h2", _hoisted_878, [
                    _hoisted_879,
                    _hoisted_880,
                    _hoisted_881,
                    _hoisted_882,
                    _createElementVNode("span", _hoisted_883, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_884, [
                    _hoisted_885,
                    _hoisted_886,
                    _createElementVNode("span", _hoisted_887, [
                      _createTextVNode("管理者は、予告なく本ビューアの一部または全部のサービスの提供を中止することがあります。"),
                      _createElementVNode("span", _hoisted_888, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_889, [
                    _hoisted_890,
                    _hoisted_891,
                    _createElementVNode("span", _hoisted_892, [
                      _createTextVNode("管理者は、前項に基づきサービスの提供を中止する場合に、当該中止により利用者が被った損害について、賠償する責任を負いません。"),
                      _createElementVNode("span", _hoisted_893, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_894, [
                    _hoisted_895,
                    _createElementVNode("span", _hoisted_896, [
                      _createTextVNode("前項の規定は、提供していたデータまたは機能を第９条の規定により限定公開とした場合、またはその対象者を変更した場合において、当該限定公開の開始または変更により損害を被った者について準用します。"),
                      _createElementVNode("span", _hoisted_897, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_898, [
                    _createElementVNode("span", _hoisted_899, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("h1", _hoisted_900, [
                    _hoisted_901,
                    _hoisted_902,
                    _hoisted_903,
                    _hoisted_904,
                    _createElementVNode("span", _hoisted_905, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_906, [
                    _createElementVNode("span", _hoisted_907, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("h2", _hoisted_908, [
                    _hoisted_909,
                    _hoisted_910,
                    _hoisted_911,
                    _hoisted_912,
                    _createElementVNode("span", _hoisted_913, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_914, [
                    _hoisted_915,
                    _hoisted_916,
                    _createElementVNode("span", _hoisted_917, [
                      _createTextVNode("管理者は、利用者がコンテンツを用いて行う一切の行為"),
                      _hoisted_918,
                      _createTextVNode("について何ら責任を負うものではありません。"),
                      _createElementVNode("span", _hoisted_919, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_920, [
                    _hoisted_921,
                    _createElementVNode("span", _hoisted_922, [
                      _createTextVNode("コンテンツは、予告なく変更、移転、削除等が行われることがあります。"),
                      _createElementVNode("span", _hoisted_923, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_924, [
                    _hoisted_925,
                    _createElementVNode("span", _hoisted_926, [
                      _createTextVNode("管理者は、特別に定める場合を除き、本サービスの利用及び利用できないことにより利用者、提供者またはその他の第三者が被った損害について、一切の責任を負いません。"),
                      _createElementVNode("span", _hoisted_927, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_928, [
                    _hoisted_929,
                    _createElementVNode("span", _hoisted_930, [
                      _createTextVNode("管理者は、特別に定める場合を除き、本サービスの提供の停止、休止、中止もしくは制限または通信回線の障害等により発生した利用者、提供者またはその他の第三者が被った損害について、一切の責任を負いません。"),
                      _createElementVNode("span", _hoisted_931, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_932, [
                    _hoisted_933,
                    _createElementVNode("span", _hoisted_934, [
                      _createTextVNode("管理者は、本サービスの利用に際しマルウェア感染等で生じた被害について、一切の責任を負いません。"),
                      _createElementVNode("span", _hoisted_935, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_936, [
                    _hoisted_937,
                    _hoisted_938,
                    _hoisted_939,
                    _createElementVNode("span", _hoisted_940, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_941, [
                    _createElementVNode("span", _hoisted_942, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("h1", _hoisted_943, [
                    _hoisted_944,
                    _hoisted_945,
                    _hoisted_946,
                    _hoisted_947,
                    _createElementVNode("span", _hoisted_948, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_949, [
                    _createElementVNode("span", _hoisted_950, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("h2", null, [
                    _hoisted_951,
                    _hoisted_952,
                    _hoisted_953,
                    _createElementVNode("span", _hoisted_954, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_955, [
                    _hoisted_956,
                    _createElementVNode("span", _hoisted_957, [
                      _createTextVNode("本ビューアは、原則リンクフリーとします。ただし、管理者の許可を得ずに、限定公開の対象となるデータ及び機能にアクセスさせるリンクを設定することはできません。"),
                      _createElementVNode("span", _hoisted_958, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_959, [
                    _hoisted_960,
                    _createElementVNode("span", _hoisted_961, [
                      _createTextVNode("リンクの設定をされる際は、「道路データプラットフォームデータビューア」へのリンクである旨の明示をするものとします。"),
                      _createElementVNode("span", _hoisted_962, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_963, [
                    _hoisted_964,
                    _createElementVNode("span", _hoisted_965, [
                      _createTextVNode("本ビューアが他のウェブページ中に組み込まれるようなリンクの設定はせず、必ず新しいウインドウで表示されるように設定するものとします。"),
                      _createElementVNode("span", _hoisted_966, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_967, [
                    _createElementVNode("a", _hoisted_968, [
                      _hoisted_969,
                      _createElementVNode("span", _hoisted_970, [
                        _createTextVNode("リンクの設定にあたっては、管理者及び提供者が共催、参加、後援、協賛または監修等を行っているとの誤解を与えることのないよう、配置、表現等にご配慮ください。"),
                        _createElementVNode("span", _hoisted_971, [
                          _createVNode(_component_o58p)
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_972,
                  _createElementVNode("p", _hoisted_973, [
                    _createElementVNode("span", _hoisted_974, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("h2", _hoisted_975, [
                    _hoisted_976,
                    _hoisted_977,
                    _createElementVNode("span", _hoisted_978, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_979, [
                    _hoisted_980,
                    _hoisted_981,
                    _hoisted_982,
                    _hoisted_983,
                    _createElementVNode("span", _hoisted_984, [
                      _createTextVNode("の義務と同等の義務を受託者に負わせるものとします。"),
                      _createElementVNode("span", _hoisted_985, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_986, [
                    _createElementVNode("span", _hoisted_987, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("h2", _hoisted_988, [
                    _hoisted_989,
                    _hoisted_990,
                    _hoisted_991,
                    _createElementVNode("span", _hoisted_992, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_993, [
                    _hoisted_994,
                    _hoisted_995,
                    _createElementVNode("span", _hoisted_996, [
                      _createTextVNode("管理者は、利用者または提供者の個人情報を、管理者のウェブサイトにおいて定める「プライバシーポリシー」に基づき、適切に取り扱うものとします。"),
                      _createElementVNode("span", _hoisted_997, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_998, [
                    _createElementVNode("span", _hoisted_999, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("h2", _hoisted_1000, [
                    _hoisted_1001,
                    _hoisted_1002,
                    _hoisted_1003,
                    _hoisted_1004,
                    _createElementVNode("span", _hoisted_1005, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1006, [
                    _hoisted_1007,
                    _hoisted_1008,
                    _createElementVNode("span", _hoisted_1009, [
                      _createTextVNode("利用者は、管理者に対し、次の各号の事項を確約するものとします。"),
                      _createElementVNode("span", _hoisted_1010, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1011, [
                    _hoisted_1012,
                    _createElementVNode("span", _hoisted_1013, [
                      _createTextVNode("（１）"),
                      _hoisted_1014,
                      _createTextVNode("自らが、暴力団、暴力団関係企業、総会屋もしくはこれらに準ずる者またはその構成員（以下、総称して「反社会的勢力」といいます）ではないこと。"),
                      _createElementVNode("span", _hoisted_1015, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1016, [
                    _hoisted_1017,
                    _createElementVNode("span", _hoisted_1018, [
                      _createTextVNode("（２）"),
                      _hoisted_1019,
                      _createTextVNode("自らの役員（業務を執行する社員、取締役、執行役またはこれらに準ずる者をいいます）が反社会的勢力ではないこと。"),
                      _createElementVNode("span", _hoisted_1020, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1021, [
                    _hoisted_1022,
                    _createElementVNode("span", _hoisted_1023, [
                      _createTextVNode("（３）"),
                      _hoisted_1024,
                      _createTextVNode("本ビューアまたはデータを反社会的勢力に利用させるものではないこと。"),
                      _createElementVNode("span", _hoisted_1025, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1026, [
                    _hoisted_1027,
                    _createElementVNode("span", _hoisted_1028, [
                      _createTextVNode("（４）"),
                      _hoisted_1029,
                      _createTextVNode("自らまたは第三者を利用して、次の行為をしないこと。"),
                      _createElementVNode("span", _hoisted_1030, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1031, [
                    _hoisted_1032,
                    _hoisted_1033,
                    _hoisted_1034,
                    _createElementVNode("span", _hoisted_1035, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1036, [
                    _hoisted_1037,
                    _hoisted_1038,
                    _hoisted_1039,
                    _hoisted_1040,
                    _createElementVNode("span", _hoisted_1041, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1042, [
                    _hoisted_1043,
                    _hoisted_1044,
                    _createElementVNode("span", _hoisted_1045, [
                      _createTextVNode("管理者は、利用者が次のいずれかに該当した場合には、何らの催告を要せずして、本ビューアの利用の全部または一部を停止することができます。"),
                      _createElementVNode("span", _hoisted_1046, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1047, [
                    _hoisted_1048,
                    _hoisted_1049,
                    _createElementVNode("span", _hoisted_1050, [
                      _createTextVNode("前項（１）または前項（２）の確約に反することが判明した場合"),
                      _hoisted_1051,
                      _createElementVNode("span", _hoisted_1052, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1053, [
                    _hoisted_1054,
                    _createElementVNode("span", _hoisted_1055, [
                      _createTextVNode("前項（３）の確約に反し契約をしたことが判明した場合"),
                      _createElementVNode("span", _hoisted_1056, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1057, [
                    _hoisted_1058,
                    _hoisted_1059,
                    _createElementVNode("span", _hoisted_1060, [
                      _createTextVNode("前項（４）の確約に反した行為をした場合"),
                      _createElementVNode("span", _hoisted_1061, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1062, [
                    _hoisted_1063,
                    _hoisted_1064,
                    _createElementVNode("span", _hoisted_1065, [
                      _createTextVNode("前項の規定により利用が停止された場合には、利用者は、利用の停止により生じる損害について、管理者に対し、何ら請求を行うことができないものとします。"),
                      _createElementVNode("span", _hoisted_1066, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1067, [
                    _createElementVNode("span", _hoisted_1068, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("h2", _hoisted_1069, [
                    _hoisted_1070,
                    _hoisted_1071,
                    _hoisted_1072,
                    _hoisted_1073,
                    _hoisted_1074,
                    _hoisted_1075,
                    _hoisted_1076,
                    _createElementVNode("span", _hoisted_1077, [
                      _createElementVNode("span", _hoisted_1078, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1079, [
                    _createElementVNode("span", _hoisted_1080, [
                      _hoisted_1081,
                      _hoisted_1082,
                      _hoisted_1083,
                      _createElementVNode("span", _hoisted_1084, [
                        _createTextVNode("本規約は、日本法に基づいて解釈されます。"),
                        _createElementVNode("span", _hoisted_1085, [
                          _createVNode(_component_o58p)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1086, [
                    _hoisted_1087,
                    _createElementVNode("span", _hoisted_1088, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1089, [
                    _createElementVNode("span", _hoisted_1090, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("h2", _hoisted_1091, [
                    _hoisted_1092,
                    _hoisted_1093,
                    _createElementVNode("span", _hoisted_1094, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1095, [
                    _hoisted_1096,
                    _createElementVNode("span", _hoisted_1097, [
                      _createTextVNode("管理者は、本規約を予告なく変更することがあります。"),
                      _createElementVNode("span", _hoisted_1098, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1099, [
                    _hoisted_1100,
                    _hoisted_1101,
                    _hoisted_1102,
                    _createElementVNode("span", _hoisted_1103, [
                      _createTextVNode("へのお知らせの掲載その他の方法により、利用者に通知するものとします。"),
                      _createElementVNode("span", _hoisted_1104, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1105, [
                    _hoisted_1106,
                    _createElementVNode("span", _hoisted_1107, [
                      _createTextVNode("利用者は、第２項の通知後に本ビューアを利用した場合、変更後の本規約の適用に同意したものとみなします。"),
                      _createElementVNode("span", _hoisted_1108, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1109, [
                    _createElementVNode("span", _hoisted_1110, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("h2", _hoisted_1111, [
                    _hoisted_1112,
                    _hoisted_1113,
                    _createElementVNode("span", _hoisted_1114, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1115, [
                    _hoisted_1116,
                    _createElementVNode("span", _hoisted_1117, [
                      _createTextVNode("本規約は、著作権法上認められている引用などの利用について、制限するものではありません。 "),
                      _createElementVNode("span", _hoisted_1118, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1119, [
                    _hoisted_1120,
                    _hoisted_1121,
                    _createElementVNode("span", _hoisted_1122, [
                      _createTextVNode("５月"),
                      _hoisted_1123,
                      _createTextVNode("日"),
                      _createElementVNode("span", _hoisted_1124, [
                        _createTextVNode("に定めたものです。本規約は、今後変更される可能性があります。なお、既に以前の政府標準利用規約にしたがってコンテンツを利用している場合は、引き続きその条件が適用されます。"),
                        _createElementVNode("span", _hoisted_1125, [
                          _createVNode(_component_o58p)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1126, [
                    _hoisted_1127,
                    _createElementVNode("span", _hoisted_1128, [
                      _createTextVNode("本"),
                      _hoisted_1129,
                      _createElementVNode("span", _hoisted_1130, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1131, [
                    _hoisted_1132,
                    _createElementVNode("span", _hoisted_1133, [
                      _createTextVNode("ウェブサイト全体についての"),
                      _createElementVNode("a", _hoisted_1134, [
                        _createTextVNode("リンクポリシー、プライバシーポリシー、アクセシビリティや免責事項については、本規約に基づく本コンテンツ利用に係る内容と矛盾しない限り、本規約を採用する管理者の側で自由に定められます。"),
                        _createElementVNode("span", _hoisted_1135, [
                          _createVNode(_component_o58p)
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_1136,
                  _createElementVNode("p", _hoisted_1137, [
                    _hoisted_1138,
                    _createElementVNode("span", _hoisted_1139, [
                      _createTextVNode("本規約は、ウェブサイト全体だけでなく、個別のコンテンツに適用されることもあります。"),
                      _createElementVNode("span", _hoisted_1140, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1141, [
                    _createElementVNode("span", _hoisted_1142, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1143, [
                    _createElementVNode("span", _hoisted_1144, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("h1", _hoisted_1145, [
                    _hoisted_1146,
                    _hoisted_1147,
                    _hoisted_1148,
                    _hoisted_1149,
                    _createElementVNode("span", _hoisted_1150, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1151, [
                    _createElementVNode("span", _hoisted_1152, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("h2", _hoisted_1153, [
                    _hoisted_1154,
                    _hoisted_1155,
                    _hoisted_1156,
                    _hoisted_1157,
                    _createElementVNode("span", _hoisted_1158, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1159, [
                    _hoisted_1160,
                    _createElementVNode("span", _hoisted_1161, [
                      _createTextVNode("１．本規約は、"),
                      _hoisted_1162,
                      _createTextVNode("５月"),
                      _hoisted_1163,
                      _createTextVNode("日"),
                      _createElementVNode("span", _hoisted_1164, [
                        _createTextVNode("より適用されます。"),
                        _createElementVNode("span", _hoisted_1165, [
                          _createVNode(_component_o58p)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1166, [
                    _hoisted_1167,
                    _createElementVNode("span", _hoisted_1168, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _hoisted_1169,
                  _createElementVNode("p", _hoisted_1170, [
                    _createElementVNode("a", _hoisted_1171, [
                      _createElementVNode("span", _hoisted_1172, [
                        _createVNode(_component_o58p, null, {
                          default: _withCtx(() => [
                            _createTextVNode(" ")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _hoisted_1173,
                  _createElementVNode("h1", _hoisted_1174, [
                    _hoisted_1175,
                    _hoisted_1176,
                    _hoisted_1177,
                    _hoisted_1178,
                    _createElementVNode("span", _hoisted_1179, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1180, [
                    _createElementVNode("span", _hoisted_1181, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("h2", _hoisted_1182, [
                    _hoisted_1183,
                    _hoisted_1184,
                    _createElementVNode("span", _hoisted_1185, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1186, [
                    _createElementVNode("span", _hoisted_1187, [
                      _createTextVNode("本ビューアにおいて提供しているデータは以下のとおりです（限定公開のデータを除きます）。"),
                      _createElementVNode("span", _hoisted_1188, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1189, [
                    _createElementVNode("span", _hoisted_1190, [
                      _createTextVNode("また、本ビューアで扱っている下記のデータを引用する際には下記の例を参考に出典を記載してください。"),
                      _createElementVNode("span", _hoisted_1191, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1192, [
                    _createElementVNode("span", _hoisted_1193, [
                      _createTextVNode("（令和８年３月時点）"),
                      _createElementVNode("a", _hoisted_1194, [
                        _createElementVNode("span", _hoisted_1195, [
                          _createVNode(_component_o58p)
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_1196,
                  _hoisted_1197,
                  _hoisted_1198,
                  _hoisted_1199,
                  _hoisted_1200,
                  _hoisted_1201,
                  _hoisted_1202,
                  _hoisted_1203,
                  _hoisted_1204,
                  _hoisted_1205,
                  _hoisted_1206,
                  _hoisted_1207,
                  _hoisted_1208,
                  _hoisted_1209,
                  _hoisted_1210,
                  _hoisted_1211,
                  _hoisted_1212,
                  _hoisted_1213,
                  _hoisted_1214,
                  _hoisted_1215,
                  _hoisted_1216,
                  _hoisted_1217,
                  _hoisted_1218,
                  _hoisted_1219,
                  _hoisted_1220,
                  _hoisted_1221,
                  _hoisted_1222,
                  _hoisted_1223,
                  _createElementVNode("table", _hoisted_1224, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", _hoisted_1225, [
                        _createElementVNode("td", _hoisted_1226, [
                          _createElementVNode("p", _hoisted_1227, [
                            _createElementVNode("span", _hoisted_1228, [
                              _createElementVNode("span", _hoisted_1229, [
                                _createTextVNode("データ"),
                                _createElementVNode("span", _hoisted_1230, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_1231, [
                            _createElementVNode("span", _hoisted_1232, [
                              _createElementVNode("span", _hoisted_1233, [
                                _createTextVNode("（本ビューア内での名称）"),
                                _createElementVNode("span", _hoisted_1234, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_1235, [
                          _createElementVNode("p", _hoisted_1236, [
                            _createElementVNode("span", _hoisted_1237, [
                              _createElementVNode("span", _hoisted_1238, [
                                _createTextVNode("出典の記載例"),
                                _createElementVNode("span", _hoisted_1239, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_1240, [
                            _createElementVNode("span", _hoisted_1241, [
                              _createElementVNode("span", _hoisted_1242, [
                                _createTextVNode("（）内は提供者"),
                                _createElementVNode("span", _hoisted_1243, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_1244, [
                        _createElementVNode("td", _hoisted_1245, [
                          _createElementVNode("p", _hoisted_1246, [
                            _createElementVNode("span", _hoisted_1247, [
                              _createElementVNode("span", _hoisted_1248, [
                                _createTextVNode("交通量データ"),
                                _createElementVNode("span", _hoisted_1249, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_1250, [
                          _createElementVNode("p", _hoisted_1251, [
                            _createElementVNode("span", _hoisted_1252, [
                              _createElementVNode("span", _hoisted_1253, [
                                _createTextVNode("交通量データ"),
                                _hoisted_1254,
                                _createTextVNode("国土交通省"),
                                _createElementVNode("span", _hoisted_1255, [
                                  _createTextVNode(")"),
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_1256, [
                        _createElementVNode("td", _hoisted_1257, [
                          _createElementVNode("p", _hoisted_1258, [
                            _hoisted_1259,
                            _createElementVNode("span", _hoisted_1260, [
                              _createElementVNode("span", _hoisted_1261, [
                                _createTextVNode("プローブデータ"),
                                _createElementVNode("span", _hoisted_1262, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_1263, [
                          _createElementVNode("p", _hoisted_1264, [
                            _hoisted_1265,
                            _createElementVNode("span", _hoisted_1266, [
                              _createElementVNode("span", _hoisted_1267, [
                                _createTextVNode("プローブ情報"),
                                _hoisted_1268,
                                _createTextVNode("国土交通省"),
                                _createElementVNode("span", _hoisted_1269, [
                                  _createTextVNode(")"),
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_1270, [
                        _createElementVNode("td", _hoisted_1271, [
                          _createElementVNode("p", _hoisted_1272, [
                            _createElementVNode("span", _hoisted_1273, [
                              _createElementVNode("span", _hoisted_1274, [
                                _createTextVNode("OD"),
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_1275, [
                          _createElementVNode("p", _hoisted_1276, [
                            _createElementVNode("span", _hoisted_1277, [
                              _createElementVNode("span", _hoisted_1278, [
                                _createTextVNode("全国道路・街路交通情勢調査"),
                                _hoisted_1279,
                                _createTextVNode("国土交通省"),
                                _createElementVNode("span", _hoisted_1280, [
                                  _createTextVNode(")"),
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_1281, [
                        _createElementVNode("td", _hoisted_1282, [
                          _createElementVNode("p", _hoisted_1283, [
                            _createElementVNode("span", _hoisted_1284, [
                              _createElementVNode("span", _hoisted_1285, [
                                _createTextVNode("（都道府県タイル）"),
                                _createElementVNode("span", _hoisted_1286, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_1287, [
                          _createElementVNode("p", _hoisted_1288, [
                            _hoisted_1289,
                            _hoisted_1290,
                            _hoisted_1291,
                            _hoisted_1292,
                            _createElementVNode("span", _hoisted_1293, [
                              _createElementVNode("span", _hoisted_1294, [
                                _createTextVNode("を加工して作成"),
                                _createElementVNode("span", _hoisted_1295, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_1296, [
                        _createElementVNode("td", _hoisted_1297, [
                          _createElementVNode("p", _hoisted_1298, [
                            _hoisted_1299,
                            _createElementVNode("span", _hoisted_1300, [
                              _createElementVNode("span", _hoisted_1301, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_1302, [
                          _createElementVNode("p", _hoisted_1303, [
                            _hoisted_1304,
                            _hoisted_1305,
                            _hoisted_1306,
                            _createElementVNode("span", _hoisted_1307, [
                              _createElementVNode("span", _hoisted_1308, [
                                _createTextVNode(")"),
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_1309, [
                        _createElementVNode("td", _hoisted_1310, [
                          _createElementVNode("p", _hoisted_1311, [
                            _createElementVNode("span", _hoisted_1312, [
                              _createElementVNode("span", _hoisted_1313, [
                                _createTextVNode("道路施設点検データ"),
                                _createElementVNode("span", _hoisted_1314, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_1315, [
                          _createElementVNode("p", _hoisted_1316, [
                            _createElementVNode("span", _hoisted_1317, [
                              _createElementVNode("span", _hoisted_1318, [
                                _createTextVNode("全国道路施設点検データベース"),
                                _createElementVNode("span", _hoisted_1319, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_1320, [
                            _hoisted_1321,
                            _hoisted_1322,
                            _createElementVNode("span", _hoisted_1323, [
                              _createElementVNode("span", _hoisted_1324, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_1325, [
                        _createElementVNode("td", _hoisted_1326, [
                          _createElementVNode("p", _hoisted_1327, [
                            _createElementVNode("span", _hoisted_1328, [
                              _createElementVNode("span", _hoisted_1329, [
                                _createTextVNode("DRM"),
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_1330, [
                          _createElementVNode("p", _hoisted_1331, [
                            _hoisted_1332,
                            _createElementVNode("span", _hoisted_1333, [
                              _createElementVNode("span", _hoisted_1334, [
                                _createTextVNode("属性情報"),
                                _hoisted_1335,
                                _createTextVNode("日本デジタル道路地図協会"),
                                _createElementVNode("span", _hoisted_1336, [
                                  _createTextVNode(")"),
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_1337, [
                            _hoisted_1338,
                            _hoisted_1339,
                            _createElementVNode("span", _hoisted_1340, [
                              _createElementVNode("span", _hoisted_1341, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_1342, [
                        _createElementVNode("td", _hoisted_1343, [
                          _createElementVNode("p", _hoisted_1344, [
                            _createElementVNode("span", _hoisted_1345, [
                              _createElementVNode("span", _hoisted_1346, [
                                _createTextVNode("地理院地図"),
                                _createElementVNode("span", _hoisted_1347, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_1348, [
                          _createElementVNode("p", _hoisted_1349, [
                            _createElementVNode("span", _hoisted_1350, [
                              _createElementVNode("span", _hoisted_1351, [
                                _createTextVNode("地理院タイル"),
                                _hoisted_1352,
                                _createTextVNode("国土地理院"),
                                _createElementVNode("span", _hoisted_1353, [
                                  _createTextVNode(")"),
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_1354, [
                            _hoisted_1355,
                            _hoisted_1356,
                            _createElementVNode("span", _hoisted_1357, [
                              _createElementVNode("span", _hoisted_1358, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_1359, [
                        _createElementVNode("td", _hoisted_1360, [
                          _createElementVNode("p", _hoisted_1361, [
                            _createElementVNode("span", _hoisted_1362, [
                              _createElementVNode("span", _hoisted_1363, [
                                _createTextVNode("住所検索"),
                                _createElementVNode("span", _hoisted_1364, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_1365, [
                          _createElementVNode("p", _hoisted_1366, [
                            _hoisted_1367,
                            _createElementVNode("span", _hoisted_1368, [
                              _createElementVNode("span", _hoisted_1369, [
                                _createTextVNode("シンプルジオコーディング実験を利用 ※"),
                                _createElementVNode("span", _hoisted_1370, [
                                  _createTextVNode("1"),
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_1371, [
                            _hoisted_1372,
                            _hoisted_1373,
                            _createElementVNode("span", _hoisted_1374, [
                              _createElementVNode("span", _hoisted_1375, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_1376, [
                        _createElementVNode("td", _hoisted_1377, [
                          _createElementVNode("p", _hoisted_1378, [
                            _createElementVNode("span", _hoisted_1379, [
                              _createElementVNode("span", _hoisted_1380, [
                                _createTextVNode("特殊車両データ"),
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_1381, [
                          _createElementVNode("p", _hoisted_1382, [
                            _createElementVNode("span", _hoisted_1383, [
                              _createElementVNode("span", _hoisted_1384, [
                                _createTextVNode("特殊車両データ（国土交通省）"),
                                _createElementVNode("span", _hoisted_1385, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_1386, [
                        _createElementVNode("td", _hoisted_1387, [
                          _createElementVNode("p", _hoisted_1388, [
                            _createElementVNode("span", _hoisted_1389, [
                              _createElementVNode("span", _hoisted_1390, [
                                _createTextVNode("主要渋滞箇所"),
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_1391, [
                          _createElementVNode("p", _hoisted_1392, [
                            _hoisted_1393,
                            _createElementVNode("span", _hoisted_1394, [
                              _createElementVNode("span", _hoisted_1395, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_1396, [
                        _createElementVNode("td", _hoisted_1397, [
                          _createElementVNode("p", _hoisted_1398, [
                            _createElementVNode("span", _hoisted_1399, [
                              _createElementVNode("span", _hoisted_1400, [
                                _createTextVNode("ロードキル"),
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_1401, [
                          _createElementVNode("p", _hoisted_1402, [
                            _createElementVNode("span", _hoisted_1403, [
                              _createElementVNode("span", _hoisted_1404, [
                                _createTextVNode("ロードキル（国土交通省）"),
                                _createElementVNode("span", _hoisted_1405, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_1406, [
                            _createElementVNode("span", _hoisted_1407, [
                              _createElementVNode("span", _hoisted_1408, [
                                _createTextVNode("※希少種のロードキルデータの一部は、環境省やんばる自然保護官事務所から提供"),
                                _createElementVNode("span", _hoisted_1409, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_1410, [
                        _createElementVNode("td", _hoisted_1411, [
                          _createElementVNode("p", _hoisted_1412, [
                            _createElementVNode("span", _hoisted_1413, [
                              _createElementVNode("span", _hoisted_1414, [
                                _createTextVNode("交通事故統計情報"),
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_1415, [
                          _createElementVNode("p", _hoisted_1416, [
                            _hoisted_1417,
                            _createElementVNode("span", _hoisted_1418, [
                              _createElementVNode("span", _hoisted_1419, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_1420, [
                            _hoisted_1421,
                            _hoisted_1422,
                            _createElementVNode("span", _hoisted_1423, [
                              _createElementVNode("span", _hoisted_1424, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1425, [
                    _createElementVNode("span", _hoisted_1426, [
                      _createElementVNode("span", _hoisted_1427, [
                        _createTextVNode("※"),
                        _hoisted_1428,
                        _createElementVNode("span", _hoisted_1429, [
                          _createTextVNode("本実験の提供者については下記"),
                          _hoisted_1430,
                          _createTextVNode("より「本実験の参加規約」を確認ください。"),
                          _createElementVNode("span", _hoisted_1431, [
                            _createVNode(_component_o58p)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1432, [
                    _hoisted_1433,
                    _hoisted_1434,
                    _createElementVNode("span", _hoisted_1435, [
                      _createElementVNode("span", _hoisted_1436, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _hoisted_1437,
                  _createElementVNode("p", _hoisted_1438, [
                    _createElementVNode("span", _hoisted_1439, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("h2", _hoisted_1440, [
                    _hoisted_1441,
                    _hoisted_1442,
                    _hoisted_1443,
                    _hoisted_1444,
                    _createElementVNode("span", _hoisted_1445, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1446, [
                    _createElementVNode("span", _hoisted_1447, [
                      _createTextVNode("本ビューアにおいて提供しているコンテンツのうち、本規約と別の利用ルールを定めているコンテンツは以下のとおりです。本ビューアにおいてこれらのコンテンツを利用するにあたっては、本規約のほか当該利用ルールを遵守する必要があります。"),
                      _createElementVNode("span", _hoisted_1448, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1449, [
                    _createElementVNode("span", _hoisted_1450, [
                      _createTextVNode("（令８年３月時点）"),
                      _createElementVNode("span", _hoisted_1451, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _hoisted_1452,
                  _hoisted_1453,
                  _hoisted_1454,
                  _hoisted_1455,
                  _hoisted_1456,
                  _hoisted_1457,
                  _hoisted_1458,
                  _hoisted_1459,
                  _createElementVNode("table", _hoisted_1460, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", _hoisted_1461, [
                        _createElementVNode("td", _hoisted_1462, [
                          _createElementVNode("p", _hoisted_1463, [
                            _hoisted_1464,
                            _createElementVNode("span", _hoisted_1465, [
                              _createVNode(_component_o58p)
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_1466, [
                          _createElementVNode("p", _hoisted_1467, [
                            _hoisted_1468,
                            _createElementVNode("span", _hoisted_1469, [
                              _createVNode(_component_o58p)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_1470, [
                        _createElementVNode("td", _hoisted_1471, [
                          _createElementVNode("p", _hoisted_1472, [
                            _hoisted_1473,
                            _hoisted_1474,
                            _createElementVNode("span", _hoisted_1475, [
                              _createVNode(_component_o58p)
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_1476, [
                          _createElementVNode("p", _hoisted_1477, [
                            _createElementVNode("span", _hoisted_1478, [
                              _createTextVNode("参考：プローブ情報の利用及び取り扱いについて"),
                              _createElementVNode("span", _hoisted_1479, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_1480, [
                            _createElementVNode("span", _hoisted_1481, [
                              _createTextVNode("車載器の"),
                              _hoisted_1482,
                              _createTextVNode("付きプローブ情報の利用及び取り扱い方針"),
                              _createElementVNode("span", _hoisted_1483, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_1484, [
                            _hoisted_1485,
                            _createElementVNode("span", _hoisted_1486, [
                              _createVNode(_component_o58p)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_1487, [
                        _createElementVNode("td", _hoisted_1488, [
                          _createElementVNode("p", _hoisted_1489, [
                            _createElementVNode("a", _hoisted_1490, [
                              _createElementVNode("span", _hoisted_1491, [
                                _createTextVNode("道路施設点検データ"),
                                _createElementVNode("span", _hoisted_1492, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_1493, [
                            _hoisted_1494,
                            _createElementVNode("span", _hoisted_1495, [
                              _createElementVNode("span", _hoisted_1496, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_1497, [
                          _createElementVNode("p", _hoisted_1498, [
                            _hoisted_1499,
                            _createElementVNode("span", _hoisted_1500, [
                              _createElementVNode("span", _hoisted_1501, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_1502, [
                            _hoisted_1503,
                            _hoisted_1504,
                            _createElementVNode("span", _hoisted_1505, [
                              _createElementVNode("span", _hoisted_1506, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_1507, [
                        _createElementVNode("td", _hoisted_1508, [
                          _createElementVNode("p", _hoisted_1509, [
                            _hoisted_1510,
                            _createElementVNode("span", _hoisted_1511, [
                              _createElementVNode("span", _hoisted_1512, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_1513, [
                          _createElementVNode("p", _hoisted_1514, [
                            _createElementVNode("span", _hoisted_1515, [
                              _createElementVNode("span", _hoisted_1516, [
                                _createTextVNode("一部のコンテンツには、測量法により利用に制約がある場合があります。測量法により利用に制約があるコンテンツかどうかは、下記サイトを参照してください。"),
                                _createElementVNode("span", _hoisted_1517, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_1518, [
                            _createElementVNode("span", _hoisted_1519, [
                              _createElementVNode("span", _hoisted_1520, [
                                _createTextVNode("※測量法により利用に制約がある一部コンテンツの例：背景地図（標準地図・淡色地図）"),
                                _createElementVNode("span", _hoisted_1521, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_1522, [
                            _hoisted_1523,
                            _hoisted_1524,
                            _hoisted_1525,
                            _createElementVNode("span", _hoisted_1526, [
                              _createElementVNode("span", _hoisted_1527, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_1528, [
                        _createElementVNode("td", _hoisted_1529, [
                          _createElementVNode("p", _hoisted_1530, [
                            _createElementVNode("span", _hoisted_1531, [
                              _createElementVNode("span", _hoisted_1532, [
                                _createTextVNode("住所検索"),
                                _createElementVNode("span", _hoisted_1533, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_1534, [
                            _hoisted_1535,
                            _createElementVNode("span", _hoisted_1536, [
                              _createElementVNode("span", _hoisted_1537, [
                                _createTextVNode("シンプルジオコーディング実験"),
                                _createElementVNode("span", _hoisted_1538, [
                                  _createTextVNode(")"),
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_1539, [
                          _createElementVNode("p", _hoisted_1540, [
                            _createElementVNode("span", _hoisted_1541, [
                              _createElementVNode("span", _hoisted_1542, [
                                _createTextVNode("シンプル ジオコーディング 実験 参加規約"),
                                _createElementVNode("span", _hoisted_1543, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_1544, [
                            _hoisted_1545,
                            _hoisted_1546,
                            _hoisted_1547,
                            _createElementVNode("span", _hoisted_1548, [
                              _createElementVNode("span", _hoisted_1549, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_1550, [
                        _createElementVNode("td", _hoisted_1551, [
                          _createElementVNode("p", _hoisted_1552, [
                            _createElementVNode("span", _hoisted_1553, [
                              _createElementVNode("span", _hoisted_1554, [
                                _createTextVNode("その他限定公開のデータ"),
                                _createElementVNode("span", _hoisted_1555, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_1556, [
                          _createElementVNode("p", _hoisted_1557, [
                            _createElementVNode("span", _hoisted_1558, [
                              _createElementVNode("span", _hoisted_1559, [
                                _createTextVNode("（限定公開の対象は限定公開対象者に別途お知らせします）"),
                                _createElementVNode("span", _hoisted_1560, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1561, [
                    _createElementVNode("span", _hoisted_1562, [
                      _createElementVNode("a", _hoisted_1563, [
                        _createElementVNode("span", _hoisted_1564, [
                          _createVNode(_component_o58p, null, {
                            default: _withCtx(() => [
                              _createTextVNode(" ")
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_1565,
                  _createElementVNode("h2", _hoisted_1566, [
                    _hoisted_1567,
                    _hoisted_1568,
                    _hoisted_1569,
                    _hoisted_1570,
                    _hoisted_1571,
                    _createElementVNode("span", _hoisted_1572, [
                      _createElementVNode("span", _hoisted_1573, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1574, [
                    _createElementVNode("span", _hoisted_1575, [
                      _createElementVNode("span", _hoisted_1576, [
                        _createTextVNode("本ビューアにおいて提供しているコンテンツのうち、"),
                        _hoisted_1577,
                        _createTextVNode("例を以下に示します。"),
                        _createElementVNode("span", _hoisted_1578, [
                          _createVNode(_component_o58p)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1579, [
                    _createElementVNode("span", _hoisted_1580, [
                      _createElementVNode("span", _hoisted_1581, [
                        _createTextVNode("（令和８年３月時点）"),
                        _createElementVNode("span", _hoisted_1582, [
                          _createVNode(_component_o58p)
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_1583,
                  _hoisted_1584,
                  _hoisted_1585,
                  _hoisted_1586,
                  _hoisted_1587,
                  _hoisted_1588,
                  _createElementVNode("table", _hoisted_1589, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", _hoisted_1590, [
                        _createElementVNode("td", _hoisted_1591, [
                          _createElementVNode("p", _hoisted_1592, [
                            _hoisted_1593,
                            _createElementVNode("span", _hoisted_1594, [
                              _createElementVNode("span", _hoisted_1595, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_1596, [
                          _createElementVNode("p", _hoisted_1597, [
                            _createElementVNode("span", _hoisted_1598, [
                              _createElementVNode("span", _hoisted_1599, [
                                _createTextVNode("表示・示唆している例"),
                                _createElementVNode("span", _hoisted_1600, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_1601, [
                        _createElementVNode("td", _hoisted_1602, [
                          _createElementVNode("p", _hoisted_1603, [
                            _createElementVNode("span", _hoisted_1604, [
                              _createElementVNode("span", _hoisted_1605, [
                                _createTextVNode("道路施設点検データ"),
                                _createElementVNode("span", _hoisted_1606, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_1607, [
                            _hoisted_1608,
                            _createElementVNode("span", _hoisted_1609, [
                              _createElementVNode("span", _hoisted_1610, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_1611, [
                          _createElementVNode("p", _hoisted_1612, [
                            _hoisted_1613,
                            _createElementVNode("span", _hoisted_1614, [
                              _createElementVNode("span", _hoisted_1615, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_1616, [
                            _hoisted_1617,
                            _hoisted_1618,
                            _createElementVNode("span", _hoisted_1619, [
                              _createElementVNode("span", _hoisted_1620, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_1621, [
                        _createElementVNode("td", _hoisted_1622, [
                          _createElementVNode("p", _hoisted_1623, [
                            _createElementVNode("span", _hoisted_1624, [
                              _createElementVNode("span", _hoisted_1625, [
                                _createTextVNode("交通事故統計情報"),
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_1626, [
                          _createElementVNode("p", _hoisted_1627, [
                            _createElementVNode("span", _hoisted_1628, [
                              _createElementVNode("span", _hoisted_1629, [
                                _createTextVNode("参考：警察庁ウェブサイトのコンテンツの利用について"),
                                _createElementVNode("span", _hoisted_1630, [
                                  _createVNode(_component_o58p)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_1631, [
                            _createElementVNode("span", _hoisted_1632, [
                              _createElementVNode("span", _hoisted_1633, [
                                _createTextVNode("https://www.npa.go.jp/rules/index.html"),
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_1634,
                  _createElementVNode("p", _hoisted_1635, [
                    _createElementVNode("span", _hoisted_1636, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("h2", _hoisted_1637, [
                    _hoisted_1638,
                    _hoisted_1639,
                    _hoisted_1640,
                    _hoisted_1641,
                    _hoisted_1642,
                    _hoisted_1643,
                    _createElementVNode("span", _hoisted_1644, [
                      _createVNode(_component_o58p)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1645, [
                    _createElementVNode("span", _hoisted_1646, [
                      _createTextVNode("本ビューアにおいて提供しているコンテンツのうち、外部データベース等との"),
                      _hoisted_1647,
                      _createTextVNode("連携等により取得しているものは以下のとおりです。"),
                      _createElementVNode("span", _hoisted_1648, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1649, [
                    _createElementVNode("span", _hoisted_1650, [
                      _createTextVNode("（令和８年３月時点）"),
                      _createElementVNode("span", _hoisted_1651, [
                        _createVNode(_component_o58p)
                      ])
                    ])
                  ]),
                  _createElementVNode("table", _hoisted_1652, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", _hoisted_1653, [
                        _createElementVNode("td", _hoisted_1654, [
                          _createElementVNode("p", _hoisted_1655, [
                            _hoisted_1656,
                            _createElementVNode("span", _hoisted_1657, [
                              _createVNode(_component_o58p)
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_1658, [
                          _createElementVNode("p", _hoisted_1659, [
                            _hoisted_1660,
                            _createElementVNode("span", _hoisted_1661, [
                              _createVNode(_component_o58p)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_1662, [
                        _createElementVNode("td", _hoisted_1663, [
                          _createElementVNode("p", _hoisted_1664, [
                            _hoisted_1665,
                            _createElementVNode("span", _hoisted_1666, [
                              _createVNode(_component_o58p)
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_1667, [
                          _createElementVNode("p", _hoisted_1668, [
                            _createElementVNode("span", _hoisted_1669, [
                              _createTextVNode("『国土交通省交通量"),
                              _hoisted_1670,
                              _createTextVNode("』ガイダンスサイト"),
                              _hoisted_1671,
                              _createTextVNode("日本道路交通情報センター"),
                              _createElementVNode("span", _hoisted_1672, [
                                _createTextVNode(")"),
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_1673, [
                            _hoisted_1674,
                            _createElementVNode("span", _hoisted_1675, [
                              _createVNode(_component_o58p)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_1676, [
                        _createElementVNode("td", _hoisted_1677, [
                          _createElementVNode("p", _hoisted_1678, [
                            _createElementVNode("span", _hoisted_1679, [
                              _createTextVNode("道路施設点検データ"),
                              _createElementVNode("span", _hoisted_1680, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_1681, [
                            _hoisted_1682,
                            _createElementVNode("span", _hoisted_1683, [
                              _createVNode(_component_o58p)
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_1684, [
                          _createElementVNode("p", _hoisted_1685, [
                            _createElementVNode("span", _hoisted_1686, [
                              _createTextVNode("全国道路施設点検データベース"),
                              _createElementVNode("span", _hoisted_1687, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_1688, [
                            _hoisted_1689,
                            _createElementVNode("span", _hoisted_1690, [
                              _createVNode(_component_o58p)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_1691, [
                        _createElementVNode("td", _hoisted_1692, [
                          _createElementVNode("p", _hoisted_1693, [
                            _createElementVNode("span", _hoisted_1694, [
                              _createTextVNode("DRM"),
                              _createVNode(_component_o58p)
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_1695, [
                          _createElementVNode("p", _hoisted_1696, [
                            _hoisted_1697,
                            _createElementVNode("span", _hoisted_1698, [
                              _createTextVNode("属性情報"),
                              _hoisted_1699,
                              _createTextVNode("日本デジタル道路地図協会"),
                              _createElementVNode("span", _hoisted_1700, [
                                _createTextVNode(")"),
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_1701, [
                            _hoisted_1702,
                            _createElementVNode("span", _hoisted_1703, [
                              _createVNode(_component_o58p)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_1704, [
                        _createElementVNode("td", _hoisted_1705, [
                          _createElementVNode("p", _hoisted_1706, [
                            _hoisted_1707,
                            _createElementVNode("span", _hoisted_1708, [
                              _createVNode(_component_o58p)
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_1709, [
                          _createElementVNode("p", _hoisted_1710, [
                            _createElementVNode("span", _hoisted_1711, [
                              _createTextVNode("地理院タイル"),
                              _hoisted_1712,
                              _createTextVNode("国土地理院"),
                              _createElementVNode("span", _hoisted_1713, [
                                _createTextVNode(")"),
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_1714, [
                            _hoisted_1715,
                            _createElementVNode("span", _hoisted_1716, [
                              _createVNode(_component_o58p)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", _hoisted_1717, [
                        _createElementVNode("td", _hoisted_1718, [
                          _createElementVNode("p", _hoisted_1719, [
                            _createElementVNode("span", _hoisted_1720, [
                              _createTextVNode("住所検索"),
                              _createElementVNode("span", _hoisted_1721, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_1722, [
                          _createElementVNode("p", _hoisted_1723, [
                            _hoisted_1724,
                            _createElementVNode("span", _hoisted_1725, [
                              _createTextVNode("シンプルジオコーディング実験を利用"),
                              _createElementVNode("span", _hoisted_1726, [
                                _createVNode(_component_o58p)
                              ])
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_1727, [
                            _hoisted_1728,
                            _createElementVNode("span", _hoisted_1729, [
                              _createVNode(_component_o58p)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_1730, [
                    _createElementVNode("span", _hoisted_1731, [
                      _createVNode(_component_o58p, null, {
                        default: _withCtx(() => [
                          _createTextVNode(" ")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_1732, [
          _createElementVNode("div", _hoisted_1733, [
            _createVNode(_unref(ButtonItem), {
              class: "confirm-button",
              onClick: confirm
            }, {
              default: _withCtx(() => [
                _createTextVNode("同意する")
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_1734, [
          _createTextVNode(" 同意いただけない場合は、"),
          _createElementVNode("a", { href: _unref(portalUrl) }, "ポータルサイト", 8, _hoisted_1735),
          _createTextVNode("をご利用ください。 ")
        ])
      ]),
      _: 1
    }, 8, ["title", "style"])
  ], 64))
}
}

})